<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-12">
				<div class="d-flex align-items-center justify-content-between">
					<div>
						<h4 class="mb-1">{{ title }}</h4>
						<small class="text-muted">{{ desc1 }}</small>
					</div>
					<div class="d-flex align-items-center">
						<b-button
							:variant="todayCollectionStatus.isCollected ? 'success' : 'danger'"
							class="mr-2 px-4 py-2"
							@click="collectRocketSales"
							:title="todayCollectionStatus.tooltip">
							<i class="fas fa-download mr-1"></i>
							{{ todayCollectionStatus.buttonText }}
						</b-button>
						<b-button
							variant="outline-info"
							size="sm"
							class="mr-2 d-none"
							@click="collectCustomDateRange"
							title="원하는 날짜 범위를 지정하여 데이터를 수집합니다">
							<i class="fas fa-calendar-alt mr-1"></i>
							날짜 지정 수집
						</b-button>
						<!-- <div class="custom-control custom-switch custom-control-inline ml-3" style="font-size: 0.85rem;">
							<input type="checkbox" class="custom-control-input" id="rocketCoupassSyncSwitch"
								:checked="coupassSyncEnabled" @click="handleCoupassSyncClick" ref="coupassSyncSwitch">
							<label class="custom-control-label" for="rocketCoupassSyncSwitch">쿠패스연동</label>
						</div> -->
					</div>
				</div>
			</div>
			<div class="col-lg-12">
				<img v-if="showspinner" style="max-width:100%;"
					:src="require('../../../assets/images/small/spinner.gif')">
				<div v-if="showspinner1" class="d-flex justify-content-center">
					<div><img style="max-width:10%;" :src="require('../../../assets/images/small/loading.gif')">{{
						loadingtext }}</div>
				</div>
			</div>
		</div>


		<div class="row mt-0">
			<div class="col-lg-12" v-if="showlist">
				<div class="row d-flex justify-content-between">
					<div class="d-flex flex-column">
						<div>
							<b-button variant="outline-primary" size="sm" class="ml-3 mb-1 mr-1" @click="showAll">
								전체<b-badge variant="primary" class="ml-1">{{ totalCnt }}</b-badge>
							</b-button>
							<b-button variant="outline-secondary" size="sm" class="mb-1 mr-1" @click="showNeedPo">
								구매 필요<b-badge variant="secondary" class="ml-1">{{ needPo }}</b-badge>
							</b-button>
							<b-button variant="outline-danger" size="sm" class="mb-1 mr-1" @click="showNeedOverseasOutbound">
								배대지출고 필요<b-badge variant="danger" class="ml-1">{{ needOverseasOutbound }}</b-badge>
							</b-button>
							<b-button variant="outline-secondary" size="sm" class="mb-1 mr-1" @click="showNeedDomesticOutbound">
								국내출고 필요<b-badge variant="secondary" class="ml-1">{{ needDomesticOutbound }}</b-badge>
							</b-button>
							<b-button variant="outline-danger" size="sm" class="mb-1 mr-1" @click="showStockDanger">
								품절예고<b-badge variant="danger" class="ml-1">{{ stockDangerCnt }}</b-badge>
							</b-button>
							<b-button variant="outline-secondary" size="sm" class="mb-1 mr-1" @click="showOverStock">
								과재고위험<b-badge variant="secondary" class="ml-1">{{ overStockCnt }}</b-badge>
							</b-button>
							<b-button variant="outline-success" size="sm" class="mb-1 mr-1" @click="showMonthlyCntOver0">
								월판매0이상<b-badge variant="success" class="ml-1">{{ monthlyCntOver0 }}</b-badge>
							</b-button>
							<!-- <b-button variant="outline-danger" class="mb-1 mr-2" @click="showNeedReturn">
							반출 필요<b-badge variant="danger" class="ml-2">{{needReturn}}</b-badge>
							</b-button>  -->
							<b-button variant="outline-warning" size="sm" class="mb-1 mr-1" @click="showReturn">
								반품제품<b-badge variant="warning" class="ml-1">{{ returnProducts }}</b-badge>
							</b-button>
							<b-button variant="outline-danger" size="sm" class="mb-1 mr-1" @click="showHidden">
								숨김상품<b-badge variant="danger" class="ml-1">{{ hiddenProducts }}</b-badge>
							</b-button>
						</div>
						<div>
							<div class="custom-control custom-switch custom-control-inline ml-3" style="font-size: 0.85rem;">
								<input type="checkbox" class="custom-control-input" id="salesTrendSwitch"
									v-model="showSalesTrend">
								<label class="custom-control-label" for="salesTrendSwitch">판매트렌드</label>
							</div>
							<div class="custom-control custom-switch custom-control-inline ml-1" style="font-size: 0.85rem;">
								<input type="checkbox" class="custom-control-input" id="customSwitchsss"
									v-model="showReturnProducts">
								<label class="custom-control-label" for="customSwitchsss">반품상품보기</label>
							</div>
							<div class="custom-control custom-switch custom-control-inline ml-1" style="font-size: 0.85rem;">
								<input type="checkbox" class="custom-control-input" id="bundleDisplaySwitch"
									v-model="showBundleProducts">
								<label class="custom-control-label" for="bundleDisplaySwitch">번들보기</label>
							</div>
							<div class="custom-control custom-switch custom-control-inline ml-1" style="font-size: 0.85rem;">
								<input type="checkbox" class="custom-control-input" id="stockDisplaySwitch"
									v-model="showStockPeriodFirst">
								<label class="custom-control-label" for="stockDisplaySwitch">재고기간보기</label>
							</div>
							<div class="custom-control custom-switch custom-control-inline ml-1" style="font-size: 0.85rem;">
								<input type="checkbox" class="custom-control-input" id="stockAmountSwitch"
									v-model="showStockAmount">
								<label class="custom-control-label" for="stockAmountSwitch">재고금액보기</label>
							</div>
							<div v-if="showStockAmount" class="ml-2 d-inline-flex align-items-center" style="font-size: 0.85rem;">
								<span class="text-primary font-weight-bold">
									전체 재고금액: {{ getTotalStockAmount().toLocaleString() }}원
								</span>
							</div>
						</div>
					</div>
					<div>
						<!-- 첫 번째 행: 저장, 숨김, 순서, 일괄변경 -->
						<div class="mb-2">
							<button type="button" class="btn btn-primary btn-sm mr-1 ml-3" @click="saveSales">저장</button>
							<button type="button" class="btn btn-secondary btn-sm mr-1" @click="hideSelectedItems" v-if="!isShowingHidden">
								숨김
							</button>
							<button type="button" class="btn btn-success btn-sm mr-1" @click="restoreSelectedItems" v-if="isShowingHidden">
								복원
							</button>
							<button type="button" class="btn btn-primary btn-sm mr-1" @click="showOrderModal = true" v-if="!isShowingHidden">
								순서
							</button>
							<button type="button" class="btn btn-danger btn-sm mr-1" v-b-toggle.my-collapse>일괄변경</button>

							<button type="button" class="btn btn-secondary btn-sm mr-1 position-relative" v-b-modal.reqpurchase id="purchaseRequestBtn">
								구매요청
								<span v-if="purchaseCart.length > 0" class="badge badge-danger position-absolute"
									style="top: -8px; right: -8px; font-size: 0.7em;">
									{{ purchaseCart.length }}
								</span>
							</button>
							<button type="button" class="btn btn-success btn-sm mr-1" v-b-modal.excelupload>엑셀업로드</button>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-12 d-flex justify-content-end">
				<b-collapse id="my-collapse">
					<b-card title="">
						<div class="form-group">
							<input type="number" class="form-control" placeholder="입고기간" v-model="입고기간">
						</div>
						<div class="form-group">
							<input type="number" class="form-control" placeholder="배대지입고기간" v-model="배대지입고기간">
						</div>
						<div class="form-group">
							<input type="number" class="form-control" placeholder="통관중입고기간" v-model="통관중입고기간">
						</div>
						<div class="form-group">
							<input type="number" class="form-control" placeholder="국내입고기간" v-model="국내입고기간">
						</div>
						<div class="form-group">
							<input type="number" class="form-control" placeholder="안전재고기간" v-model="최소재고기간">
						</div>
						<div class="form-group">
							<input type="number" class="form-control" placeholder="목표재고기간" v-model="최대재고기간">
						</div>
						<div class="form-group">
							<input type="number" class="form-control" placeholder="MOQ수량" v-model="MOQ수량">
						</div>
						<button type="button" class="btn btn-success mr-2 mt-1" @click="editlists">적용</button>
					</b-card>
				</b-collapse>
			</div>


			<div class="col-lg-12 mt-0" v-if="showlist">
				<CDataTable
					storage-key="rocketScm.1" :key="`${showReturnProducts}-${showBundleProducts}-${showStockAmount}-${showSalesTrend}`" :headers="headers" :items="saleslists" v-model="tableSelectedItem" :show-select="true"
					:fixedColumns="'옵션명'" itemKey="vendorItemId" style="margin-bottom: 10px" :items-per-page="100" :height="'750px'"
					:subheader="subheaderData" :headerTooltips="headerTooltips">
					<template v-slot:상품등급="{ item }">
						<div><a :href="'https://www.coupang.com/vp/products/' + item.productId + '?vendorItemId=' + item.vendorItemId"
								target="_blank"><b-badge variant="success">새제품</b-badge></a></div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="i">
								<a :href="'https://www.coupang.com/vp/products/' + a.listingDetails.productId + '?vendorItemId=' + a.listingDetails.vendorItemId"
									target="_blank">
									<b-badge variant="secondary">
										{{ a.skuGrade == 'PACKAGE_DAMAGED' ? '반품-미개봉' :
											a.skuGrade == 'RETURN_BEST' ? '반품-최상' :
												a.skuGrade == 'RETURN_GOOD' ? '반품-상' : '반품-중'
										}}
									</b-badge>
								</a>
							</div>
						</div>
					</template>
					<template v-slot:상품구분="{ item }">
						<div>
							<a :href="'https://www.coupang.com/vp/products/' + item.productId + '?vendorItemId=' + item.vendorItemId"
								target="_blank">
								<b-badge variant="success">새제품</b-badge>
							</a>
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="i" class="mt-1">
								<a :href="'https://www.coupang.com/vp/products/' + a.productId + '?vendorItemId=' + a.vendorItemId"
									target="_blank">
									<b-badge variant="secondary">
										{{ a.skuGrade == 'PACKAGE_DAMAGED' ? '반품-미개봉' :
											a.skuGrade == 'RETURN_BEST' ? '반품-최상' :
												a.skuGrade == 'RETURN_GOOD' ? '반품-상' : '반품-중'
										}}
									</b-badge>
								</a>
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i" class="mt-1">
								<a :href="'https://www.coupang.com/vp/products/' + item.productId + '?vendorItemId=' + a.vendorItemId"
									target="_blank">
									<b-badge variant="info">번들x{{ a.upBundlingSize || 1 }}</b-badge>
								</a>
							</div>
						</div>
					</template>
					<template v-slot:썸네일="{ item }">
						<a :href="'https://www.coupang.com/vp/products/' + item.productId + '?vendorItemId=' + item.vendorItemId"
							target="_blank">
							<img :src="item.썸네일" class="img-fluid rounded avatar-40 mr-3" alt="image">
						</a>
					</template>
					<template v-slot:판매상품명="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId" style="max-width: 150px;">
							<div class="product-name-multiline font-weight-bold" :title="item.판매상품명">
								{{ item.판매상품명 }}
							</div>
							<small class="text-muted" :title="item.productId">
								{{ item.productId }}
							</small>
							<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
								<div v-for="a, i in item.upBundlingProducts" :key="'bundle-product-' + i" class="mt-1">
									<div class="product-name-multiline text-primary" :title="a.판매상품명">{{ a.판매상품명 }}</div>
									<small class="text-muted" :title="a.productId">{{ a.productId }}</small>
								</div>
							</div>
						</div>
					</template>
					<template v-slot:옵션명="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId" style="max-width: 100px;font-size:90%">
							<div class="option-name-wrap" :title="item.옵션명">
								{{ item.옵션명 }}
							</div>
							<small class="text-muted" :title="item.vendorItemId">
								{{ item.vendorItemId }}
							</small>
							<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
								<div v-for="a, i in item.returnProducts" :key="i" class="mt-1">
									<small class="text-muted" :title="a.vendorItemId">{{ a.vendorItemId }}</small>
								</div>
							</div>
							<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
								<div v-for="a, i in item.upBundlingProducts" :key="'bundle-option-' + i" class="mt-1">
									<div class="option-name-wrap text-primary" :title="a.옵션명">{{ a.옵션명 }}</div>
									<small class="text-muted" :title="a.vendorItemId">{{ a.vendorItemId }}</small>
								</div>
							</div>
						</div>
					</template>
					<template v-slot:구매필요수량="{ item }">
						<div
							:class="['purchase-outbound-cell', { 'purchase-requested': hasPurchaseRequest(item) }]"
							@click="openPurchaseRequestModal(item)"
							style="cursor: pointer;">
							<div>{{ item.구매필요수량 === 0 ? '-' : item.구매필요수량 }}</div>
							<div v-if="hasPurchaseRequest(item)" class="stock-period-text text-primary font-weight-bold">
								{{ getPurchaseRequestQuantity(item) }}
							</div>
							<!-- <div v-else-if="item.박스인입수량 > 1" class="stock-period-text">
								{{ item.박스인입수량 }}
							</div> -->
						</div>
						<b-modal :id="'poQty' + item.vendorItemId" scrollable title="판매현황" ok-title="OK" size="xl"
							modal-class="scm-detail-modal" @show="onPoQtyModalShow(item)" ok-only
							@ok="closeModal($event, item)">
							<div class="row h-100">
								<div class="col-md-12">
									<card style="padding:10px;">
										<div class="d-flex align-items-center" style="margin:auto;padding:0px">
											<img :src="item.썸네일" class="img-fluid rounded avatar-120 mr-3" alt="image">
											<div>
												<p>판매상품명 : {{ item.판매상품명 }}</p>
												<p>노출ID : {{ item.productId }}</p>
												<p>옵션ID : {{ item.vendorItemId }}</p>
											</div>
										</div>
									</card>
								</div>
								<div class="col-md-8 h-100">
									<b-card no-body>
										<b-card-body class="p-3"> <!-- padding을 제거합니다 -->
											<div style="width: 100%; height:100%"> <!-- 100% 너비의 div로 감쌉니다 -->
												<ApexChart ref="mainChart" element="layout1-chart-5"
													:chartOption="getUpdatedChartOption(item)" />
											</div>
										</b-card-body>
										<b-card-footer>
											<div class="d-flex justify-content-between align-items-center row">
												<div class="col-6 d-flex justify-content-start align-items-center">
													<label class="w-50">판매인식기간:</label>
													<b-form-input class="w-50" type="date" v-model="item.startDate"
														@change="updateDateRange(item)"></b-form-input>
													<h5> ~ </h5>
													<b-form-input class="w-50" type="date" v-model="item.endDate"
														@change="updateDateRange(item)"></b-form-input>
												</div>
												<div class="col-4 d-flex justify-content-start align-items-center">
													<b-button variant="outline-primary" size="md"
														@click="setDateRange(item, 7)">최근 7일</b-button>
													<b-button variant="outline-primary" size="md"
														@click="setDateRange(item, 15)" class="ml-2">최근 15일</b-button>
												</div>
											</div>
										</b-card-footer>
									</b-card>

									<!-- 판매량 전용 차트 (메인 제품에만 표시) -->
									<b-card no-body class="mt-3" v-if="item.salesHistory && item.dates && !item.skuGrade">
										<b-card-header class="p-2">
											<h6 class="mb-0">판매량 상세 분석 (메인/번들/반품 구분)</h6>
										</b-card-header>
										<b-card-body class="p-3">
											<div style="width: 100%; height: 100%;" v-if="salesChartReady">
												<ApexChart ref="salesChart" :element="`sales-chart-${item.vendorItemId}`"
													:key="`sales-chart-${item.vendorItemId}`"
													:chartOption="getSalesChartOption(item)" />
											</div>
											<div v-else class="text-center p-4">
												<div class="spinner-border text-primary" role="status">
													<span class="sr-only">Loading...</span>
												</div>
												<p class="mt-2">차트 로딩 중...</p>
											</div>
										</b-card-body>
									</b-card>
								</div>
								<div class="col-md-4 h-100">
									<b-card>
										<b-list-group flush>
											<!-- 판매 정보 -->
											<b-list-group-item class="p-2">
												<div class="d-flex justify-content-between">
													<div class="font-weight-bold text-primary">판매 정보</div>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1 border-bottom">
												<div class="d-flex justify-content-between align-items-center">
													<span>일평균판매량</span>
													<span class="font-weight-bold">{{ item.일판매수량.toFixed(1) }}</span>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1 border-bottom">
												<div class="d-flex justify-content-between align-items-center">
													<span>현재재고수량</span>
													<span class="font-weight-bold">{{ item.재고 }}</span>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1">
												<div class="d-flex justify-content-between align-items-center">
													<span>남은 재고기간</span>
													<span class="font-weight-bold">{{ item.남은재고기간 }}</span>
												</div>
											</b-list-group-item>

											<!-- 예측 정보 -->
											<b-list-group-item class="p-2 mt-2">
												<div class="d-flex justify-content-between">
													<div class="font-weight-bold text-primary">예측 정보</div>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1 border-bottom">
												<div class="d-flex justify-content-between align-items-center">
													<span>향후 30일 예상 판매수량(series)</span>
													<span class="font-weight-bold">{{ parseInt(item.forecastSeriesQty)
													}}</span>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1">
												<div class="d-flex justify-content-between align-items-center">
													<span>향후 30일 예상 판매수량(AI)</span>
													<span class="font-weight-bold">{{ parseInt(item.forecastAIQty)
													}}</span>
												</div>
											</b-list-group-item>

											<!-- Series 기준 구매 정보 -->
											<b-list-group-item class="p-2 mt-2">
												<div class="d-flex justify-content-between">
													<div class="font-weight-bold text-primary">구매 정보 (최근 30일 판매량 기준)
													</div>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1 border-bottom">
												<div class="d-flex justify-content-between align-items-center">
													<span>D-Day</span>
													<span class="font-weight-bold">{{ item.dday }}</span>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1 border-bottom">
												<div class="d-flex justify-content-between align-items-center">
													<span>구매필요수량</span>
													<span class="font-weight-bold">{{ item.구매필요수량 }}</span>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1">
												<div class="d-flex justify-content-between align-items-center">
													<span>필요재고 일수</span>
													<span class="font-weight-bold">{{ calculateNeededStockDays(item)
													}}</span>
												</div>
											</b-list-group-item>

											<!-- 판매인식기간 기반 구매 정보 추가 (기존 AI 기준 구매 정보 부분 대체) -->
											<b-list-group-item class="p-2 mt-2" v-if="item.customPeriodMetrics">
												<div class="d-flex justify-content-between">
													<div class="font-weight-bold text-secondary">선택 기간 기준 구매 정보</div>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1 border-bottom"
												v-if="item.customPeriodMetrics">
												<div class="d-flex justify-content-between align-items-center">
													<span>D-Day (선택 기간)</span>
													<span class="font-weight-bold">{{ item.customPeriodMetrics.dday
													}}</span>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1 border-bottom"
												v-if="item.customPeriodMetrics">
												<div class="d-flex justify-content-between align-items-center">
													<span>구매필요수량 (선택 기간)</span>
													<span class="font-weight-bold">{{ item.customPeriodMetrics.구매필요수량
													}}</span>
												</div>
											</b-list-group-item>
											<b-list-group-item class="p-1" v-if="item.customPeriodMetrics">
												<div class="d-flex justify-content-between align-items-center">
													<span>필요재고 일수 (선택 기간)</span>
													<span class="font-weight-bold">{{
														item.customPeriodMetrics.neededStockDays }}</span>
												</div>
											</b-list-group-item>

											<!-- 구매 기준 설명 -->
											<b-list-group-item class="p-1 mt-2">
												<small class="text-secondary">
													※ 재고 기준:
													<br>- 안전재고(7일) 이하 → 20일치 주문
													<br>- 7~27일 사이 → 부족분 주문
													<br>- 27일 이상 → 주문 없음
												</small>
											</b-list-group-item>
										</b-list-group>
									</b-card>
								</div>
							</div>
						</b-modal>
					</template>
					<template v-slot:구매="{ item }">
						<div @click="showInventoryModal(item)"
							class="inventory-box-vertical bg-light border text-dark position-relative"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.구매, item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.구매, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.구매 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.구매 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.구매 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.구매, item.일판매수량, item) }}</div>
							<span v-if="coupassSyncEnabled && item.구매 > 0" class="coupass-detail-icon"
								@click.stop="openReqpurchaseDetailModal(item)"
								title="구매요청 상세보기">🔍</span>
						</div>
					</template>
					<template v-slot:배대지="{ item }">
						<div @click="showInventoryModal(item)"
							class="inventory-box-vertical bg-light border text-dark position-relative"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.배대지, item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.배대지, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.배대지 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.배대지 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.배대지 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.배대지, item.일판매수량, item) }}</div>
							<span v-if="coupassSyncEnabled && item.배대지 > 0" class="coupass-detail-icon"
								@click.stop="openReqpurchaseDetailModal(item)"
								title="구매요청 상세보기">🔍</span>
						</div>
					</template>
					<template v-slot:통관중="{ item }">
						<div @click="showInventoryModal(item)"
							class="inventory-box-vertical bg-light border text-dark position-relative"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.통관중, item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.통관중, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.통관중 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.통관중 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.통관중 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.통관중, item.일판매수량, item) }}</div>
							<span v-if="coupassSyncEnabled && item.통관중 > 0" class="coupass-detail-icon"
								@click.stop="openReqpurchaseDetailModal(item)"
								title="구매요청 상세보기">🔍</span>
						</div>
					</template>
					<template v-slot:장기입고중="{ item }">
						<div @click="showInventoryModal(item)"
							class="inventory-box-vertical bg-light border text-dark"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.장기입고중, item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.장기입고중, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.장기입고중 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.장기입고중 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.장기입고중 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.장기입고중, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:단기입고중="{ item }">
						<div @click="showInventoryModal(item)"
							class="inventory-box-vertical bg-light border text-dark"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.단기입고중, item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.단기입고중, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.단기입고중 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.단기입고중 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.단기입고중 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.단기입고중, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:국내재고="{ item }">
						<div @click="showInventoryModal(item)"
							class="inventory-box-vertical bg-light border text-dark"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.국내재고, item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.국내재고, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.국내재고 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.국내재고 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.국내재고 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.국내재고, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:입고기간="{ item }">
						<input type="number" class="form-control ml-1 text-center" placeholder="입고기간"
							v-model="item.입고기간" @keyup.enter="changePoEnter($event, item)" @input="onInputChange(item)"
							@blur="onInputComplete(item)">
					</template>
					<template v-slot:배대지입고기간="{ item }">
						<input type="number" class="form-control ml-1 text-center" placeholder="배대지입고기간"
							v-model="item.배대지입고기간" @keyup.enter="changePoEnter($event, item)" @input="onInputChange(item)"
							@blur="onInputComplete(item)">
					</template>
					<template v-slot:국내입고기간="{ item }">
						<input type="number" class="form-control ml-1 text-center" placeholder="국내입고기간"
							v-model="item.국내입고기간" @keyup.enter="changePoEnter($event, item)" @input="onInputChange(item)"
							@blur="onInputComplete(item)">
					</template>
					<template v-slot:최대재고기간="{ item }">
						<input type="number" class="form-control ml-1 text-center" placeholder="최대재고기간"
							v-model="item.최대재고기간" @keyup.enter="changePoEnter($event, item)"
							@input="onInputChange(item)" @blur="onInputComplete(item)">
					</template>
					<template v-slot:최소재고기간="{ item }">
						<input type="number" class="form-control ml-1 text-center" placeholder="최소재고기간"
							v-model="item.최소재고기간" @keyup.enter="changePoEnter($event, item)"
							@input="onInputChange(item)" @blur="onInputComplete(item)">
					</template>
					<template v-slot:MOQ수량="{ item }">
						<input type="number" class="form-control ml-1 text-center" placeholder="MOQ수량"
							v-model="item.MOQ수량" @keyup.enter="changePoEnter($event, item)"
							@input="onInputChange(item)" @blur="onInputComplete(item)">
					</template>
					<template v-slot:재고="{ item }">
						<div @click="showInventoryModal(item)"
							:class="getCoupangStockBoxClass(item)"
							:title="getCoupangStockDangerTooltip(item)"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.재고, item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.재고, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.재고 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.재고 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.재고 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.재고, item.일판매수량, item) }}</div>
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-stock-' + i">{{ a.orderableQuantity || 0 }}</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-stock-' + i">{{ a.orderableQuantity || 0 }}</div>
						</div>
					</template>

					<template v-slot:남은재고기간="{ item }">
						<div
							@click="showInventoryModal(item)"
							:class="['inventory-box-vertical', 'bg-light', 'border', 'text-dark', getTotalStockDangerClass(item)]"
							:title="getTotalStockDangerTooltip(item)"
							style="cursor: pointer;">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(getTotalAvailableStock(item), item.vendorItemId).toLocaleString() }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(getTotalAvailableStock(item), item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ getTotalAvailableStock(item) }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ getTotalAvailableStock(item) }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ getTotalAvailableStock(item) }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(getTotalAvailableStock(item), item.일판매수량, item) }}</div>
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="i"
								@click="showInventoryModal(item)"
								:class="getReturnStockDangerClass(a, item)"
								:title="getReturnStockDangerTooltip(a, item)">
								{{ a.남은재고기간 }}
							</div>
						</div>
					</template>
					<template v-slot:월판매수량="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0 ?
								getMainProductMonthlySales(item) : item.월판매수량 }}
							<div v-if="item.목표일판매수량 && item.목표일판매수량 > 0" class="text-secondary small">
								{{ item.목표일판매수량*30 }}
							</div>
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="i">{{ getReturnProductMonthlySales(a) }}</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-' + i">
								{{ getBundleProductMonthlySales(a) }}
							</div>
						</div>
					</template>
					<template v-slot:7일판매수량="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0 ?
								getMainProduct7DaySales(item) : item['7일판매수량'] }}
							<div v-if="item.목표일판매수량 && item.목표일판매수량 > 0" class="text-secondary small">
								{{ Math.round(item.목표일판매수량*7) }}
							</div>
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-7day-' + i">{{ getReturnProduct7DaySales(a) }}</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-7day-' + i">
								{{ getBundleProduct7DaySales(a) }}
							</div>
						</div>
					</template>
					<template v-slot:recentDay6="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ getMainProductDailySalesAtOffset(item, 6) }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-day-6-' + i">
								{{ getReturnProductDailySales(a, 6) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-day-6-' + i">
								{{ getBundleProductDailySales(a, 6) }}
							</div>
						</div>
					</template>
					<template v-slot:recentDay5="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ getMainProductDailySalesAtOffset(item, 5) }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-day-5-' + i">
								{{ getReturnProductDailySales(a, 5) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-day-5-' + i">
								{{ getBundleProductDailySales(a, 5) }}
							</div>
						</div>
					</template>
					<template v-slot:recentDay4="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ getMainProductDailySalesAtOffset(item, 4) }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-day-4-' + i">
								{{ getReturnProductDailySales(a, 4) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-day-4-' + i">
								{{ getBundleProductDailySales(a, 4) }}
							</div>
						</div>
					</template>
					<template v-slot:recentDay3="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ getMainProductDailySalesAtOffset(item, 3) }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-day-3-' + i">
								{{ getReturnProductDailySales(a, 3) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-day-3-' + i">
								{{ getBundleProductDailySales(a, 3) }}
							</div>
						</div>
					</template>
					<template v-slot:recentDay2="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ getMainProductDailySalesAtOffset(item, 2) }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-day-2-' + i">
								{{ getReturnProductDailySales(a, 2) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-day-2-' + i">
								{{ getBundleProductDailySales(a, 2) }}
							</div>
						</div>
					</template>
					<template v-slot:recentDay1="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ getMainProductDailySalesAtOffset(item, 1) }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-day-1-' + i">
								{{ getReturnProductDailySales(a, 1) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-day-1-' + i">
								{{ getBundleProductDailySales(a, 1) }}
							</div>
						</div>
					</template>
					<template v-slot:recentDay0="{ item }">
						<div v-b-modal="'poQty' + item.vendorItemId">
							{{ getMainProductDailySalesAtOffset(item, 0) }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-day-0-' + i">
								{{ getReturnProductDailySales(a, 0) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-day-0-' + i">
								{{ getBundleProductDailySales(a, 0) }}
							</div>
						</div>
					</template>

					<template v-slot:판매변화="{ item }">
						<div>
							<span :style="{ color: getSalesChangeStyle(showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0 ? getSalesChangeRate(item) : item.판매변화).color }">
								{{ Math.abs(showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0 ? getSalesChangeRate(item) : item.판매변화).toFixed(1) }}%
								{{ getSalesChangeStyle(showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0 ? getSalesChangeRate(item) : item.판매변화).icon }}
							</span>
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-change-' + i">
								<span :style="{ color: getSalesChangeStyle(getReturnProductChangeRate(a)).color }">
									{{ Math.abs(getReturnProductChangeRate(a)).toFixed(1) }}%
									{{ getSalesChangeStyle(getReturnProductChangeRate(a)).icon }}
								</span>
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-change-' + i">
								<span :style="{ color: getSalesChangeStyle(getBundleProductChangeRate(a)).color }">
									{{ Math.abs(getBundleProductChangeRate(a)).toFixed(1) }}%
									{{ getSalesChangeStyle(getBundleProductChangeRate(a)).icon }}
								</span>
							</div>
						</div>
					</template>
					<template v-slot:일판매수량="{ item }">
						<div @click="openTargetSalesModal(item)" style="cursor: pointer;">
							<div>{{ showBundleProducts && item.upBundlingProducts && item.upBundlingProducts.length > 0 ?
								getMainProductDailySales(item).toFixed(2) : item.일판매수량.toFixed(2) }}</div>
							<div v-if="item.목표일판매수량 && item.목표일판매수량 > 0" class="text-secondary small">
								{{ item.목표일판매수량 }}
							</div>
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="'return-daily-' + i">
								{{ (getReturnProductMonthlySales(a) / 30).toFixed(2) }}
							</div>
						</div>
						<div v-if="item.upBundlingProducts && item.upBundlingProducts.length > 0 && showBundleProducts">
							<div v-for="a, i in item.upBundlingProducts" :key="'bundle-daily-' + i">
								{{ (getBundleProductMonthlySales(a) / 30).toFixed(2) }}
							</div>
						</div>
					</template>
					<template v-slot:발주="{ item }">
						<div v-if="item._poQty > 0" :title="item._poTooltip">
							<b-badge variant="info" pill>📦 {{ item._poQty }}</b-badge>
						</div>
						<div v-else class="text-muted">-</div>
					</template>
					<template v-slot:dday="{ item }">
						<div class="purchase-outbound-cell" :style="getDdayStyle(item.dday, item.최소재고기간)" @click="showInventoryModal(item)">
							{{ formatDday(item.dday) }}
						</div>
					</template>
					<template v-slot:배대지출고Dday="{ item }">
						<div class="purchase-outbound-cell" :style="getDdayStyle(item.배대지출고Dday, item.최소재고기간)" @click="showInventoryModal(item)">
							{{ formatDday(item.배대지출고Dday) }}
						</div>
					</template>
					<template v-slot:배대지출고필요수량="{ item }">
						<div class="purchase-outbound-cell" v-if="item.배대지 <= 0" @click="showInventoryModal(item)">-</div>
						<div class="purchase-outbound-cell" v-else @click="showInventoryModal(item)">
							<div>{{ item.배대지출고필요수량 === 0 ? '-' : item.배대지출고필요수량 }}</div>
							<div v-if="item.박스인입수량 > 1" class="stock-period-text">
								{{ item.박스인입수량 }}
							</div>
						</div>
					</template>
					<template v-slot:통관중출고Dday="{ item }">
						<div class="purchase-outbound-cell" :style="getDdayStyle(item.통관중출고Dday, item.최소재고기간)" @click="showInventoryModal(item)">
							{{ formatDday(item.통관중출고Dday) }}
						</div>
					</template>
					<template v-slot:통관중출고필요수량="{ item }">
						<div class="purchase-outbound-cell" v-if="item.통관중 <= 0" @click="showInventoryModal(item)">-</div>
						<div class="purchase-outbound-cell" v-else @click="showInventoryModal(item)">
							<div>{{ item.통관중출고필요수량 === 0 ? '-' : item.통관중출고필요수량 }}</div>
							<div v-if="item.박스인입수량 > 1" class="stock-period-text">
								{{ item.박스인입수량 }}
							</div>
						</div>
					</template>
					<template v-slot:국내출고Dday="{ item }">
						<div class="purchase-outbound-cell" :style="getDdayStyle(item.국내출고Dday, item.최소재고기간)" @click="showInventoryModal(item)">
							{{ formatDday(item.국내출고Dday) }}
						</div>
					</template>
					<template v-slot:국내출고필요수량="{ item }">
						<div class="purchase-outbound-cell" v-if="item.국내재고 <= 0" @click="showInventoryModal(item)">-</div>
						<div class="purchase-outbound-cell" v-else @click="showInventoryModal(item)">
							<div>{{ item.국내출고필요수량 === 0 ? '-' : item.국내출고필요수량 }}</div>
							<div v-if="item.박스인입수량 > 1" class="stock-period-text">
								{{ item.박스인입수량 }}
							</div>
						</div>
					</template>
					<template v-slot:최대입고기간="{ item }">
						<div v-b-modal="'inboundDetails' + item.vendorItemId" style="cursor: pointer">{{ item.최대입고기간 }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="i">{{ a.최대입고기간 }}</div>
						</div>
					</template>
					<template v-slot:보관료="{ item }">
						<div v-b-modal="'inboundDetails' + item.vendorItemId" style="cursor: pointer">{{ item.보관료 }}
						</div>
						<div v-if="item.returnProducts && item.returnProducts.length > 0 && showReturnProducts">
							<div v-for="a, i in item.returnProducts" :key="i">{{ a.보관료 }}</div>
						</div>

						<!-- 입고 상세 내역 모달 -->
						<b-modal :id="'inboundDetails' + item.vendorItemId" scrollable title="입고 상세 내역" ok-only
							modal-class="scm-detail-modal">
							<div class="overflow-x-auto">
								<!-- 입고 상세 테이블 -->
								<table class="table table-bordered">
									<thead>
										<tr>
											<th class="text-center">입고일자</th>
											<th class="text-center">남은수량</th>
											<th class="text-center">입고기간</th>
											<!-- <th class="text-center">보관료</th> -->
										</tr>
									</thead>
									<tbody>
										<tr v-for="(detail, index) in sortedInboundList(item.inboundInfo)" :key="index"
											:class="{ 'text-muted': detail.remainingSkuQty <= 0 }">
											<td class="text-center">{{ formatDate(detail.inboundDate) }}</td>
											<td class="text-right">{{ formatNumber(detail.remainingSkuQty) }}개</td>
											<td class="text-right">{{ calculateDaysAgo(detail.inboundDate) }}일</td>
											<!-- <td class="text-right">{{ formatCurrency(calculateStorageFee(detail.inboundDate, detail.remainingSkuQty, item.inboundInfo.storageFeeRates)) }}</td> -->
										</tr>
										<!-- 합계 행 -->
										<tr class="table-secondary font-weight-bold">
											<td>합계</td>
											<td class="text-right">{{ formatNumber(getTotalQuantity(item.inboundInfo))
											}}개</td>
											<td></td>
											<!-- <td class="text-right">{{ formatCurrency(getTotalStorageFee(item.inboundInfo)) }}</td> -->
										</tr>
									</tbody>
								</table>
							</div>
						</b-modal>

					</template>
					<!-- 설정 -->
					<template v-slot:설정="{ item }">
						<div class="text-center">
							<i v-if="item.isSummaryRow"
								class="fas fa-cogs text-primary cursor-pointer"
								@click="showSettingsModal()"
								title="전체 설정 관리"
								style="font-size: 16px;"></i>
							<i v-else
								class="fas fa-cog text-secondary cursor-pointer"
								@click="showSettingsModal(item)"
								:title="getSettingsTooltip(item)"
								style="font-size: 14px;"></i>
						</div>
					</template>

					<!-- 메모 -->
					<template v-slot:메모="{ item }">
						<!-- 종합 행인 경우 -->
						<div v-if="item.isSummaryRow" class="text-center">
							<i v-if="hasMemoInItems()"
								class="fas fa-sticky-note text-warning memo-simple-icon"
								:title="getSummaryMemoTooltip()"></i>
							<span v-else class="text-muted">-</span>
						</div>
						<!-- 일반 행인 경우 -->
						<div v-else class="text-center">
							<!-- 메모가 있는 경우 -->
							<div v-if="item.메모 && item.메모.toString().trim()">
								<i class="fas fa-sticky-note text-success memo-simple-icon"
									:title="item.메모"
									@click="editMemo(item)"></i>
							</div>
							<!-- 메모가 없는 경우: 빈 공간에 클릭하면 메모 추가 -->
							<div v-else class="memo-add-area" @click="editMemo(item)" title="메모 추가">
								<i class="fas fa-plus text-muted memo-add-icon"></i>
							</div>
						</div>
					</template>
				</CDataTable>





				<b-modal size="xl" id="excelupload" scrollable title="일괄업로드" ok-only>
					<div class="row">
						<div class="col-md-12">
							<p><strong>[업로드 방법]</strong></p>
							<p>1. 엑셀업로드 포맷 다운로드 → 2. 엑셀 파일에서 필요한 필드 업데이트 → 3. 업데이트된 엑셀 파일 업로드</p>
							<p><small class="text-muted">* 상품명, 옵션명은 수정할 수 없습니다. 변경된 데이터만 업데이트됩니다.</small></p>
						</div>
					</div>

					<!-- 옵션ID 매칭 방식 -->
					<div class="card mb-3">
						<div class="card-header bg-primary text-white">
							<h6 class="mb-0"><i class="fa fa-barcode mr-2"></i>옵션ID(vendorItemId)로 매칭</h6>
						</div>
						<div class="card-body">
							<div class="row align-items-end">
								<div class="col-md-4">
									<label class="form-label">엑셀 포맷 다운로드</label>
									<div>
										<button type="button" @click="formatDownload('vendorItemId')"
											class="btn btn-outline-primary btn-block">
											<i class="fa fa-download mr-1"></i>옵션ID 포맷 다운로드
										</button>
									</div>
								</div>
								<div class="col-md-6">
									<label class="form-label">엑셀 파일 업로드</label>
									<div class="custom-file">
										<input ref="vendorItemIdUpload" type="file" @change="uploadfile($event, 'vendorItemId')"
											class="custom-file-input" id="vendorItemIdFile" accept=".xlsx,.xls">
										<label class="custom-file-label" for="vendorItemIdFile">{{ uploadstatus }}</label>
									</div>
								</div>
								<div class="col-md-2" v-if="showuploadspinner && currentUploadType === 'vendorItemId'">
									<img style="width:30px;" :src="require('../../../assets/images/small/loading.gif')">
								</div>
							</div>
						</div>
					</div>

					<!-- 바코드 매칭 방식 -->
					<div class="card">
						<div class="card-header bg-success text-white">
							<h6 class="mb-0"><i class="fa fa-qrcode mr-2"></i>바코드(barcode)로 매칭</h6>
						</div>
						<div class="card-body">
							<div class="row align-items-end">
								<div class="col-md-4">
									<label class="form-label">엑셀 포맷 다운로드</label>
									<div>
										<button type="button" @click="formatDownload('barcode')"
											class="btn btn-outline-success btn-block">
											<i class="fa fa-download mr-1"></i>바코드 포맷 다운로드
										</button>
									</div>
								</div>
								<div class="col-md-6">
									<label class="form-label">엑셀 파일 업로드</label>
									<div class="custom-file">
										<input ref="barcodeUpload" type="file" @change="uploadfile($event, 'barcode')"
											class="custom-file-input" id="barcodeFile" accept=".xlsx,.xls">
										<label class="custom-file-label" for="barcodeFile">{{ uploadstatus2 }}</label>
									</div>
								</div>
								<div class="col-md-2" v-if="showuploadspinner && currentUploadType === 'barcode'">
									<img style="width:30px;" :src="require('../../../assets/images/small/loading.gif')">
								</div>
							</div>
						</div>
					</div>
				</b-modal>

				<b-modal id="reqpurchase" size="xl" scrollable title="구매대행요청" ok-title="구매대행요청추가" cancel-title="취소"
					modal-class="scm-detail-modal" @ok="requestpurchase($event)" @show="initReqLists">
					<div class="mb-3">
						<button type="button" class="btn btn-warning btn-sm" @click="clearPurchaseCart">
							장바구니 초기화 ({{ purchaseCart.length }}개 상품)
						</button>
					</div>
					<CDataTable
						storage-key="rocketScm.2" :headers="reqHeaders" :items="reqlists" v-model="reqTableSelectedItem"
						:show-select="true" itemKey="vendorItemId" style="margin-bottom: 10px" :headerTooltips="headerTooltips">
						<template v-slot:상품명="{ item }">
							<div class="d-flex align-items-center">
								<img :src="item.썸네일" class="img-fluid rounded avatar-40 mr-3" alt="image">
								<div class="text-wrap">{{ item.판매상품명 }}</div>
							</div>
						</template>
						<template v-slot:MOQ수량="{ item }">
							<span class="text-center font-weight-bold">{{ item.MOQ수량 || 2 }}</span>
						</template>
						<template v-slot:구매요청수량="{ item }">
							<input type="number" class="form-control text-center" v-model="item.구매요청수량" min="0" @input="updatePurchasePreview">
						</template>
						<template v-slot:예상재고량="{ item }">
							<div class="text-center font-weight-bold text-primary">
								{{ getPurchasePreviewTotalStockForItem(item) }}개
							</div>
						</template>
						<template v-slot:예상재고일="{ item }">
							<div class="text-center font-weight-bold text-success">
								{{ getPurchasePreviewStockPeriodForItem(item) }}일
							</div>
						</template>
					</CDataTable>
				</b-modal>

				<b-modal id="waitreqpurchase" size="sm" hide-footer>
					<div class="text-center">
						구매요청 내역을 저장 중입니다. 잠시만 기다려 주세요.
					</div>
					<div class=text-center>
						<img style="max-width:100%;" :src="require('../../../assets/images/small/spinner.gif')">
					</div>
				</b-modal>


			</div>
		</div>

		<!-- 입고중 상태 모달 -->
		<b-modal id="inventoryModal" size="xl" scrollable title="재고 관리" hide-footer
			modal-class="scm-detail-modal" @shown="onInventoryModalShown" @hidden="onModalHidden">
			<div class="inventory-modal-content">
				<!-- 색상 범례 및 정렬 초기화 -->
				<div class="legend-container mb-3">
					<div class="d-flex justify-content-between align-items-center">
						<!-- 일괄 관리 버튼 그룹 -->
						<div class="d-flex align-items-center">
							<b-button variant="outline-primary" size="sm" class="mr-2" v-b-toggle.inventory-collapse>
								<i class="fas fa-edit mr-1"></i>일괄변경
							</b-button>
							<b-button variant="outline-success" size="sm" v-b-modal.excelupload>
								<i class="fas fa-upload mr-1"></i>엑셀업로드
							</b-button>
						</div>
						<!-- 우측 컨트롤 그룹 -->
						<div class="d-flex align-items-center">
							<!-- 정렬 초기화 버튼 -->
							<button class="btn btn-sm btn-outline-secondary mr-3" @click="resetSort" title="기본 정렬로 초기화">
								<i class="fas fa-undo"></i> 정렬 초기화
							</button>
							<!-- 색상 범례 그룹 -->
							<div class="d-flex align-items-center">
								<div class="legend-item mr-3">
									<span class="legend-box bg-success"></span>
									<small>입고 완료</small>
								</div>
								<div class="legend-item mr-3">
									<span class="legend-box bg-warning"></span>
									<small>부분 입고</small>
								</div>
								<div class="legend-item">
									<span class="legend-box bg-danger"></span>
									<small>입고 전</small>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 일괄변경 collapse -->
				<div class="col-lg-12 d-flex justify-content-end mb-3">
					<b-collapse id="inventory-collapse">
						<b-card title="">
							<div class="form-group">
								<input type="number" class="form-control" placeholder="구매완료재고" v-model="재고일괄변경.구매">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="배대지재고" v-model="재고일괄변경.배대지">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="통관중재고" v-model="재고일괄변경.통관중">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="국내재고" v-model="재고일괄변경.국내재고">
							</div>
							<button type="button" class="btn btn-success mr-2 mt-1" @click="applyBulkInventory">적용</button>
						</b-card>
					</b-collapse>
				</div>

				<!-- 전체 상품 재고 관리 테이블 (종합 데이터 포함) -->
				<CDataTable
					storage-key="rocketScm.3" :key="`inventory-${showStockAmount}-${inventoryFilteredVendorItemId}`" :headers="inventoryModalHeaders" :items="filteredInventoryList" itemKey="vendorItemId"
					style="margin-bottom: 10px" :show-select="true" v-model="inventorySelectedItems" :row-class="getRowClass" ref="inventoryTable" :items-per-page="100"
					:subheader="inventoryFilteredVendorItemId ? null : inventorySubheaderData" :headerTooltips="headerTooltips">

					<!-- Subheader 썸네일 -->
					<template v-slot:subheader-썸네일>
						<div class="text-center">
							<i class="fas fa-chart-bar text-primary" style="font-size: 20px;"></i>
						</div>
					</template>

					<!-- 상품 이미지 -->
					<template v-slot:썸네일="{ item }">
						<img :src="item.썸네일" class="img-thumbnail" style="width: 50px; height: 50px;" />
					</template>

					<!-- Subheader 상품명 -->
					<template v-slot:subheader-판매상품명>
						<div class="text-center font-weight-bold text-primary">
							전체 종합
						</div>
					</template>

					<!-- 상품명 + 옵션명 -->
					<template v-slot:판매상품명="{ item }">
						<div style="max-width: 200px;">
							<div class="text-truncate font-weight-bold" :title="item.판매상품명">
								{{ item.판매상품명 }}
							</div>
							<div class="text-truncate text-muted small" :title="item.옵션명">
								{{ item.옵션명 }}
							</div>
						</div>
					</template>

					<!-- Subheader 개별 재고 컬럼들 -->
					<template v-slot:subheader-구매>
						<div class="text-center font-weight-bold">{{ totalSummary.구매 }}</div>
					</template>
					<template v-slot:subheader-배대지>
						<div class="text-center font-weight-bold">{{ totalSummary.배대지 }}</div>
					</template>
					<template v-slot:subheader-장기입고중>
						<div class="text-center font-weight-bold">{{ totalSummary.장기입고중 }}</div>
					</template>
					<template v-slot:subheader-통관중>
						<div class="text-center font-weight-bold">{{ totalSummary.통관중 }}</div>
					</template>
					<template v-slot:subheader-국내재고>
						<div class="text-center font-weight-bold">{{ totalSummary.국내재고 }}</div>
					</template>
					<template v-slot:subheader-단기입고중>
						<div class="text-center font-weight-bold">{{ totalSummary.단기입고중 }}</div>
					</template>
					<template v-slot:subheader-재고>
						<div class="text-center font-weight-bold text-danger">{{ totalSummary.재고 }}</div>
					</template>

					<!-- 개별 재고 컬럼들 -->
					<template v-slot:구매="{ item }">
						<div class="inventory-box-vertical bg-light border text-dark">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.구매, item.vendorItemId).toLocaleString() }}원</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.구매, item.일판매수량, item) }}</div>
							<div v-else>
								<input type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.구매" @blur="updateInventoryInModal(item, '구매', item.구매)" style="width: 100%;">
							</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.구매 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">
								<input type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.구매" @blur="updateInventoryInModal(item, '구매', item.구매)" style="width: 100%;">
							</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.구매, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:배대지="{ item }">
						<div class="inventory-box-vertical bg-light text-dark">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.배대지, item.vendorItemId).toLocaleString() }}원</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.배대지, item.일판매수량, item) }}</div>
							<div v-else>
								<input type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.배대지" @blur="updateInventoryInModal(item, '배대지', item.배대지)" style="width: 100%;">
							</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.배대지 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">
								<input type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.배대지" @blur="updateInventoryInModal(item, '배대지', item.배대지)" style="width: 100%;">
							</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.배대지, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:통관중="{ item }">
						<div class="inventory-box-vertical bg-light text-dark">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.통관중, item.vendorItemId).toLocaleString() }}원</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.통관중, item.일판매수량, item) }}</div>
							<div v-else>
								<input type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.통관중" @blur="updateInventoryInModal(item, '통관중', item.통관중)" style="width: 100%;">
							</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.통관중 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">
								<input type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.통관중" @blur="updateInventoryInModal(item, '통관중', item.통관중)" style="width: 100%;">
							</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.통관중, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:장기입고중="{ item }">
						<div class="inventory-box-vertical bg-primary text-white text-center">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.장기입고중, item.vendorItemId).toLocaleString() }}원</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.장기입고중, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.장기입고중 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.장기입고중 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.장기입고중 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.장기입고중, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:국내재고="{ item }">
						<div class="inventory-box-vertical bg-light text-dark">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.국내재고, item.vendorItemId).toLocaleString() }}원</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.국내재고, item.일판매수량, item) }}</div>
							<div v-else>
								<input type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.국내재고" @blur="updateInventoryInModal(item, '국내재고', item.국내재고)" style="width: 100%;">
							</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.국내재고 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">
								<input type="number" class="form-control form-control-sm text-center border-0"
									v-model="item.국내재고" @blur="updateInventoryInModal(item, '국내재고', item.국내재고)" style="width: 100%;">
							</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.국내재고, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:단기입고중="{ item }">
						<div class="inventory-box-vertical bg-primary text-white text-center">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.단기입고중, item.vendorItemId).toLocaleString() }}원</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.단기입고중, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.단기입고중 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.단기입고중 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.단기입고중 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.단기입고중, item.일판매수량, item) }}</div>
						</div>
					</template>
					<template v-slot:재고="{ item }">
						<div class="inventory-box-vertical bg-danger text-white text-center">
							<div v-if="showStockAmount" class="stock-quantity">{{ getStockAmount(item.재고, item.vendorItemId).toLocaleString() }}원</div>
							<div v-else-if="showStockPeriodFirst" class="stock-quantity">{{ getStockPeriod(item.재고, item.일판매수량, item) }}</div>
							<div v-else class="stock-quantity">{{ item.재고 }}</div>
							<div v-if="showStockAmount" class="stock-period-text">{{ item.재고 }}</div>
							<div v-else-if="showStockPeriodFirst" class="stock-period-text">{{ item.재고 }}</div>
							<div v-else class="stock-period-text">{{ getStockPeriod(item.재고, item.일판매수량, item) }}</div>
						</div>
					</template>

					<!-- 설정 -->
					<template v-slot:설정="{ item }">
						<div class="text-center">
							<button v-if="item.isSummaryRow"
								class="btn btn-sm btn-outline-primary"
								@click="showSettingsModal()"
								title="전체 설정 관리">
								<i class="fas fa-cogs"></i>
							</button>
							<button v-else
								class="btn btn-sm btn-outline-secondary"
								@click="showSettingsModal(item)"
								:title="getSettingsTooltip(item)">
								<i class="fas fa-cog"></i>
							</button>
						</div>
					</template>

					<!-- Subheader 메모 -->
					<template v-slot:subheader-메모>
						<div class="text-center">
							<i v-if="hasMemoInItems()"
								class="fas fa-sticky-note text-warning memo-simple-icon"
								:title="getSummaryMemoTooltip()"></i>
							<span v-else class="text-muted">-</span>
						</div>
					</template>

					<!-- 재고메모 (재고관리 모달용) -->
					<template v-slot:메모="{ item }">
						<!-- 일반 행인 경우 -->
						<div class="text-center">
							<!-- 메모가 있는 경우 -->
							<div v-if="item.메모 && item.메모.toString().trim()">
								<i class="fas fa-sticky-note text-success memo-simple-icon"
									:title="item.메모"
									@click="editMemo(item)"></i>
							</div>
							<!-- 메모가 없는 경우: 빈 공간에 클릭하면 메모 추가 -->
							<div v-else class="memo-add-area" @click="editMemo(item)" title="메모 추가">
								<i class="fas fa-plus text-muted memo-add-icon"></i>
							</div>
						</div>
					</template>

					<!-- Subheader 동적 날짜별 입고 수량 -->
					<template v-for="date in inboundDates" v-slot:[`subheader-inbound_${date}`]>
						<div :key="`subheader-${date}`" class="text-center p-1 rounded" :class="getInboundStyleByValue(getSummaryForDate(date), true)">
							<span @click="sortByDateColumn(date)"
								class="clickable-summary"
								:title="getSummaryTooltip(date)">
								{{ getSummaryForDate(date) }}
							</span>
						</div>
					</template>

					<!-- 동적 날짜별 입고 수량 템플릿 -->
					<template v-for="date in inboundDates" v-slot:[`inbound_${date}`]="{ item }">
						<div :key="`${date}-${item.vendorItemId}`" class="text-center p-1 rounded" :class="getInboundStyleByValue(item[`inbound_${date}`], false)">
							<!-- 일반 행인 경우 -->
							<span :title="getInboundTooltip(item, date)"
								class="inbound-cell">
								{{ item[`inbound_${date}`] }}
							</span>
						</div>
					</template>

				</CDataTable>
			</div>
		</b-modal>

		<!-- 메모 편집 모달 -->
		<b-modal id="memoModal" title="메모 편집" ok-title="저장" cancel-title="취소"
			@ok="saveMemo" @cancel="cancelMemo" size="sm" modal-class="memo-modal">
			<div class="form-group">
				<label for="memoTextarea" class="small">메모 내용:</label>
				<textarea id="memoTextarea" class="form-control form-control-sm" rows="4"
					v-model="currentMemo"
					placeholder="메모 내용을 입력하세요...&#10;여러 줄로 작성 가능합니다."
					maxlength="500"></textarea>
				<small class="form-text text-muted">
					{{ currentMemo ? currentMemo.length : 0 }}/500자
				</small>
			</div>
		</b-modal>

		<!-- 설정 관리 모달 -->
		<b-modal id="settingsModal" title="설정 관리" hide-footer scrollable
			modal-class="scm-detail-modal" @shown="onSettingsModalShown" @hidden="onModalHidden">
			<div class="container-fluid">
				<!-- 헤더 영역 -->
				<div class="row mb-0">
					<div class="col-8">
						<h5>전체 상품 설정 관리</h5>
						<small class="text-muted">각 상품별로 설정값을 관리할 수 있습니다.</small>

					</div>
					<div class="col-4 text-right">
						<b-button variant="outline-primary" size="sm" class="mr-2" v-b-toggle.settings-collapse>
							<i class="fas fa-edit mr-1"></i>일괄변경
						</b-button>
						<b-button variant="outline-success" size="sm" v-b-modal.excelupload>
							<i class="fas fa-upload mr-1"></i>엑셀업로드
						</b-button>
					</div>
				</div>

				<!-- 일괄변경 collapse -->
				<div class="col-lg-12 d-flex justify-content-end mb-3">
					<b-collapse id="settings-collapse">
						<b-card title="">
							<div class="form-group">
								<input type="number" class="form-control" placeholder="입고기간" v-model="설정일괄변경.입고기간">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="배대지입고기간" v-model="설정일괄변경.배대지입고기간">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="통관중입고기간" v-model="설정일괄변경.통관중입고기간">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="국내입고기간" v-model="설정일괄변경.국내입고기간">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="안전재고기간" v-model="설정일괄변경.최소재고기간">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="목표재고기간" v-model="설정일괄변경.최대재고기간">
							</div>
							<div class="form-group">
								<input type="number" class="form-control" placeholder="MOQ수량" v-model="설정일괄변경.MOQ수량">
							</div>
							<button type="button" class="btn btn-success mr-2 mt-1" @click="applyBulkSettings">적용</button>
						</b-card>
					</b-collapse>
				</div>

				<!-- 개념도 영역 -->
				<div class="concept-diagram mb-0">
					<div class="scm-concept-image">
								<img src="@/assets/images/small/scm개념도.png"
										alt="SCM 입고기간 및 재고기간 개념도"
										class="img-fluid concept-diagram-img">
							</div>
				</div>

				<!-- 설정 테이블 -->
				<CDataTable
					storage-key="rocketScm.4"
					:key="`settings-${settingsFilteredVendorItemId}`"
					:headers="settingsHeaders"
					:items="filteredSettingsList"
					:items-per-page="100"
					:show-select="true"
					v-model="settingsSelectedItems"
					itemKey="_id"
					:row-class="getRowClass"
					ref="settingsTable"
					class="settings-table">

					<!-- 상품 이미지 -->
					<template v-slot:썸네일="{ item }">
						<div class="text-center">
							<img :src="item.썸네일" style="width: 40px; height: 40px; object-fit: cover;"
								class="rounded" :alt="item.판매상품명">
						</div>
					</template>

					<!-- 상품명 -->
					<template v-slot:판매상품명="{ item }">
						<div style="max-width: 150px;">
							<div class="product-name-multiline font-weight-bold" :title="item.판매상품명">
								{{ item.판매상품명 }}
							</div>
							<small class="text-muted" :title="item.productId">
								{{ item.productId }}
							</small>
						</div>
					</template>

					<!-- 옵션명 -->
					<template v-slot:옵션명="{ item }">
						<div style="max-width: 120px;">
							<div class="text-truncate" :title="item.옵션명">
								{{ item.옵션명 }}
							</div>
							<small class="text-muted" :title="item.vendorItemId">
								{{ item.vendorItemId }}
							</small>
						</div>
					</template>

					<!-- 구매입고기간 -->
					<template v-slot:구매입고기간="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.입고기간" @blur="updateItemSettings(item)"
							style="width: 70px;" placeholder="7">
					</template>

					<!-- 배대지입고기간 -->
					<template v-slot:배대지입고기간="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.배대지입고기간" @blur="updateItemSettings(item)"
							style="width: 70px;" placeholder="3">
					</template>

					<!-- 통관중입고기간 -->
					<template v-slot:통관중입고기간="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.통관중입고기간" @blur="updateItemSettings(item)"
							style="width: 70px;" placeholder="3">
					</template>

					<!-- 국내입고기간 -->
					<template v-slot:국내입고기간="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.국내입고기간" @blur="updateItemSettings(item)"
							style="width: 70px;" placeholder="2">
					</template>

					<!-- 목표재고기간 -->
					<template v-slot:목표재고기간="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.최대재고기간" @blur="updateItemSettings(item)"
							style="width: 70px;" placeholder="30">
					</template>

					<!-- 안전재고기간 -->
					<template v-slot:안전재고기간="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.최소재고기간" @blur="updateItemSettings(item)"
							style="width: 70px;" placeholder="7">
					</template>

					<!-- MOQ수량 -->
					<template v-slot:MOQ수량="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.MOQ수량" @blur="updateItemSettings(item)"
							style="width: 80px;" placeholder="100">
					</template>

					<!-- 1박스 인입수량 -->
					<template v-slot:박스인입수량="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.박스인입수량" @blur="updateItemSettings(item)"
							style="width: 80px;" placeholder="1">
					</template>

					<!-- 메모 -->
					<template v-slot:메모="{ item }">
						<div class="text-center">
							<!-- 메모가 있는 경우 -->
							<div v-if="item.메모 && item.메모.toString().trim()">
								<i class="fas fa-sticky-note text-success memo-simple-icon"
									:title="item.메모"
									@click="editMemo(item)"></i>
							</div>
							<!-- 메모가 없는 경우: 빈 공간에 클릭하면 메모 추가 -->
							<div v-else class="memo-add-area" @click="editMemo(item)" title="메모 추가">
								<i class="fas fa-plus text-muted memo-add-icon"></i>
							</div>
						</div>
					</template>

				</CDataTable>
			</div>
		</b-modal>

		<!-- 순서 관리 모달 -->
		<b-modal v-model="showOrderModal" size="xl" title="순서 관리" hide-footer>
			<div class="order-management">
				<p class="text-muted mb-3">노출ID별, 옵션ID별로 순서를 지정할 수 있습니다. 빈값은 기본 정렬(월판매수량 기준) 뒤에 배치됩니다.</p>

				<CDataTable
					storage-key="rocketScm.5" :headers="orderHeaders" :items="saleslists" itemKey="vendorItemId"
					style="margin-bottom: 10px" :show-select="false">

					<!-- 상품 이미지 -->
					<template v-slot:썸네일="{ item }">
						<img :src="item.썸네일" class="img-thumbnail" style="width: 40px; height: 40px;" />
					</template>

					<!-- 상품명 -->
					<template v-slot:판매상품명="{ item }">
						<div class="text-truncate" style="max-width: 200px;" :title="item.판매상품명">
							{{ item.판매상품명 }}
						</div>
					</template>

					<!-- 옵션명 -->
					<template v-slot:옵션명="{ item }">
						<div class="text-truncate" style="max-width: 150px;" :title="item.옵션명">
							{{ item.옵션명 }}
						</div>
					</template>

					<!-- 노출ID 순서 -->
					<template v-slot:노출ID순서="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.productOrder" @blur="updateProductOrder(item)"
							placeholder="순서" style="width: 80px;">
					</template>

					<!-- 옵션ID 순서 -->
					<template v-slot:옵션ID순서="{ item }">
						<input type="number" class="form-control form-control-sm text-center"
							v-model="item.optionOrder" @blur="updateOrder(item)"
							placeholder="순서" style="width: 80px;">
					</template>

				</CDataTable>

				<div class="text-center mt-3">
					<button class="btn btn-primary mr-2" @click="applyCustomSort">순서 적용</button>
					<button class="btn btn-secondary" @click="showOrderModal = false">닫기</button>
				</div>
			</div>
		</b-modal>

		<!-- 목표 일판매수량 입력 모달 -->
		<b-modal v-model="targetSalesModal.show" title="목표 일판매수량 설정" size="sm" @ok="saveTargetSales" @cancel="cancelTargetSales">
			<div v-if="targetSalesModal.item">
				<div class="mb-3">
					<strong>상품:</strong> {{ targetSalesModal.item.판매상품명 }}
				</div>
				<div class="mb-3">
					<strong>옵션:</strong> {{ targetSalesModal.item.옵션명 }}
				</div>
				<div class="mb-3">
					<strong>현재 일판매수량:</strong> {{ targetSalesModal.item.일판매수량.toFixed(2) }}
				</div>
				<div class="form-group">
					<label for="targetSales">목표 일판매수량:</label>
					<input
						type="number"
						id="targetSales"
						class="form-control"
						v-model="targetSalesModal.targetSales"
						step="0.01"
						min="0"
						placeholder="목표 일판매수량을 입력하세요">
				</div>
			</div>
		</b-modal>

		<!-- 구매요청수량 입력 모달 -->
		<b-modal v-model="purchaseRequestModal.show" title="구매요청수량 설정" size="sm"
			ok-title="구매요청추가" cancel-title="취소" @ok="savePurchaseRequest" @cancel="cancelPurchaseRequest"
			:ok-disabled="purchaseRequestModal.isProcessing">
			<div v-if="purchaseRequestModal.item">
				<!-- 처리 중 오버레이 -->
				<div v-if="purchaseRequestModal.isProcessing" class="text-center py-4">
					<div class="spinner-border text-primary mb-3" role="status">
						<span class="sr-only">처리 중...</span>
					</div>
					<div class="h5 text-primary">구매요청에 추가하는 중...</div>
					<div class="text-muted">잠시만 기다려주세요 🛒</div>
				</div>

				<!-- 일반 모달 내용 -->
				<div v-else>
					<!-- 상품 정보 (이미지 포함) -->
					<div class="d-flex align-items-center mb-3">
						<img :src="purchaseRequestModal.item.썸네일" class="img-fluid rounded mr-3"
							style="width: 60px; height: 60px; object-fit: cover; flex-shrink: 0;" alt="상품이미지">
						<div class="flex-grow-1" style="min-width: 0;">
							<div class="font-weight-bold text-truncate" style="font-size: 0.9em; line-height: 1.2;">
								{{ purchaseRequestModal.item.판매상품명 }}
							</div>
							<div class="text-muted small text-truncate">{{ purchaseRequestModal.item.옵션명 }}</div>
						</div>
					</div>

					<!-- 구매 설정 정보 (편집 가능) -->
					<div class="mb-3">
						<div class="row">
							<div class="col-6">
								<label class="small font-weight-bold">1박스 인입수량</label>
								<input
									type="number"
									class="form-control form-control-sm text-center"
									v-model="purchaseRequestModal.item.박스인입수량"
									min="1"
									@blur="updatePurchaseSettings">
							</div>
							<div class="col-6">
								<label class="small font-weight-bold">MOQ수량</label>
								<input
									type="number"
									class="form-control form-control-sm text-center"
									v-model="purchaseRequestModal.item.MOQ수량"
									min="1"
									@blur="updatePurchaseSettings">
							</div>
						</div>
					</div>

					<!-- 구매요청수량 입력 -->
					<div class="form-group mb-3">
						<label for="requestQuantity" class="font-weight-bold">
							구매요청수량
							<span class="text-muted small">(현재 {{ purchaseRequestModal.item.구매필요수량 }}개 필요)</span>
						</label>
						<input
							type="number"
							id="requestQuantity"
							class="form-control text-center"
							v-model="purchaseRequestModal.requestQuantity"
							min="0"
							@input="calculatePurchasePreview"
							placeholder="구매요청수량을 입력하세요">
					</div>

				<!-- 구매 후 예상 재고 정보 (컴팩트) -->
				<div v-if="purchaseRequestModal.requestQuantity > 0" class="mt-3">
					<div class="small font-weight-bold mb-2 text-center text-dark">구매 후 예상 재고</div>

					<!-- 현재 → 예상 블럭 형태 -->
					<div class="d-flex align-items-center justify-content-between">
						<!-- 현재 재고 블럭 -->
						<div class="text-center p-3 rounded shadow-sm" style="flex: 1; background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border: 1px solid #dee2e6;">
							<div class="font-weight-bold text-dark" style="font-size: 1.1em;">{{ getTotalAvailableStock(purchaseRequestModal.item) }}개</div>
							<div class="font-weight-bold text-dark" style="font-size: 1em;">{{ getCurrentStockPeriod() }}일</div>
							<div class="small text-muted mt-1">현재</div>
						</div>

						<!-- 화살표 -->
						<div class="mx-3">
							<i class="fas fa-arrow-right text-success" style="font-size: 1.2em;"></i>
						</div>

						<!-- 예상 재고 블럭 -->
						<div class="text-center p-3 rounded shadow-sm" style="flex: 1; background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border: 1px solid #dee2e6;">
							<div class="font-weight-bold text-secondary" style="font-size: 1.1em;">{{ getPurchasePreviewTotalStock() }}개</div>
							<div class="font-weight-bold text-secondary" style="font-size: 1em;">{{ getPurchasePreviewStockPeriod() }}일</div>
							<div class="small text-muted mt-1" style="opacity: 0.9;">예상</div>
						</div>
					</div>

					<div class="mt-2 small text-success text-center font-weight-bold">
						<i class="fas fa-plus-circle mr-1"></i>{{ purchaseRequestModal.requestQuantity }}개 추가
					</div>
				</div>
				</div>
			</div>
		</b-modal>


		<!-- ✅ 사용자 지정 날짜 범위 수집 모달 -->
		<b-modal id="customDateRangeModal" title="날짜 지정 수집" hide-footer>
			<div class="form-group">
				<label for="customStartDate">시작일:</label>
				<input
					type="date"
					id="customStartDate"
					class="form-control"
					v-model="customStartDate"
					:max="customEndDate || new Date().toISOString().split('T')[0]">
			</div>
			<div class="form-group">
				<label for="customEndDate">종료일:</label>
				<input
					type="date"
					id="customEndDate"
					class="form-control"
					v-model="customEndDate"
					:min="customStartDate"
					:max="new Date().toISOString().split('T')[0]">
			</div>
			<div class="text-center mt-3">
				<b-button variant="secondary" @click="$bvModal.hide('customDateRangeModal')" class="mr-2">
					취소
				</b-button>
				<b-button variant="primary" @click="executeCustomDateCollection">
					<i class="fas fa-download mr-1"></i>
					수집 시작
				</b-button>
			</div>
		</b-modal>

	<!-- 쿠패스 구매요청 상세 모달 -->
	<b-modal v-model="showReqpurchaseDetailModal" title="구매요청 상세" size="lg" ok-only ok-title="닫기">
		<div v-if="reqpurchaseDetailItem" class="mb-3">
			<div class="d-flex align-items-center mb-2">
				<img v-if="reqpurchaseDetailItem.썸네일" :src="reqpurchaseDetailItem.썸네일"
					style="width:40px;height:40px;object-fit:cover;" class="mr-2 rounded">
				<div>
					<strong>{{ reqpurchaseDetailItem.판매상품명 }}</strong>
					<div class="text-muted small">
						옵션ID: {{ reqpurchaseDetailItem.vendorItemId }} |
						바코드: {{ getBarcode(reqpurchaseDetailItem) }}
					</div>
				</div>
			</div>
			<div class="row text-center mb-3">
				<div class="col-3">
					<div class="border rounded p-2">
						<div class="small text-muted">구매완료</div>
						<div class="font-weight-bold text-primary">{{ reqpurchaseDetailItem.구매 || 0 }}</div>
					</div>
				</div>
				<div class="col-3">
					<div class="border rounded p-2">
						<div class="small text-muted">배대지</div>
						<div class="font-weight-bold text-info">{{ reqpurchaseDetailItem.배대지 || 0 }}</div>
					</div>
				</div>
				<div class="col-3">
					<div class="border rounded p-2">
						<div class="small text-muted">통관중</div>
						<div class="font-weight-bold text-warning">{{ reqpurchaseDetailItem.통관중 || 0 }}</div>
					</div>
				</div>
				<div class="col-3">
					<div class="border rounded p-2">
						<div class="small text-muted">전체가용</div>
						<div class="font-weight-bold text-success">{{ getTotalAvailableStock(reqpurchaseDetailItem) }}</div>
					</div>
				</div>
			</div>
		</div>
		<table class="table table-sm table-bordered" v-if="reqpurchaseDetailList.length > 0">
			<thead>
				<tr class="text-center">
					<th>바코드</th>
					<th>수량</th>
					<th>진행현황</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(req, idx) in reqpurchaseDetailList" :key="idx" class="text-center">
					<td>{{ req.바코드 }}</td>
					<td>{{ req.구매요청수량 }}</td>
					<td>
						<span :class="getProcessStatusBadgeClass(req.processStatus)">
							{{ req.processStatus }}
						</span>
					</td>
				</tr>
			</tbody>
		</table>
		<div v-else class="text-center text-muted py-3">
			매칭되는 구매요청이 없습니다.
		</div>
	</b-modal>

	<!-- 쿠패스연동 확인 모달 -->
	<b-modal v-model="coupassSyncConfirmModal.show" title="쿠패스연동 확인" size="md"
		ok-title="연동 시작" cancel-title="취소" @ok="confirmCoupassSync" @cancel="cancelCoupassSync">
		<div class="alert alert-warning">
			<i class="fas fa-exclamation-triangle mr-2"></i>
			<strong>주의사항</strong>
		</div>
		<p>쿠패스연동을 활성화하면 다음 재고 정보가 자동으로 업데이트됩니다:</p>
		<div class="mb-3">
			<h6 class="text-danger"><i class="fas fa-sync-alt mr-1"></i>변경될 재고 항목:</h6>
			<ul class="list-unstyled ml-3">
				<li><i class="fas fa-dot-circle text-danger mr-2"></i>구매완료재고</li>
				<li><i class="fas fa-dot-circle text-danger mr-2"></i>배대지재고</li>
				<li><i class="fas fa-dot-circle text-danger mr-2"></i>통관중재고</li>
			</ul>
		</div>
		<div class="mb-3">
			<h6 class="text-success"><i class="fas fa-lock mr-1"></i>유지될 재고 항목:</h6>
			<ul class="list-unstyled ml-3">
				<li><i class="fas fa-dot-circle text-success mr-2"></i>해외입고중</li>
				<li><i class="fas fa-dot-circle text-success mr-2"></i>국내재고</li>
				<li><i class="fas fa-dot-circle text-success mr-2"></i>국내입고중</li>
			</ul>
		</div>
		<p class="text-muted small">
			<i class="fas fa-info-circle mr-1"></i>
			기존에 수동으로 입력한 재고 정보가 덮어쓰여질 수 있습니다. 계속하시겠습니까?
		</p>
	</b-modal>

	</div>
</template>

<style scoped>
.coupass-detail-icon {
	position: absolute;
	top: 1px;
	right: 1px;
	font-size: 10px;
	cursor: pointer;
	opacity: 0.5;
	transition: all 0.2s;
	z-index: 1;
}

.coupass-detail-icon:hover {
	opacity: 1;
	transform: scale(1.2);
}

.inventory-flow {
	background: #f8f9fa;
	padding: 20px;
	border-radius: 10px;
	border: 2px solid #e9ecef;
}

.flow-item {
	flex: 1;
	max-width: 120px;
}

.flow-box {
	padding: 10px;
	border-radius: 8px;
	min-height: 70px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.flow-arrow {
	font-size: 8px;
	color: #6c757d;
	margin: 0 1px;
	flex-shrink: 0;
}

.flow-box input {
	font-weight: bold !important;
	font-size: 14px !important;
}

.flow-box input:focus {
	box-shadow: 0 0 0 0.2rem rgba(255,255,255,0.5) !important;
}

.inventory-box {
	padding: 8px;
	border-radius: 6px;
	font-weight: bold;
	text-align: center;
	min-height: 35px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.2s ease;
}

.inventory-box:hover {
	transform: scale(1.05);
	box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.mini-flow-box {
	padding: 3px;
	border-radius: 3px;
	min-height: 35px;
	width: 65px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 11px;
	flex-shrink: 0;
}

.mini-flow-box input {
	font-size: 11px !important;
	padding: 2px !important;
	height: 25px !important;
}

.scm-detail-modal .modal-dialog {
	max-width: 98vw !important;
	margin: 1vh auto !important;
}

.scm-detail-modal .modal-content {
	height: 98vh !important;
}

.scm-detail-modal .modal-body {
	max-height: 98vh !important;
	overflow-y: auto !important;
}

.inventory-modal-full .modal-dialog {
	max-width: 99vw !important;
	margin: 0.5vh auto !important;
}

.inventory-modal-full .modal-content {
	height: 98vh !important;
}

.inventory-modal-full .modal-body {
	max-height: 98vh !important;
	overflow-y: auto !important;
}

.summary-flow {
	width: 100%;
}

.summary-item {
	flex: 1;
	min-width: 60px;
}

.summary-label {
	font-size: 11px;
	font-weight: bold;
	color: #6c757d;
	margin-bottom: 2px;
}

.summary-value {
	font-size: 14px;
	font-weight: bold;
	color: #333;
}

/* 범례 스타일 */

.legend-item {
	display: flex;
	align-items: center;
}

.legend-box {
	width: 16px;
	height: 16px;
	border-radius: 3px;
	margin-right: 6px;
	display: inline-block;
}

.legend-box.bg-warning {
	color: #856404 !important;
}

.legend-box.bg-success {
	color: white !important;
}

.legend-box.bg-danger {
	color: white !important;
}

/* 클릭 가능한 종합 데이터 스타일 */
.clickable-summary {
	cursor: pointer;
	text-decoration: underline;
	transition: opacity 0.2s;
}

.clickable-summary:hover {
	opacity: 0.8;
}

/* 입고 수량 셀 스타일 */
.inbound-cell {
	cursor: help;
}

.inbound-cell:hover {
	opacity: 0.9;
}

/* 메모 관련 스타일 - 심플한 디자인 */
.memo-simple-container {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;
}

.memo-simple-display {
	display: flex;
	align-items: center;
	gap: 4px;
}

.memo-simple-icon {
	font-size: 14px;
	cursor: pointer;
	transition: opacity 0.2s ease;
}

.memo-simple-icon:hover {
	opacity: 0.7;
}

.memo-simple-add {
	font-size: 12px;
	cursor: pointer;
	transition: opacity 0.2s ease;
}

.memo-simple-add:hover {
	opacity: 0.7;
}

.memo-simple-delete {
	font-size: 10px;
	cursor: pointer;
	transition: opacity 0.2s ease;
}

.memo-simple-delete:hover {
	opacity: 0.7;
}

/* 상품명 두 줄 표시 스타일 */
.product-name-multiline {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	line-height: 1.2;
	max-height: 2.4em; /* line-height * 2 */
	word-break: break-word;
}

/* 커서 포인터 스타일 */
.cursor-pointer {
	cursor: pointer;
}

/* 메모 추가 영역 스타일 */
.memo-add-area {
	cursor: pointer;
	padding: 5px;
	border-radius: 3px;
	transition: background-color 0.2s;
}

.memo-add-area:hover {
	background-color: #f8f9fa;
}

.memo-add-icon {
	font-size: 12px;
	opacity: 0.6;
}

.memo-add-area:hover .memo-add-icon {
	opacity: 1;
}

/* 개념도 스타일 */
.concept-diagram .card {
	border: 1px solid #e3e6f0;
	box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
}

/* SCM 개념도 이미지 스타일 */
.scm-concept-image {
	text-align: center;
	padding: 10px;
	background: #f8f9fa;
	border-radius: 6px;
}

.concept-diagram-img {
	max-width: 40%;
	height: auto;
	border-radius: 4px;
	box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* 재고 박스 세로 배치 스타일 */
.inventory-box-vertical {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 8px 4px;
	border-radius: 4px;
	min-height: 50px;
}

.stock-quantity {
	font-size: 14px;
	font-weight: bold;
	line-height: 1.2;
}

/* 재고 기간 텍스트 스타일 */
.stock-period-text {
	font-size: 11px;
	opacity: 0.8;
	margin-top: 2px;
	line-height: 1;
	font-weight: bold;
}

/* 전체가용재고기간 경고 스타일 (보라색) */
.total-stock-danger {
	background: #9f7bc0 !important;  /* 보라색 */
}

/* 쿠팡재고기간과 기타 경고 스타일 (빨간색) */
.stock-danger {
	background: #dc3545 !important;  /* 기본 빨간색 */
}

/* 쿠팡재고기간 60일 초과 경고 스타일 (주황색) */
.stock-warning {
	background: #fd7e14 !important;  /* 주황색 */
}

/* 구매/출고 관련 컬럼 배경색 */
.purchase-outbound-cell {
	background-color: #b4f0c6 !important;  /* 연한 회색 배경 */
	border-radius: 3px;
	padding: 4px 6px;
	margin: 1px;
	font-weight: bolder;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
	.scm-concept-image {
		padding: 5px;
	}

	.concept-diagram-img {
		max-width: 100%;
	}

	.inventory-box-vertical {
		min-height: 45px;
		padding: 6px 3px;
	}

	.stock-quantity {
		font-size: 12px;
	}

	.stock-period-text {
		font-size: 10px;
	}
}

/* 옵션명 자동 개행 스타일 */
.option-name-wrap {
	word-wrap: break-word;
	word-break: keep-all;        /* 단어 중간에서 줄바꿈 방지 */
	white-space: pre-wrap;       /* 띄어쓰기와 줄바꿈 보존 */
	line-height: 1.2;
	overflow-wrap: break-word;
	hyphens: none;               /* 하이픈 자동 추가 비활성화 */
}
.total-stock-danger {
	animation: pulse-total-stock-danger 2s infinite;
	cursor: help;
}
/* 재고 위험 상태 스타일 */
.stock-danger {
	animation: pulse-danger 2s infinite;
	cursor: help;
}

.stock-warning {
	animation: pulse-warning 2s infinite;
	cursor: help;
}

@keyframes pulse-warning {
	0% {
		box-shadow: 0 0 0 0 rgba(255, 189, 68, 0.7);
	}
	70% {
		box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
	}
	100% {
		box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
	}
}

@keyframes pulse-danger {
	0% {
		box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
	}
	70% {
		box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
	}
	100% {
		box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
	}
}

@keyframes pulse-total-stock-danger {
	0% {
		box-shadow: 0 0 0 0 rgba(220, 53, 184, 0.7);
	}
	70% {
		box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
	}
	100% {
		box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
	}
}

/* 전체 종합 플로우 간격 조정 */
.summary-flow {
	gap: 2px;
}

.summary-flow .summary-item {
	flex: 1;
	max-width: 61px;
	min-width: 61px;
}

.summary-flow .flow-arrow {
	font-size: 8px;
	color: #6c757d;
	margin: 0 1px;
}

/* 재고 플로우 input 필드 스타일 */
.mini-flow-box input.bg-primary::placeholder {
	color: rgba(255, 255, 255, 0.7) !important;
}

.mini-flow-box input.bg-info::placeholder {
	color: rgba(255, 255, 255, 0.7) !important;
}

.mini-flow-box input.bg-secondary::placeholder {
	color: rgba(255, 255, 255, 0.7) !important;
}

.mini-flow-box input:focus {
	box-shadow: none !important;
	outline: none !important;
}

/* 큰 모달들 (scm-detail-modal) 스타일 */
::v-deep .scm-detail-modal .modal-dialog {
	max-width: 98vw !important;
	width: 98vw !important;
	height: 96vh !important;
	max-height: 96vh !important;
	margin: 1vh auto !important;
}

::v-deep .scm-detail-modal .modal-content {
	height: 100% !important;
	display: flex !important;
	flex-direction: column !important;
	border: none !important;
	border-radius: 0 !important;
}

::v-deep .scm-detail-modal .modal-body {
	flex: 1 !important;
	overflow-y: auto !important;
	padding: 0.5rem !important;
	max-height: none !important;
}

::v-deep .scm-detail-modal .modal-header {
	padding: 0.5rem 1rem !important;
	flex-shrink: 0 !important;
}

::v-deep .scm-detail-modal .modal-footer {
	padding: 0.5rem 1rem !important;
	flex-shrink: 0 !important;
}

/* 메모 모달 (memo-modal) 스타일 - 적당한 크기 */
::v-deep .memo-modal .modal-dialog {
	max-width: 450px !important;
	width: 450px !important;
	height: auto !important;
	max-height: none !important;
	margin: 1.75rem auto !important;
}

::v-deep .memo-modal .modal-content {
	height: auto !important;
	display: block !important;
	flex-direction: initial !important;
	border: 1px solid rgba(0,0,0,.2) !important;
	border-radius: 0.3rem !important;
}

::v-deep .memo-modal .modal-body {
	flex: initial !important;
	overflow-y: initial !important;
	padding: 1rem !important;
	max-height: initial !important;
}

::v-deep .memo-modal .modal-header {
	padding: 1rem 1rem 0.5rem 1rem !important;
}

::v-deep .memo-modal .modal-footer {
	padding: 0.5rem 1rem 1rem 1rem !important;
}
</style>

<!-- 메모 모달 전용 전역 스타일 (더 강력한 우선순위) -->
<style>
/* 메모 모달 강제 스타일 */
.memo-modal .modal-dialog {
	max-width: 450px !important;
	width: 450px !important;
	height: auto !important;
	max-height: none !important;
	margin: 1.75rem auto !important;
}

.memo-modal .modal-content {
	height: auto !important;
	display: block !important;
	flex-direction: initial !important;
	border: 1px solid rgba(0,0,0,.2) !important;
	border-radius: 0.3rem !important;
}

.memo-modal .modal-body {
	flex: initial !important;
	overflow-y: initial !important;
	padding: 1rem !important;
	max-height: initial !important;
}

.memo-modal .modal-header {
	padding: 1rem 1rem 0.5rem 1rem !important;
	flex-shrink: initial !important;
}

.memo-modal .modal-footer {
	padding: 0.5rem 1rem 1rem 1rem !important;
	flex-shrink: initial !important;
}

/* ID 기반 더 강력한 선택자 */
#memoModal .modal-dialog {
	max-width: 450px !important;
	width: 450px !important;
	height: auto !important;
	max-height: none !important;
	margin: 1.75rem auto !important;
}

#memoModal .modal-content {
	height: auto !important;
	display: block !important;
	flex-direction: initial !important;
	border: 1px solid rgba(0,0,0,.2) !important;
	border-radius: 0.3rem !important;
}

#memoModal .modal-body {
	flex: initial !important;
	overflow-y: initial !important;
	padding: 1rem !important;
	max-height: initial !important;
}

/* 모달 관련 스타일 (v-deep 사용) - 최대 크기 */
::v-deep .scm-detail-modal .modal-dialog {
	max-width: 98vw !important;
	width: 98vw !important;
	height: 96vh !important;
	max-height: 96vh !important;
	margin: 1vh auto !important;
}

::v-deep .scm-detail-modal .modal-content {
	height: 100% !important;
	display: flex !important;
	flex-direction: column !important;
	border: none !important;
	border-radius: 0 !important;
}

::v-deep .scm-detail-modal .modal-header {
	padding: 0.5rem 1rem !important;
	border-bottom: 1px solid #dee2e6 !important;
	flex-shrink: 0 !important;
}

::v-deep .scm-detail-modal .modal-body {
	flex: 1 !important;
	overflow-y: auto !important;
	padding: 0.5rem !important;
	max-height: none !important;
}

::v-deep .scm-detail-modal .modal-footer {
	padding: 0.5rem 1rem !important;
	border-top: 1px solid #dee2e6 !important;
	flex-shrink: 0 !important;
}

/* 모든 xl 사이즈 모달에도 적용 */
::v-deep .modal-xl .modal-dialog {
	max-width: 98vw !important;
	width: 98vw !important;
	height: 96vh !important;
	max-height: 96vh !important;
	margin: 1vh auto !important;
}

::v-deep .modal-xl .modal-content {
	height: 100% !important;
	display: flex !important;
	flex-direction: column !important;
	border: none !important;
	border-radius: 0 !important;
}

::v-deep .modal-xl .modal-body {
	flex: 1 !important;
	overflow-y: auto !important;
	padding: 0.5rem !important;
	max-height: none !important;
}

/* 구매필요수량 모달 전용 스타일 (더 강력한 선택자) */
::v-deep .modal[id*="poQty"] .modal-dialog {
	max-width: 98vw !important;
	width: 98vw !important;
	height: 96vh !important;
	max-height: 96vh !important;
	margin: 1vh auto !important;
}

::v-deep .modal[id*="poQty"] .modal-content {
	height: 100% !important;
	display: flex !important;
	flex-direction: column !important;
	border: none !important;
	border-radius: 0 !important;
}

::v-deep .modal[id*="poQty"] .modal-body {
	flex: 1 !important;
	overflow-y: auto !important;
	padding: 0.5rem !important;
	max-height: none !important;
}

/* 모든 모달에 강제 적용 (최후 수단) */
::v-deep .modal .modal-dialog {
	max-width: 98vw !important;
	width: 98vw !important;
}

::v-deep .modal .modal-content {
	height: 96vh !important;
	display: flex !important;
	flex-direction: column !important;
}

::v-deep .modal .modal-body {
	flex: 1 !important;
	overflow-y: auto !important;
	max-height: none !important;
}
</style>

<script>
import axios from 'axios';
import ApexChart from '../../../components/charts/ApexChart';
import * as XLSX from 'xlsx';
import CDataTable from "@/components/common/CDataTable";
import reqVolatileMixin from '@/mixins/reqVolatileMixin'
export default {
	name: 'salesstatus',
	mixins: [reqVolatileMixin],
	components: {
		ApexChart,
		CDataTable
	},
	data() {
		return {
			// Toast 메시지 기반 수집 상태 관리
			todayCollectionNeeded: false, // Toast 메시지 표시 여부와 동일한 상태
			collectionCheckDate: '', // 수집여부를 마지막으로 확인한 날짜 — 툴팁 날짜(computed 캐시로 전날에 멈추지 않게)
			baseHeaders: [
				{ text: '\n\n상품\n이미지\n\n', value: '썸네일', align: 'center', width: 40, isSlot: true },
				{ text: '\n\n상품명\n노출ID\n\n', value: '판매상품명', align: 'center', width: 150, isSlot: true },
				{ text: '\n\n옵션명\n옵션ID\n\n', value: '옵션명', align: 'center', width: 120, isSlot: true },


				{ text: '\n월판매\n수량\n(목표)', value: '월판매수량', align: 'center', width: 50, isSlot: true },
				{ text: '\n7일판매\n수량\n(목표)', value: '7일판매수량', align: 'center', width: 60, isSlot: true },
				{ text: '\n판매\n트렌드', value: '판매변화', align: 'center', width: 100, isSlot: true },
				{ text: '\n일판매\n수량\n(목표)', value: '일판매수량', align: 'center', width: 50, isSlot: true },


				{ text: '\n구매완료\n재고\n(가용기간)', value: '구매', align: 'center', width: 80, isSlot: true },
				{ text: '\n배대지\n재고\n(가용기간)', value: '배대지', align: 'center', width: 80, isSlot: true },
				{ text: '\n해외\n입고중\n(가용기간)', value: '장기입고중', align: 'center', width: 80, isSlot: true },
				{ text: '\n통관중\n재고\n(가용기간)', value: '통관중', align: 'center', width: 80, isSlot: true },
				{ text: '\n국내\n재고\n(가용기간)', value: '국내재고', align: 'center', width: 80, isSlot: true },
				{ text: '\n국내\n입고중\n(가용기간)', value: '단기입고중', align: 'center', width: 80, isSlot: true },
				{ text: '\n쿠팡재고\n(가용기간)', value: '재고', align: 'center', width: 80, isSlot: true },
				{ text: '\n전체재고\n(가용기간)', value: '남은재고기간', align: 'center', width: 80, isSlot: true },

				{ text: '\n구매\n시점', value: 'dday', align: 'center', width: 80, isSlot: true },
				{ text: '\n구매\n필요수량\n(요청수량)', value: '구매필요수량', align: 'center', width: 80, isSlot: true },
				{ text: '\n발주', value: '발주', align: 'center', width: 60, isSlot: true },
				{ text: '\n해외\n출고\n시점', value: '배대지출고Dday', align: 'center', width: 80, isSlot: true },
				{ text: '\n해외출고\n필요수량\n(인입수량)', value: '배대지출고필요수량', align: 'center', width: 80, isSlot: true },
				{ text: '\n통관중\n출고\n시점', value: '통관중출고Dday', align: 'center', width: 80, isSlot: true },
				{ text: '\n통관중출고\n필요수량\n(인입수량)', value: '통관중출고필요수량', align: 'center', width: 80, isSlot: true },
				{ text: '\n국내\n출고\n시점', value: '국내출고Dday', align: 'center', width: 80, isSlot: true },
				{ text: '\n국내출고\n필요수량\n(인입수량)', value: '국내출고필요수량', align: 'center', width: 80, isSlot: true },

				{ text: '설정', value: '설정', align: 'center', width: 50, isSlot: true },
				{ text: '메모', value: '메모', align: 'center', width: 50, isSlot: true },

				{ text: '최장\n입고\n재고\n기간', value: '최대입고기간', align: 'center', width: 50, isSlot: true },
				{ text: '보관료', value: '보관료', align: 'center', width: 80, isSlot: true },


			],
			scmData: {},  // vendorItemId를 키로 하는 SCM 데이터 객체
			inboundDates: [],  // 입고 날짜 목록
			// 쿠패스연동
			coupassSyncEnabled: false,
			coupassSyncConfirmModal: { show: false },
			coupassData: [],
			inventoryMap: {},
			showReqpurchaseDetailModal: false,
			reqpurchaseDetailItem: null,
			reqpurchaseDetailList: [],
			originalSaleslistsOrder: [],  // 모달 초기 상태의 saleslists 순서
			tableSelectedItem: [],
			subheaderData: [],
			// 목표 일판매수량 관련
			targetSalesModal: {
				show: false,
				item: null,
				targetSales: 0
			},
			// 구매요청수량 관련
			purchaseRequestModal: {
				show: false,
				item: null,
				requestQuantity: 0,
				isProcessing: false
			},

			// 메모 관련
			currentMemo: '',
			currentItem: null,

			// 설정 관련
			settingsHeaders: [
				{ text: '상품\n이미지', value: '썸네일', align: 'center', width: 60, isSlot: true },
				{ text: '상품명\n노출ID', value: '판매상품명', align: 'center', width: 150, isSlot: true },
				{ text: '옵션명\n옵션ID', value: '옵션명', align: 'center', width: 100, isSlot: true },
				{ text: '구매입고기간', value: '구매입고기간', align: 'center', width: 100, isSlot: true },
				{ text: '배대지입고기간', value: '배대지입고기간', align: 'center', width: 100, isSlot: true },
				{ text: '통관중입고기간', value: '통관중입고기간', align: 'center', width: 100, isSlot: true },
				{ text: '국내입고기간', value: '국내입고기간', align: 'center', width: 100, isSlot: true },
				{ text: '목표재고기간', value: '목표재고기간', align: 'center', width: 100, isSlot: true },
				{ text: '안전재고기간', value: '안전재고기간', align: 'center', width: 100, isSlot: true },
				{ text: 'MOQ수량', value: 'MOQ수량', align: 'center', width: 100, isSlot: true },
				{ text: '1박스\n인입수량', value: '박스인입수량', align: 'center', width: 100, isSlot: true },
				{ text: '메모', value: '메모', align: 'center', width: 150, isSlot: true }
			],
			reqHeaders: [
				{ text: '상품명', value: '상품명', align: 'left', width: 300, isSlot: true },
				{ text: '옵션명', value: '옵션명', align: 'left', width: 150 },
				{ text: '옵션ID', value: 'vendorItemId', align: 'center', width: 100 },
				{ text: '구매', value: '구매', align: 'center', width: 80 },
				{ text: '배대지', value: '배대지', align: 'center', width: 80 },
				{ text: '통관중', value: '통관중', align: 'center', width: 80 },
				{ text: '국내재고', value: '국내재고', align: 'center', width: 80 },
				{ text: '쿠팡재고', value: '재고', align: 'center', width: 80 },
				{ text: 'MOQ수량', value: 'MOQ수량', align: 'center', width: 80, isSlot: true },
				{ text: '구매요청수량', value: '구매요청수량', align: 'center', width: 120, isSlot: true },
				{ text: '예상재고량', value: '예상재고량', align: 'center', width: 100, isSlot: true },
				{ text: '예상재고일', value: '예상재고일', align: 'center', width: 100, isSlot: true }
			],
			reqTableSelectedItem: [],
			purchaseCart: [], // 구매요청 장바구니

			// 헤더 tooltip 정의
			headerTooltips: {
				'월판매수량': '어제부터 이전 30일간의 월 판매수량입니다 (목표 수량 포함)',
				'7일판매수량': '어제부터 이전 7일간의 판매수량입니다 (목표 수량 포함)',
				'판매변화': '30일 평균 대비 7일 평균 일판매수량의 변화율입니다 (%) - 최근 판매 트렌드',
				'일판매수량': '최근 30일 기준 일평균 판매수량입니다 (목표 수량 포함)',
				'구매': '구매 완료된 재고 수량과 가용 기간입니다',
				'배대지': '배대지에 있는 재고 수량과 가용 기간입니다',
				'장기입고중': '해외에서 쿠팡으로 입고 중인 재고 수량과 가용 기간입니다',
				'통관중': '통관 중인 재고 수량과 가용 기간입니다',
				'국내재고': '국내 창고에 있는 재고 수량과 가용 기간입니다',
				'단기입고중': '국내에서 쿠팡으로 입고 중인 재고 수량과 가용 기간입니다',
				'재고': '쿠팡 창고에 있는 현재 재고 수량과 가용 기간입니다',
				'남은재고기간': '전체 재고를 합한 총 가용 기간입니다',
				'dday': '구매가 필요한 시점까지 남은 일수입니다',
				'구매필요수량': '안전재고 확보를 위해 구매해야 할 수량입니다',
				'배대지출고Dday': '배대지에서 출고해야 할 시점까지 남은 일수입니다',
				'배대지출고필요수량': '배대지에서 출고해야 할 수량입니다',
				'통관중출고Dday': '통관중 재고를 출고해야 할 시점까지 남은 일수입니다',
				'통관중출고필요수량': '통관중에서 출고해야 할 수량입니다',
				'국내출고Dday': '국내 재고를 출고해야 할 시점까지 남은 일수입니다',
				'국내출고필요수량': '국내에서 출고해야 할 수량입니다',
				'입고기간': '구매부터 쿠팡 입고까지 소요되는 기간(일)입니다',
				'배대지입고기간': '배대지부터 쿠팡 입고까지 소요되는 기간(일)입니다',
				'국내입고기간': '국내창고부터 쿠팡 입고까지 소요되는 기간(일)입니다',
				'최대재고기간': '쿠팡 창고 내에서 목표로 하는 재고 보유 기간(일)입니다',
				'최소재고기간': '쿠팡 창고 내에서 안전재고로 유지해야 할 최소 기간(일)입니다',
				'MOQ수량': '최소 주문 수량(Minimum Order Quantity)입니다',
				'최대입고기간': '남아있는 재고 중 가장 오래된 입고 재고의 보관 기간입니다',
				'보관료': '현재 재고에 대한 예상 보관료입니다',
				'설정': '상품별 개별 설정을 관리합니다',
				'메모': '상품에 대한 메모를 작성할 수 있습니다'
			},
			profitTop10ChartOption: null,
			needPo: 0,
			needOverseasOutbound: 0,
			needDomesticOutbound: 0,
			needPriceAdjust: 0,
			salesAmount: 0,
			marginAmount: 0,
			monthlyCntOver0: 0,
			stockDangerCnt: 0,
			overStockCnt: 0,

			입고기간: "",
			최소재고기간: "",
			최대재고기간: "",
			MOQ수량: "",
			배대지입고기간: "",
			통관중입고기간: "",
			국내입고기간: "",
			// 설정 일괄변경용 변수들
			설정일괄변경: {
				입고기간: null,
				배대지입고기간: null,
				통관중입고기간: null,
				국내입고기간: null,
				최소재고기간: null,
				최대재고기간: null,
				MOQ수량: null
			},
			// 재고 일괄변경용 변수들
			재고일괄변경: {
				구매: null,
				배대지: null,
				통관중: null,
				국내재고: null
			},
			// 모달창 선택된 아이템들
			settingsSelectedItems: [],
			inventorySelectedItems: [],
			// 모달 필터링용 변수
			inventoryFilteredVendorItemId: null, // 재고관리 모달에서 특정 상품만 표시
			settingsFilteredVendorItemId: null, // 설정관리 모달에서 특정 상품만 표시
			// 모달 하이라이트용 변수
			highlightedVendorItemId: null, // 현재 하이라이트된 상품 ID

			reqlists: [],

			loadingtext: '',
			showspinner1: false,

			baseSettings: {
				safetyDays: 7,    // 안전재고일
				targetDays: 27,   // 목표재고일
				inputDays: 17,     // 기본입고기간
				maxOrderDays: 20,  // 최대주문일수 (targetDays - safetyDays)
				moqQuantity: 2,   // MOQ 기본 수량
				overseasInputDays: 10,  // 배대지입고기간 (배대지→국내)
				customsInputDays: 3,    // 통관중입고기간 (통관중→국내)
				domesticInputDays: 3    // 국내입고기간 (국내→쿠팡센터)
			},
			showReturnProducts: false,
			showBundleProducts: false,
			showStockPeriodFirst: false,
			showStockAmount: false,
			showSalesTrend: false,
			salesChartReady: false,
			returnProducts: 0,
			hiddenProducts: 0,
			isShowingHidden: false,
			selectedInboundData: null,
			inventoryMemos: {}, // 재고별 메모 저장
			showOrderModal: false,
			orderModalData: null,
			totalCnt: 0,

			showuploadspinner: false,
			uploadstatus: 'excel file upload',
			uploadstatus2: 'excel file upload',
			currentUploadType: '', // 'vendorItemId' 또는 'barcode'

			salesarr: [],
			importarr: [],
			stockarr: [],

			salescnt: 0,
			importcnt: 0,
			productqty: 0,
			needReturn: 0,


			title: "로켓배송 공급관리(SCM)",
			desc1: "로켓배송의 판매현황을 확인하고 수요에 맞는 공급관리(SCM)를 진행하세요",
			desc2: "입고기간 : 입고하는 데까지 걸리는 기간",
			desc3: "최소재고기간 : 최소한의 재고가 남아있어야 하는 기간, 최대재고기간 : 구매 시 필요한 재고기준 기간",
			desc4: "",
			link: { name: 'people.addusers' },
			linktext: "로켓배송 판매현황 수집",

			SKUID: '',
			showspinner: false,
			startdate: this.getTodaywith(),
			enddate: this.getTodaywith(),
			saleslists: [],
			saleslistsinit: [],
			showlist: false,

			// ✅ 사용자 지정 날짜 범위 수집용 변수들
			customStartDate: '',
			customEndDate: '',

			showChart: false,
			conversionChartOption: null,  // 추가
			maxCpcChartOption: null,      // 추가
			selectedPeriod: 30,
			dailyStats: [],
			revenueChartOption: {
				chart: {
					type: 'line',
					height: 350,
					animations: {
						enabled: false
					},
					toolbar: {
						show: false
					},
					background: 'transparent'
				},
				series: [{
					name: '매출',
					type: 'line',
					data: []
				}, {
					name: '수익',
					type: 'line',
					data: []
				}],
				stroke: {
					curve: 'smooth',
					width: [2, 2]
				},
				colors: ['#008FFB', '#00E396'],
				dataLabels: {
					enabled: false
				},
				grid: {
					show: true,
					borderColor: '#e0e0e0',
					strokeDashArray: 0,
					position: 'back'
				},
				xaxis: {
					type: 'category',
					categories: [],
					labels: {
						rotate: -45,
						rotateAlways: false,
						style: {
							fontSize: '12px'
						}
					},
					axisBorder: {
						show: true
					},
					axisTicks: {
						show: true
					}
				},
				yaxis: {
					labels: {
						formatter: (value) => `￦${this.formatNumber(value)}`,
						style: {
							fontSize: '12px'
						}
					}
				},
				tooltip: {
					enabled: true,
					shared: true,
					intersect: false,
					y: {
						formatter: (value) => `￦${this.formatNumber(value)}`
					}
				},
				legend: {
					position: 'top',
					horizontalAlign: 'right',
					floating: true,
					offsetY: -25,
					offsetX: -5
				}
			}
		}
	},
	computed: {
		// 오늘자 판매현황 수집 상태 (Toast 메시지 로직과 동일)
		todayCollectionStatus() {
			// 판정한 날짜를 그대로 적는다. getTodayString() 은 반응형이 아니라 computed 가 캐시하면
			// 탭을 다음 날까지 열어 두었을 때 전날 날짜가 남는다(#64 툴팁 「오늘(10-07)」)
			const today = this.collectionCheckDate || this.getTodayString();

			// Toast 메시지 표시 여부와 반대로 수집 상태 결정
			const isCollected = !this.todayCollectionNeeded;

			return {
				isCollected: isCollected,
				buttonText: isCollected ? '판매현황 수집완료' : '판매현황 수집필요',
				tooltip: isCollected
					? `오늘(${today}) 판매현황이 수집되었습니다.`
					: `오늘(${today}) 판매현황을 수집해주세요!\n매일 루틴으로 수집이 필요합니다.`
			};
		},
		headers() {
			let headers = [...this.baseHeaders];

			// 반품상품보기 또는 번들보기가 ON일 때 상품구분 컬럼 추가
			if (this.showReturnProducts || this.showBundleProducts) {
				console.log('상품구분 컬럼 추가됨 - showReturnProducts:', this.showReturnProducts, 'showBundleProducts:', this.showBundleProducts);
				headers.unshift({ text: '상품\n구분', value: '상품구분', align: 'center', width: 60, isSlot: true });
			} else {
				console.log('상품구분 컬럼 제외됨 - showReturnProducts:', this.showReturnProducts, 'showBundleProducts:', this.showBundleProducts);
			}

			// 재고금액보기가 ON일 때 재고 관련 컬럼들의 width 조정
			if (this.showStockAmount) {
				const stockColumns = ['구매', '배대지', '통관중', '장기입고중', '단기입고중', '국내재고', '재고', '남은재고기간'];
				headers = headers.map(header => {
					if (stockColumns.includes(header.value)) {
						return { ...header, width: Math.max(header.width || 60, 100) };
					}
					return header;
				});
			}
				// 판매트렌드 토글이 OFF이면 관련 컬럼 제거
				// 판매트렌드 토글이 ON이면 최근 7일 날짜 컬럼을 판매트렌드 앞에 추가
				if (this.showSalesTrend) {
					const trendIndex = headers.findIndex(header => header.value === '판매변화');
					if (trendIndex !== -1) {
						const recent7Headers = this.getRecent7DaysHeaders();
						headers.splice(trendIndex, 0, ...recent7Headers);
					}
				}

				if (!this.showSalesTrend) {
					const trendColumns = [
						'월판매수량',
						'7일판매수량',
						'판매변화',
						'recentDay6',
						'recentDay5',
						'recentDay4',
						'recentDay3',
						'recentDay2',
						'recentDay1',
						'recentDay0'
					];
					headers = headers.filter(header => !trendColumns.includes(header.value));
				}


			return headers;
		},
		// 발주서 SKUID/바코드 → 매칭 발주서 목록 Map (O(1) 조회)
		polistMap() {
			const map = new Map(); // key: SKUID, value: [{ 발주번호, 발주일시, 입고예정일, 발주센터, 확정수량, 발주상태 }]
			if (!this.$store.state.polist || this.$store.state.polist.length === 0) return map;

			this.$store.state.polist.forEach(po => {
				// 발주취소, 거래명세서 제외
				if (po.발주상태 && (po.발주상태.includes('발주취소') || po.발주상태.includes('거래명세서'))) return;

				if (po.발주세부내역 && po.발주세부내역.length > 0) {
					po.발주세부내역.forEach(detail => {
						const keys = [];
						if (detail.SKUID) keys.push(detail.SKUID);
						if (detail.바코드) keys.push(detail.바코드);

						const poInfo = {
							발주번호: po.발주번호,
							발주일시: po.발주일시,
							입고예정일: po.입고예정일,
							발주센터: po.발주센터,
							발주상태: po.발주상태,
							확정수량: parseInt(detail.확정수량) || 0,
							상품명: detail.상품명
						};

						keys.forEach(key => {
							if (!map.has(key)) map.set(key, []);
							map.get(key).push(poInfo);
						});
					});
				}
			});
			return map;
		},
		inboundDateRange() {
			if (!this.selectedInboundData || !this.selectedInboundData.inbounds) {
				return [];
			}

			// 모든 날짜 수집
			const dates = this.selectedInboundData.inbounds
				.map(inbound => inbound.expectedDeliveryDate)
				.filter(date => date);

			if (dates.length === 0) return [];

			// 최소, 최대 날짜 찾기
			const minDate = new Date(Math.min(...dates.map(d => new Date(d))));
			const maxDate = new Date(Math.max(...dates.map(d => new Date(d))));

			// 날짜 범위 생성 (빈 날짜도 포함)
			const dateRange = [];
			const currentDate = new Date(minDate);

			while (currentDate <= maxDate) {
				dateRange.push(currentDate.toISOString().split('T')[0]);
				currentDate.setDate(currentDate.getDate() + 1);
			}

			return dateRange;
		},
		groupedInboundData() {
			if (!this.selectedInboundData || !this.selectedInboundData.inbounds) {
				return [];
			}

			// 쿠팡센터별로 그룹화
			const fcGroups = {};

			this.selectedInboundData.inbounds.forEach(inbound => {
				const fcName = inbound.fcName;
				const date = inbound.expectedDeliveryDate;

				if (!fcGroups[fcName]) {
					fcGroups[fcName] = {
						fcName: fcName,
						dateData: {}
					};
				}

				if (date) {
					fcGroups[fcName].dateData[date] = {
						requestedQuantity: inbound.requestedQuantity || 0,
						receivedQuantity: inbound.receivedQuantity || 0,
						stowedQuantity: inbound.stowedQuantity || 0,
						status: inbound.status
					};
				}
			});

			return Object.values(fcGroups);
		},
		inboundHeaders() {
			if (!this.inboundDateRange || this.inboundDateRange.length === 0) {
				return [];
			}

			const headers = [
				{ text: '쿠팡센터', value: '쿠팡센터', align: 'center', width: 100, isSlot: true },
				{ text: '구분', value: '구분', align: 'center', width: 120, isSlot: true }
			];

			// 날짜별 컬럼 추가
			this.inboundDateRange.forEach(date => {
				headers.push({
					text: this.formatDateShort(date),
					value: date,
					align: 'center',
					width: 80
				});
			});

			return headers;
		},
		inboundTableData() {
			if (!this.groupedInboundData || this.groupedInboundData.length === 0) {
				return [];
			}

			const tableData = [];
			let id = 1;

			this.groupedInboundData.forEach(fcGroup => {
				// 수량 행 (판매개시/입고요청 형태)
				const quantityRow = {
					id: id++,
					쿠팡센터: fcGroup.fcName,
					구분: '수량'
				};
				this.inboundDateRange.forEach(date => {
					const stowed = fcGroup.dateData[date]?.stowedQuantity || 0;
					const requested = fcGroup.dateData[date]?.requestedQuantity || 0;
					quantityRow[date] = requested > 0 ? `${stowed}/${requested}` : '-';
				});
				tableData.push(quantityRow);
			});

			return tableData;
		},
		// 전체 상품의 입고 날짜 (미리 수집된 데이터 사용)
		allInboundDates() {
			return this.inboundDates;
		},
		inventoryModalHeaders() {
			let baseHeaders = [
				{ text: '이미지', value: '썸네일', align: 'center', width: 80, isSlot: true },
				{ text: '상품명/옵션명', value: '판매상품명', align: 'left', width: 150, isSlot: true },
				{ text: '구매재고', value: '구매', align: 'center', width: 120, isSlot: true },
				{ text: '배대지재고', value: '배대지', align: 'center', width: 120, isSlot: true },
				{ text: '해외입고중', value: '장기입고중', align: 'center', width: 80, isSlot: true },
				{ text: '통관중재고', value: '통관중', align: 'center', width: 120, isSlot: true },
				{ text: '국내재고', value: '국내재고', align: 'center', width: 120, isSlot: true },
				{ text: '국내입고중', value: '단기입고중', align: 'center', width: 80, isSlot: true },
				{ text: '쿠팡재고', value: '재고', align: 'center', width: 80, isSlot: true },
				{ text: '메모', value: '메모', align: 'center', width: 60, isSlot: true }
			];

			// 재고금액보기가 ON일 때 재고 관련 컬럼들의 width 조정
			if (this.showStockAmount) {
				const stockColumns = ['구매', '배대지', '통관중', '장기입고중', '단기입고중', '국내재고', '재고'];
				baseHeaders = baseHeaders.map(header => {
					if (stockColumns.includes(header.value)) {
						return { ...header, width: Math.max(header.width || 80, 140) };
					}
					return header;
				});
			}

			// 날짜별 입고 컬럼 추가 (템플릿 슬롯 사용)
			const dateHeaders = this.allInboundDates.map(date => ({
				text: this.formatDateShort(date),
				value: `inbound_${date}`,
				align: 'center',
				width: 80,
				isSlot: true
			}));

			return [...baseHeaders, ...dateHeaders];
		},
		// 날짜별 데이터가 포함된 상품 목록
		enrichedSaleslists() {
			if (!this.saleslists || this.saleslists.length === 0) {
				return [];
			}

			return this.saleslists.map(item => {
				const enrichedItem = { ...item };

				// 각 날짜별 입고 수량을 속성으로 추가
				this.allInboundDates.forEach(date => {
					const key = `inbound_${date}`;
					enrichedItem[key] = this.getInboundQuantityForDate(item, date);
				});

				return enrichedItem;
			});
		},
		// 종합 데이터가 포함된 상품 목록
		enrichedSaleslistsWithSummary() {
			const enrichedList = this.enrichedSaleslists;

			if (enrichedList.length === 0) {
				return [];
			}

			// 종합 데이터 생성
			const summaryItem = {
				vendorItemId: 'SUMMARY_ROW',
				썸네일: '',
				판매상품명: '전체 종합',
				옵션명: '',
				구매: this.totalSummary.구매,
				배대지: this.totalSummary.배대지,
				장기입고중: this.totalSummary.장기입고중,
				국내재고: this.totalSummary.국내재고,
				단기입고중: this.totalSummary.단기입고중,
				재고: this.totalSummary.재고,
				재고메모: '',
				isSummaryRow: true
			};

			// 날짜별 종합 데이터 추가
			this.allInboundDates.forEach(date => {
				const key = `inbound_${date}`;
				summaryItem[key] = this.getSummaryForDate(date);
			});

			// 종합 데이터를 맨 위에 추가
			return [summaryItem, ...enrichedList];
		},
		// 종합 데이터 없이 상품 목록만 반환
		enrichedSaleslistsWithoutSummary() {
			return this.enrichedSaleslists;
		},
		// 재고관리 모달용 필터링된 목록
		filteredInventoryList() {
			if (this.inventoryFilteredVendorItemId) {
				// 특정 상품만 필터링
				return this.enrichedSaleslistsWithoutSummary.filter(
					item => item.vendorItemId === this.inventoryFilteredVendorItemId
				);
			}
			// 전체 목록 반환
			return this.enrichedSaleslistsWithoutSummary;
		},
		// 설정관리 모달용 필터링된 목록
		filteredSettingsList() {
			if (this.settingsFilteredVendorItemId) {
				// 특정 상품만 필터링
				return this.saleslists.filter(
					item => item.vendorItemId === this.settingsFilteredVendorItemId
				);
			}
			// 전체 목록 반환
			return this.saleslists;
		},
		// 재고관리 모달의 subheader 데이터
		inventorySubheaderData() {
			if (!this.saleslists || this.saleslists.length === 0) {
				return [];
			}

			const subheaderData = [];

			// 헤더 순서에 맞춰 subheader 데이터 생성
			this.inventoryModalHeaders.forEach(header => {
				switch (header.value) {
					case '썸네일':
						subheaderData.push({ text: '', isSlot: true });
						break;
					case '판매상품명':
						subheaderData.push({ text: '', isSlot: true });
						break;
					case '구매':
					case '배대지':
					case '장기입고중':
					case '통관중':
					case '국내재고':
					case '단기입고중':
					case '재고':
						subheaderData.push({ text: '', isSlot: true });
						break;
					case '메모':
						subheaderData.push({ text: '', isSlot: true });
						break;
					default:
						// 입고 날짜 컬럼들
						if (header.value.startsWith('inbound_')) {
							subheaderData.push({ text: '', isSlot: true });
						} else {
							subheaderData.push({ text: '' });
						}
						break;
				}
			});

			return subheaderData;
		},
		// 전체 재고 종합 데이터
		totalSummary() {
			if (!this.saleslists || this.saleslists.length === 0) {
				return {
					구매: 0,
					배대지: 0,
					장기입고중: 0,
					통관중: 0,
					국내재고: 0,
					단기입고중: 0,
					재고: 0
				};
			}

			return this.saleslists.reduce((sum, item) => {
				sum.구매 += item.구매 || 0;
				sum.배대지 += item.배대지 || 0;
				sum.장기입고중 += item.장기입고중 || 0;
				sum.통관중 += item.통관중 || 0;
				sum.국내재고 += item.국내재고 || 0;
				sum.단기입고중 += item.단기입고중 || 0;
				sum.재고 += item.재고 || 0;
				return sum;
			}, {
				구매: 0,
				배대지: 0,
				장기입고중: 0,
				통관중: 0,
				국내재고: 0,
				단기입고중: 0,
				재고: 0
			});
		},
		orderHeaders() {
			return [
				{ text: '이미지', value: '썸네일', align: 'center', width: 80, isSlot: true },
				{ text: '상품명', value: '판매상품명', align: 'left', width: 250, isSlot: true },
				{ text: '옵션명', value: '옵션명', align: 'left', width: 200, isSlot: true },
				{ text: '노출ID', value: 'productId', align: 'center', width: 100 },
				{ text: '옵션ID', value: 'vendorItemId', align: 'center', width: 120 },
				{ text: '월판매수량', value: '월판매수량', align: 'center', width: 100 },
				{ text: '노출ID 순서', value: '노출ID순서', align: 'center', width: 120, isSlot: true },
				{ text: '옵션ID 순서', value: '옵션ID순서', align: 'center', width: 120, isSlot: true }
			];
		},
		productCount() {
			return this.saleslistsinit.length;
		},
		monthlyRevenue() {
			return this.dailyStats.reduce((sum, day) => sum + day.revenue, 0);
		},
		monthlyProfit() {
			return this.dailyStats.reduce((sum, day) => sum + day.profit, 0);
		},
		profitRate() {
			return this.monthlyRevenue ?
				((this.monthlyProfit / this.monthlyRevenue) * 100).toFixed(1) : 0;
		},
		bestRevenue() {
			return Math.max(...this.dailyStats.map(day => day.revenue));
		},
		bestProfit() {
			return Math.max(...this.dailyStats.map(day => day.profit));
		},
		bestRevenueDate() {
			const bestDay = this.dailyStats.find(day => day.revenue === this.bestRevenue);
			return bestDay ? this.formatDate(bestDay.date) : '-';
		},
		bestProfitDate() {
			const bestDay = this.dailyStats.find(day => day.profit === this.bestProfit);
			return bestDay ? this.formatDate(bestDay.date) : '-';
		},
		averageDailyRevenue() {
			return this.dailyStats.length ?
				this.monthlyRevenue / this.dailyStats.length : 0;
		},
		revenueChartOptionWithAnnotations() {
			if (!this.revenueChartOption) return null;

			return {
				...this.revenueChartOption,
				annotations: {
					xaxis: [{
						x: this.bestRevenueDate,
						borderColor: '#008FFB',
						label: {
							text: '최고 매출',
							style: {
								background: '#008FFB',
								color: '#fff'
							}
						}
					}, {
						x: this.bestProfitDate,
						borderColor: '#00E396',
						label: {
							text: '최고 수익',
							style: {
								background: '#00E396',
								color: '#fff'
							}
						}
					}]
				}
			};
		}
	},
	async mounted() {
		try {
			// 쿠패스연동 설정 로드
			this.loadCoupassSyncSetting();

			// 발주서 자동 로드 (polist가 비어있으면)
			if (!this.$store.state.polist || this.$store.state.polist.length === 0) {
				await this.loadPolist();
			}
			await this.search();
			this.applyDefaultSort();
		} catch (error) {
			console.error('mounted 훅 실행 중 오류:', error);
		}

		this.messageEventHandler = async (event) => {
			// 전체 수집 응답 처리
			if (event.data.msg && event.data.msg === 'rocketSales') {
				if (event.data.res === 'success') {
					this.showlist = false;
					this.loadingtext = '수집 상품 저장 중 ...';

					const stockInfo = event.data.stockInfo.filter(e => e?.listingDetails?.skuGrade == 'NEW');
					const returnList = event.data.stockInfo.filter(e => e?.listingDetails && e?.listingDetails?.skuGrade !== 'NEW');
					if(this.$store.state.settings[0].isSaverPack == undefined || this.$store.state.settings[0].isSaverPack != event.data.isSaverPack){
						this.saveSaverPackStatus(event.data.isSaverPack);
					}
					if (stockInfo.length > 0) {
						// ✅ 번들/반품 상품을 포함한 모든 상품의 일별 데이터 저장
						const allProductsForDailyData = [...stockInfo, ...returnList];

						// 번들 상품들도 일별 데이터에 저장하기 위해 추출
						stockInfo.forEach(item => {
							if (item.upBundlingProducts?.length > 0) {
								allProductsForDailyData.push(...item.upBundlingProducts);
							}
						});

						await this.convertAndSaveDailySalesData(allProductsForDailyData);

						// ✅ 기본 상품 정보만 저장 (trafficInfo 제거)
						const sales = [];
						for (const e of stockInfo) {
							const existingItem = this.$store.state.rocketSales.find(item => item.vendorItemId === e.vendorItemId);

							// 설정값 초기화 (기존 값 또는 기본값)
							const 입고기간 = existingItem?.입고기간 ? parseInt(existingItem.입고기간) : this.baseSettings.inputDays;
							const 최대재고기간 = existingItem?.최대재고기간 ? parseInt(existingItem.최대재고기간) : this.baseSettings.targetDays;
							const 최소재고기간 = existingItem?.최소재고기간 ? parseInt(existingItem.최소재고기간) : this.baseSettings.safetyDays;
							const MOQ수량 = existingItem?.MOQ수량 !== undefined ? parseInt(existingItem.MOQ수량) : this.baseSettings.moqQuantity;
							e.MOQ수량 = MOQ수량; // 값을 직접 할당

							// ✅ 기본 재고 정보
							const 입고중 = e.inventoryDetails?.inProgressInboundStatistics?.inProgressInboundQuantity || 0;

							// ✅ 반품 상품 연결 (구성 정보만)
							const returnProducts = returnList
							.filter(a => e.skuName && e.skuName.split(' ').every(word => a.skuName && a.skuName.includes(word)))
							.sort((a, b) => b.salePrice - a.salePrice).map(returnItem => ({
								vendorItemId: returnItem.vendorItemId,
								판매상품명: returnItem.listingDetails.vendorInventoryName,
								옵션명: returnItem.listingDetails.vendorInventoryItemName,
								productId: returnItem.listingDetails.productId,
								썸네일: "http://image1.coupangcdn.com/image/" + returnItem.listingDetails.mainImagePath,
								salePrice: returnItem.salePrice,
								skuGrade: returnItem.listingDetails.skuGrade,
								orderableQuantity: returnItem.orderableQuantity || 0,
								inventoryDetails: returnItem.inventoryDetails,
								inboundInfo: returnItem.inboundInfo
							}));

							// ✅ 번들 상품 연결 (구성 정보만)
							const upBundlingProducts = (e.upBundlingProducts || []).map(bundleItem => ({
								vendorItemId: bundleItem.vendorItemId,
								upBundlingSize: bundleItem.upBundlingSize,
								판매상품명: bundleItem.listingDetails?.vendorInventoryName || '',
								옵션명: bundleItem.listingDetails?.vendorInventoryItemName || '',
								productId: bundleItem.listingDetails?.productId || '',
								썸네일: bundleItem.listingDetails?.mainImagePath ?
									"http://image1.coupangcdn.com/image/" + bundleItem.listingDetails.mainImagePath : '',
								salePrice: bundleItem.salePrice || 0
							}));

							// ✅ 기본 상품 정보만 저장 (히스토리 데이터 제거)
							sales.push({
								썸네일: "http://image1.coupangcdn.com/image/" + e.listingDetails.mainImagePath,
								판매상품명: e.listingDetails.vendorInventoryName,
								옵션명: e.listingDetails.vendorInventoryItemName,
								productId: e.listingDetails.productId,
								vendorItemId: e.vendorItemId,
								재고: e.orderableQuantity,
								// 수집 응답에는 숨김이 없다. 기존 목록의 값을 물려주지 않으면 수집 직후 숨김이 풀려 보인다
								hidden: existingItem?.hidden || false,
								입고중,
								updateDate: e.updateDate,
								inventoryDetails: e.inventoryDetails,
								inboundInfo: e.inboundInfo,
								returnProducts,
								upBundlingProducts,
								skuGrade: 'NEW',
								입고기간,
								최대재고기간,
								최소재고기간,
								MOQ수량
							});
						}

						try {
							// ✅ 기본 상품 정보 저장 (SCM용)
							const result = await axios.post('/api/updateRocketSalesV2', sales);
							if (result.data.res === 'success') {
								this.$store.commit('rocketSalesUpdate', sales);

								// 수집 완료 후 버튼 상태 업데이트
								this.todayCollectionNeeded = false;

								// ✅ 일별 데이터에서 salesHistory 생성 후 표시
								await this.buildSalesDataFromDailySales(sales);
								this.search();
							} else {
								alert(result.data.alert);
								this.showspinner1 = false;
								this.showlist = true;
							}
						} catch (err) {
							alert(err);
							this.showspinner1 = false;
							this.showlist = true;
						}
					} else {
						alert('업데이트할 내역이 없습니다.');
						this.showspinner1 = false;
						this.showlist = true;
					}
				} else {
					alert(event.data.res);
					this.showspinner1 = false;
					this.showlist = true;
				}
			}
			if (event.data.res && event.data.res === 'productdbratio') {
				if (event.data.ratio == 0) {
					this.loadingtext = event.data.text;
				} else {
					this.loadingtext = event.data.text + event.data.ratio.toFixed(0) + '%';
				}
			}
			// [수집로직 일원화] 수집 완료 시 데이터 재조회
			if (event.data.type === 'manualCollectComplete' && event.data.itemKey === 'rocketDeliverySales') {
				this.showspinner1 = false;
				this.showlist = true;
				// 실패(예: 하루 수집 횟수 초과·쿠팡 로그인 풀림)를 말없이 넘기면 버튼만 「수집필요」로 남아
				// 사용자는 왜 안 되는지 모른다(#64). 판매장부(rocketSalesLedger)와 같은 처리
				if (event.data.success === false) {
					alert(event.data.error || '판매현황 수집에 실패했습니다.');
				}
				this.search();
			}
			// [수집로직 일원화] 진행 상태 표시
			if (event.data.type === 'autoCollectStatus') {
				this.loadingtext = event.data.message;
			}
		};
		window.addEventListener('message', this.messageEventHandler);
	},
	beforeDestroy() {
		window.removeEventListener('message', this.messageEventHandler);
	},
	methods: {
		// 발주서 매칭 조회 - SKUID와 바코드로 polistMap에서 조회
		getMatchedPOs(item) {
			if (!this.polistMap || this.polistMap.size === 0) return [];
			const matched = [];
			const seen = new Set(); // 중복 방지 (SKUID+바코드 둘 다 매칭될 수 있으므로)
			const today = new Date().toISOString().split('T')[0];
			const skuId = item.SKUID ? String(item.SKUID) : '';

			// SKUID로 조회
			if (skuId && this.polistMap.has(skuId)) {
				this.polistMap.get(skuId).forEach(po => {
					if (po.입고예정일 && po.입고예정일 < today) return; // 입고예정일 지난 건 제외
					const key = po.발주번호 + '_' + po.확정수량;
					if (!seen.has(key)) { seen.add(key); matched.push(po); }
				});
			}

			// vendorItemId → barcode로 조회
			const productItem = this.$store.state.productdb.find(g => g.vendorItemId === item.vendorItemId);
			if (productItem && productItem.barcode && this.polistMap.has(productItem.barcode)) {
				this.polistMap.get(productItem.barcode).forEach(po => {
					if (po.입고예정일 && po.입고예정일 < today) return; // 입고예정일 지난 건 건 제외
					const key = po.발주번호 + '_' + po.확정수량;
					if (!seen.has(key)) { seen.add(key); matched.push(po); }
				});
			}

			return matched;
		},
		// 발주서 데이터 로드
		async loadPolist() {
			try {
				// 최근 3개월 발주서 조회
				const today = new Date();
				const threeMonthsAgo = new Date();
				threeMonthsAgo.setMonth(today.getMonth() - 3);
				const startdate = threeMonthsAgo.toISOString().split('T')[0];
				const enddate = today.toISOString().split('T')[0];

				const res = await axios.post('/api/getPolist', { startdate, enddate, selectoption: '발주일시' });
				if (res.data.success && res.data.data) {
					this.$store.commit('polistupdate', { data: res.data.data, dateRange: { startdate, enddate } });
					console.log('발주서 자동 로드 완료:', res.data.data.length, '건');
				}
			} catch (err) {
				console.error('발주서 로드 실패:', err);
			}
		},
		async savesetting(object){
			try{
				if(object._id){
					delete object._id
				}
				var result = await axios.post('/api/savesetting',object)
				return result
			}catch(e){
				return e
			}
        },
		async saveSaverPackStatus(status){
			this.$store.state.settings[0].isSaverPack = status
			// 바꾼 칸 하나만 보낸다 — 통째로 보내면 서버 흰 목록(SAVESETTING_FIELDS)이 400
			const result = await this.savesetting({ isSaverPack: status })
			if (!(result && result.data && result.data.success)) {
				const msg = (result && result.response && result.response.data && result.response.data.message) || '세이버팩 상태를 저장하지 못했어요 — 화면을 새로고침한 뒤 다시 해 주세요.'
				console.error('세이버팩 상태 저장 실패:', msg)
				this.$bvToast.toast(msg, { title: '설정 저장', variant: 'danger', solid: true })
			}
		},

		// ===== 쿠패스연동 메서드 =====
		loadCoupassSyncSetting() {
			try {
				const settings = this.$store.state.settings;
				if (settings && settings.length > 0) {
					this.coupassSyncEnabled = settings[0].rocketCoupassSyncEnabled || false;
				} else {
					this.coupassSyncEnabled = false;
				}
			} catch (error) {
				console.error('쿠패스연동 설정 로드 오류:', error);
				this.coupassSyncEnabled = false;
			}
		},
		async saveCoupassSyncSetting(enabled) {
			try {
				const response = await this.savesetting({
					rocketCoupassSyncEnabled: enabled
				});
				if (response.data.success) {
					if (this.$store.state.settings && this.$store.state.settings.length > 0) {
						this.$store.state.settings[0].rocketCoupassSyncEnabled = enabled;
					}
				} else {
					throw new Error(response.data.message || '설정 저장 실패');
				}
			} catch (error) {
				console.error('쿠패스연동 설정 저장 오류:', error);
				throw error;
			}
		},
		async handleCoupassSyncClick(event) {
			event.preventDefault();
			if (!this.coupassSyncEnabled) {
				this.coupassSyncConfirmModal.show = true;
			} else {
				try {
					await this.saveCoupassSyncSetting(false);
					this.coupassSyncEnabled = false;
					this.$forceUpdate();
					this.$bvToast.toast('쿠패스연동이 비활성화되었습니다.', {
						title: '쿠패스연동',
						variant: 'info',
						solid: true,
						autoHideDelay: 2000
					});
				} catch (error) {
					this.$bvToast.toast('설정 저장에 실패했습니다.', {
						title: '쿠패스연동 오류',
						variant: 'danger',
						solid: true,
						autoHideDelay: 3000
					});
				}
			}
		},
		async confirmCoupassSync() {
			try {
				this.coupassSyncConfirmModal.show = false;
				await this.saveCoupassSyncSetting(true);
				this.coupassSyncEnabled = true;
				this.$forceUpdate();
				this.$bvToast.toast('쿠패스연동이 활성화되었습니다. 재고 정보가 자동으로 업데이트됩니다.', {
					title: '쿠패스연동',
					variant: 'success',
					solid: true,
					autoHideDelay: 3000
				});
				await this.search();
			} catch (error) {
				this.$bvToast.toast('설정 저장에 실패했습니다.', {
					title: '쿠패스연동 오류',
					variant: 'danger',
					solid: true,
					autoHideDelay: 3000
				});
			}
		},
		cancelCoupassSync() {
			this.coupassSyncConfirmModal.show = false;
		},
		async autoUpdateReqpurchaseStatus() {
			try {
				if (!this.saleslists || this.saleslists.length === 0) return;

				const updates = [];
				const 현재날짜 = new Date();

				for (const item of this.saleslists) {
					if (!item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) continue;

					const productItem = this.$store.state.productdb.find(g => g.vendorItemId === item.vendorItemId);
					if (!productItem || !productItem.barcode) continue;

					const barcode = productItem.barcode;
					const inbounds = item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds;
					const 국내입고기간 = parseInt(item.국내입고기간) || this.baseSettings.domesticInputDays;

					let totalStowed = 0;
					let totalRequested = 0;
					let has장기 = false;
					let has단기 = false;

					inbounds.forEach(inbound => {
						totalStowed += inbound.stowedQuantity || 0;
						totalRequested += inbound.requestedQuantity || 0;

						const 입고처리중수량 = (inbound.receivedQuantity || 0) - (inbound.stowedQuantity || 0);
						const 도착대기중수량 = inbound.inProgressQuantity || 0;
						const 실제입고중수량 = Math.max(입고처리중수량, 도착대기중수량);

						if (실제입고중수량 > 0 && inbound.expectedDeliveryDate) {
							const 입고예정일 = new Date(inbound.expectedDeliveryDate);
							const 남은일수 = Math.ceil((입고예정일 - 현재날짜) / (1000 * 60 * 60 * 24));
							if (남은일수 <= 국내입고기간) {
								has단기 = true;
							} else {
								has장기 = true;
							}
						} else if (실제입고중수량 > 0) {
							has단기 = true;
						}
					});

					let toStatus = null;
					let memo = '';

					if (totalStowed > 0 && totalStowed === totalRequested && totalRequested > 0) {
						toStatus = '쿠팡센터입고완료';
						memo = `rocketScm 자동수집 - 입고완료 (${totalStowed}/${totalRequested})`;
					} else if (has장기) {
						toStatus = '해외입고중';
						memo = `rocketScm 자동수집 - 해외입고중 (${totalStowed}/${totalRequested}, 국내입고기간=${국내입고기간}일)`;
					} else if (has단기) {
						toStatus = '국내입고중';
						memo = `rocketScm 자동수집 - 국내입고중 (${totalStowed}/${totalRequested}, 국내입고기간=${국내입고기간}일)`;
					}

					if (toStatus) {
						updates.push({ barcode, toStatus, memo });
					}
				}

				if (updates.length === 0) return;

				const response = await axios.post('/api/reqpurchase/autoUpdateFromInbound', {
					companyid: this.$store.state.user.companyid,
					updates: updates
				});

				if (response.data.요청결과 === '성공' && response.data.successCount > 0) {
					this.$bvToast.toast(`${response.data.successCount}건의 구매요청 상태가 자동으로 업데이트되었습니다.`, {
						title: '입고 상태 자동 업데이트',
						variant: 'success',
						solid: true,
						autoHideDelay: 3000
					});
				}
			} catch (error) {
				console.error('autoUpdateReqpurchaseStatus 오류:', error);
			}
		},
		openReqpurchaseDetailModal(item) {
			if (!item || !this.coupassSyncEnabled) return;

			this.reqpurchaseDetailItem = item;

			const productItem = this.$store.state.productdb.find(g => g.vendorItemId === item.vendorItemId);
			const barcode = productItem?.barcode || '';

			this.reqpurchaseDetailList = this.coupassData
				.filter(c => c.바코드 === barcode)
				.sort((a, b) => {
					const statusOrder = ['구매완료', '배송중', '배송완료', '입고작업', '출고확인대기', '재고대기', '출고요청', '출고대기', '중국재고', '국내창고입고중'];
					return statusOrder.indexOf(a.processStatus) - statusOrder.indexOf(b.processStatus);
				});

			this.showReqpurchaseDetailModal = true;
		},
		getBarcode(item) {
			if (!item) return '';
			const productItem = this.$store.state.productdb.find(g => g.vendorItemId === item.vendorItemId);
			return productItem?.barcode || '-';
		},
		getProcessStatusBadgeClass(status) {
			const map = {
				'구매전': 'badge badge-secondary',
				'협상중': 'badge badge-info',
				'입금요청': 'badge badge-warning',
				'입금완료': 'badge badge-primary',
				'구매완료': 'badge badge-success',
				'배송중': 'badge badge-info',
				'배송완료': 'badge badge-success',
				'입고작업': 'badge badge-warning',
				'출고대기': 'badge badge-primary',
				'출고요청': 'badge badge-warning',
				'중국재고': 'badge badge-info',
				'국내창고입고중': 'badge badge-info',
				'국내창고입고완료': 'badge badge-success',
				'국내입고중': 'badge badge-info',
				'쿠팡센터입고완료': 'badge badge-success',
				'해외재고': 'badge badge-warning',
				'해외입고중': 'badge badge-info'
			};
			return map[status] || 'badge badge-secondary';
		},
		// ===== 쿠패스연동 메서드 끝 =====

		// 기존 trafficInfo와 신규 trafficInfo 병합
		mergeTrafficInfo(existingTrafficInfo, newTrafficInfo) {
			const merged = JSON.parse(JSON.stringify(existingTrafficInfo)); // 깊은 복사

			// 병합할 배열 목록
			const arrayNames = ['saleSummaryByDate', 'trafficSummaryByDate', 'conversionSummaryByDate', 'adSummaryByDate'];

			arrayNames.forEach(arrayName => {
				if (newTrafficInfo[arrayName] && Array.isArray(newTrafficInfo[arrayName])) {
					// 기존 배열이 없으면 새로 생성
					if (!merged[arrayName]) {
						merged[arrayName] = [];
					}

					// 신규 데이터의 각 날짜별 데이터를 처리
					newTrafficInfo[arrayName].forEach(newData => {
						const existingDataIndex = merged[arrayName].findIndex(d => d.date === newData.date);

						if (existingDataIndex >= 0) {
							// 기존 날짜 데이터가 있으면 업데이트 (신규 데이터로 덮어쓰기)
							merged[arrayName][existingDataIndex] = { ...newData };
						} else {
							// 새로운 날짜 데이터면 추가
							merged[arrayName].push({ ...newData });
						}
					});

					// 날짜순으로 정렬
					merged[arrayName].sort((a, b) => new Date(a.date) - new Date(b.date));
				}
			});

			// 기타 trafficInfo 속성들도 업데이트
			Object.keys(newTrafficInfo).forEach(key => {
				if (!arrayNames.includes(key)) {
					merged[key] = newTrafficInfo[key];
				}
			});

			return merged;
		},
		// 30일 완전한 trafficInfo 보장
		ensureComplete30DaysTrafficInfo(trafficInfo) {
			if (!trafficInfo) return null;

			// 최근 30일 날짜 배열 생성
			const today = new Date();
			const dates = [];
			for (let i = 29; i >= 0; i--) {
				const date = new Date(today);
				date.setDate(today.getDate() - i);
				dates.push(date.toISOString().split('T')[0]);
			}

			const arrayNames = ['saleSummaryByDate', 'trafficSummaryByDate', 'conversionSummaryByDate', 'adSummaryByDate'];

			arrayNames.forEach(arrayName => {
				if (!trafficInfo[arrayName]) {
					trafficInfo[arrayName] = [];
				}

				// 각 날짜에 대해 데이터가 없으면 기본값으로 채우기
				dates.forEach(date => {
					const existingData = trafficInfo[arrayName].find(d => d.date === date);
					if (!existingData) {
						// 배열별 기본 구조
						let defaultData = { date: date };

						if (arrayName === 'saleSummaryByDate') {
							defaultData = { ...defaultData, saleCount: 0, salePrice: 0 };
						} else if (arrayName === 'trafficSummaryByDate') {
							defaultData = { ...defaultData, clickCount: 0, impressionCount: 0, viewCount: 0 };
						} else if (arrayName === 'conversionSummaryByDate') {
							defaultData = { ...defaultData, conversionRate: 0, clickRate: 0 };
						}
						// adSummaryByDate 는 다른 배열과 달리 {date, 광고영역명: {지표들}} 모양이다.
						// 여기에 adCost/adSales/adClicks 같은 지표 키를 넣으면 saveAdData 가 date 아닌 키를
						// 전부 광고영역(adType)으로 승격시켜 adType 이 "adCost" 인 빈 문서가 쌓인다.
						// 광고가 없는 날은 날짜만 채운다.

						trafficInfo[arrayName].push(defaultData);
					}
				});

				// 날짜순으로 정렬
				trafficInfo[arrayName].sort((a, b) => new Date(a.date) - new Date(b.date));
			});

			return trafficInfo;
		},
		// 기존 일별판매데이터 조회
		async getExistingDailySalesData(vendorItemIds) {
			try {
				// 공통 함수를 사용해서 어제 기준 30일 날짜 범위 계산
				const todayStr = this.getTodayString();
				const dates = this.generateDatesFromUpdateDate(todayStr);

				const startDateStr = dates[0];
				const endDateStr = dates[dates.length - 1];

				console.log(`getExistingDailySalesData: 어제 기준 30일 범위 ${startDateStr} ~ ${endDateStr}`);

				// 기존 getSalesLedger API 활용
				const response = await axios.post('/api/growth/getSalesLedger', {
					startDate: startDateStr,
					endDate: endDateStr
				});

				if (response.data.res === 'success') {
					const dailySalesMap = new Map();

					// vendorItemId별로 일별 데이터 그룹화
					response.data.dailySalesData
						.filter(data => vendorItemIds.includes(data.vendorItemId))
						.forEach(dailyData => {
							if (!dailySalesMap.has(dailyData.vendorItemId)) {
								dailySalesMap.set(dailyData.vendorItemId, []);
							}
							dailySalesMap.get(dailyData.vendorItemId).push(dailyData);
						});

					return dailySalesMap;
				}
				return new Map();
			} catch (error) {
				console.error('기존 일별판매데이터 조회 중 오류:', error);
				return new Map();
			}
		},
		// 일별 판매 데이터 저장
		async saveDailySalesData(stockInfo) {
			try {
				const dailySalesData = [];
				const today = new Date().toISOString().split('T')[0];

				for (const item of stockInfo) {
					if (!item.trafficInfo) continue;

					// saleSummaryByDate에서 일별 판매 데이터 추출
					if (item.trafficInfo.saleSummaryByDate) {
						for (const saleData of item.trafficInfo.saleSummaryByDate) {
							// trafficSummaryByDate에서 해당 날짜의 트래픽 데이터 찾기
							const trafficData = item.trafficInfo.trafficSummaryByDate?.find(t => t.date === saleData.date);
							// conversionSummaryByDate에서 해당 날짜의 전환 데이터 찾기
							const conversionData = item.trafficInfo.conversionSummaryByDate?.find(c => c.date === saleData.date);

							// 광고 데이터 합계 계산
							const adSummary = this.calculateAdSummaryForDate(item.trafficInfo.adSummaryByDate, saleData.date);

							dailySalesData.push({
								vendorItemId: item.vendorItemId,
								date: saleData.date,
								updateDate: today,
								sales: {
									unitsSold: saleData.unitsSold || 0,
									gmv: saleData.gmv || 0,
									registrationType: saleData.registrationType || 'RFM'
								},
								traffic: {
									pageViews: trafficData?.pageViews || 0,
									uniqueVisitor: trafficData?.uniqueVisitor || 0,
									addToCart: conversionData?.addToCart || 0,
									orders: conversionData?.orders || 0,
									pvToOrder: conversionData?.pvToOrder || 0
								},
								adSummary: adSummary
							});
						}
					}
				}

				if (dailySalesData.length > 0) {
					const result = await axios.post('/api/growth/saveDailySales', dailySalesData);
					if (result.data.res === 'success') {
						console.log('일별 판매 데이터 저장 완료:', result.data);
					} else {
						console.error('일별 판매 데이터 저장 실패:', result.data);
					}
				}
			} catch (error) {
				console.error('일별 판매 데이터 저장 중 오류:', error);
			}
		},

		// 광고 데이터 저장
		async saveAdData(stockInfo) {
			try {
				const adData = [];
				const today = new Date().toISOString().split('T')[0];

				for (const item of stockInfo) {
					if (!item.trafficInfo?.adSummaryByDate) continue;

					for (const adDateData of item.trafficInfo.adSummaryByDate) {
						const adDetails = [];

						// 각 광고 타입별로 데이터 추출 (detail 배열 포함)
						Object.keys(adDateData).forEach(key => {
							// 값이 객체인 키만 실제 광고영역이다. 광고가 없는 날 채워지는 지표 키는 스칼라라
							// 그대로 승격시키면 adType 이 지표 이름이고 값이 전부 0인 빈 문서가 DB 에 쌓인다.
							if (key !== 'date' && adDateData[key] && typeof adDateData[key] === 'object') {
								const adTypeData = adDateData[key];
								adDetails.push({
									adType: key,
									impressions: adTypeData.impressions || 0,
									clicks: adTypeData.clicks || 0,
									cost: adTypeData.cost || 0,
									cpc: adTypeData.cpc || 0,
									detail: adTypeData.detail || [] // 🆕 detail 배열 추가
								});
							}
						});

						if (adDetails.length > 0) {
							adData.push({
								vendorItemId: item.vendorItemId,
								date: adDateData.date,
								updateDate: today,
								adDetails: adDetails
							});
						}
					}
				}

				if (adData.length > 0) {
					const result = await axios.post('/api/growth/saveAdData', adData);
					if (result.data.res === 'success') {
						console.log('광고 데이터 저장 완료:', result.data);
					} else {
						console.error('광고 데이터 저장 실패:', result.data);
					}
				}
			} catch (error) {
				console.error('광고 데이터 저장 중 오류:', error);
			}
		},

		// 광고 데이터를 chunk 단위로 저장
		async saveAdDataInChunks(stockInfo) {
			try {
				const adData = [];
				const today = new Date().toISOString().split('T')[0];

				// 데이터 준비
				for (const item of stockInfo) {
					if (!item.trafficInfo?.adSummaryByDate) continue;

					for (const adDateData of item.trafficInfo.adSummaryByDate) {
						const adDetails = [];

						Object.keys(adDateData).forEach(key => {
							// 값이 객체인 키만 실제 광고영역이다. 광고가 없는 날 채워지는 지표 키는 스칼라라
							// 그대로 승격시키면 adType 이 지표 이름이고 값이 전부 0인 빈 문서가 DB 에 쌓인다.
							if (key !== 'date' && adDateData[key] && typeof adDateData[key] === 'object') {
								const adTypeData = adDateData[key];
								adDetails.push({
									adType: key,
									impressions: adTypeData.impressions || 0,
									clicks: adTypeData.clicks || 0,
									cost: adTypeData.cost || 0,
									cpc: adTypeData.cpc || 0,
									detail: adTypeData.detail || []
								});
							}
						});

						if (adDetails.length > 0) {
							adData.push({
								vendorItemId: item.vendorItemId,
								date: adDateData.date,
								updateDate: today,
								adDetails: adDetails
							});
						}
					}
				}

				if (adData.length > 0) {
					// chunk 단위로 나누기 (50개씩)
					const CHUNK_SIZE = 50;
					const chunks = [];
					for (let i = 0; i < adData.length; i += CHUNK_SIZE) {
						chunks.push(adData.slice(i, i + CHUNK_SIZE));
					}

					// chunk별로 저장
					for (let i = 0; i < chunks.length; i++) {
						this.loadingtext = `광고 데이터 저장 중... (${i + 1}/${chunks.length})`;

						const result = await axios.post('/api/growth/saveAdData', chunks[i]);
						if (result.data.res === 'success') {
							console.log(`광고 데이터 chunk ${i + 1}/${chunks.length} 저장 완료`);
						} else {
							console.error(`광고 데이터 chunk ${i + 1} 저장 실패:`, result.data);
						}
					}

					this.loadingtext = '광고 데이터 저장 완료';
				}
			} catch (error) {
				console.error('광고 데이터 저장 중 오류:', error);
				this.loadingtext = '광고 데이터 저장 오류 발생';
			}
		},

		// ✅ 새로운 메서드: trafficInfo를 일별 데이터로 변환하여 저장
		async convertAndSaveDailySalesData(allProducts) {
			try {
				// 1. 일별 판매 데이터 저장 (개별 상품별)
				await this.saveDailySalesOnly(allProducts);

				// 2. 광고 데이터 별도 저장
				await this.saveAdDataInChunks(allProducts);

				console.log('모든 일별 데이터 저장 완료');
			} catch (error) {
				console.error('일별 데이터 변환/저장 중 오류:', error);
				this.loadingtext = '데이터 저장 오류 발생';
			}
		},

		// ✅ 새로운 메서드: 일별 판매 데이터만 저장 (광고 데이터 제외)
		async saveDailySalesOnly(allProducts) {
			try {
				const dailySalesData = [];
				const today = new Date().toISOString().split('T')[0];

				for (const item of allProducts) {
					if (!item.trafficInfo) continue;

					if (item.trafficInfo.saleSummaryByDate) {
						for (const saleData of item.trafficInfo.saleSummaryByDate) {
							const trafficData = item.trafficInfo.trafficSummaryByDate?.find(t => t.date === saleData.date);
							const conversionData = item.trafficInfo.conversionSummaryByDate?.find(c => c.date === saleData.date);
							const adSummary = this.calculateAdSummaryForDate(item.trafficInfo.adSummaryByDate, saleData.date);

							dailySalesData.push({
								vendorItemId: item.vendorItemId,
								date: saleData.date,
								updateDate: today,
								sales: {
									unitsSold: saleData.unitsSold || 0,
									saleCount: saleData.saleCount || 0,
									salePrice: saleData.salePrice || 0,
									gmv: saleData.gmv || 0,
									registrationType: saleData.registrationType || 'RFM'
								},
								traffic: {
									pageViews: trafficData?.pageViews || 0,
									uniqueVisitor: trafficData?.uniqueVisitor || 0,
									clickCount: trafficData?.clickCount || 0,
									impressionCount: trafficData?.impressionCount || 0
								},
								conversion: {
									addToCart: conversionData?.addToCart || 0,
									orders: conversionData?.orders || 0,
									conversionRate: conversionData?.conversionRate || 0,
									clickRate: conversionData?.clickRate || 0,
									pvToOrder: conversionData?.pvToOrder || 0
								},
								adSummary: adSummary
							});
						}
					}
				}

				if (dailySalesData.length > 0) {
					// chunk 단위로 나누기 (100개씩)
					const CHUNK_SIZE = 100;
					const chunks = [];
					for (let i = 0; i < dailySalesData.length; i += CHUNK_SIZE) {
						chunks.push(dailySalesData.slice(i, i + CHUNK_SIZE));
					}

					// chunk별로 저장
					for (let i = 0; i < chunks.length; i++) {
						this.loadingtext = `일별 판매 데이터 저장 중... (${i + 1}/${chunks.length})`;

						const result = await axios.post('/api/growth/saveDailySales', chunks[i]);
						if (result.data.res === 'success') {
							console.log(`일별 판매 데이터 chunk ${i + 1}/${chunks.length} 저장 완료`);
						} else {
							console.error(`일별 판매 데이터 chunk ${i + 1} 저장 실패:`, result.data);
						}
					}

					this.loadingtext = '일별 판매 데이터 저장 완료';
				}
			} catch (error) {
				console.error('일별 판매 데이터 저장 중 오류:', error);
				this.loadingtext = '일별 판매 데이터 저장 오류 발생';
			}
		},

		// ✅ 새로운 메서드: 일별 데이터에서 salesHistory 등 생성
		async buildSalesDataFromDailySales(arr) {
			if (!arr || arr.length === 0) {
				console.warn('buildSalesDataFromDailySales: arr이 비어있습니다.');
				return;
			}
			try {
				// 어제 기준 30일 날짜 범위 계산
				const todayStr = this.getTodayString();
				const dates = this.generateDatesFromUpdateDate(todayStr);

				const startDateStr = dates[0];
				const endDateStr = dates[dates.length - 1];

				// 전일 재고 비교용으로 하루 전 날짜도 필요
				const prevStartDate = new Date(startDateStr);
				prevStartDate.setDate(prevStartDate.getDate() - 1);
				const prevStartDateStr = prevStartDate.toISOString().split('T')[0];

				console.log(`buildSalesDataFromDailySales: 어제 기준 30일 범위 ${startDateStr} ~ ${endDateStr}`);

				// Sales + supplylist 데이터 조회 (Vuex 캐시 우선, rocketSalesLedger와 동일 방식)
				let salesData, supplyData;

				const cachedSales = this.$store.state.sales || [];
				const cachedSupply = this.$store.state.supply || [];

				// 캐시된 Sales 날짜 범위가 필요 범위를 커버하는지 확인
				if (cachedSales.length >= 2) {
					const cachedDates = cachedSales.map(s => s.date).sort();
					const cachedStart = cachedDates[0];
					const cachedEnd = cachedDates[cachedDates.length - 1];

					if (cachedStart <= prevStartDateStr && cachedEnd >= endDateStr) {
						console.log(`Vuex 캐시에서 Sales/Supply 데이터 사용 (${cachedStart} ~ ${cachedEnd})`);
						salesData = cachedSales;
						supplyData = cachedSupply;
					}
				}

				if (!salesData) {
					const [salesResult, supplyResult] = await Promise.all([
						axios.post('/api/listsales', {
							companyid: this.$store.state.user.companyid,
							start: prevStartDateStr,
							end: endDateStr
						}),
						axios.post('/api/listsales/supplylist', {
							companyid: this.$store.state.user.companyid,
							start: startDateStr,
							end: endDateStr
						})
					]);

					salesData = salesResult.data.sales || [];
					supplyData = supplyResult.data.supply || [];

					// Vuex에 커밋 (다른 페이지에서 재사용 가능)
					this.$store.commit('salesupdate', salesData);
					this.$store.commit('supplyupdate', supplyData);
				}

				console.log(`buildSalesDataFromDailySales: Sales ${salesData.length}일, Supply ${supplyData.length}일`);

				if (salesData.length < 2) {
					console.log('판매 데이터가 2일 미만 - 일별 판매량 계산 불가');
					arr.forEach(item => {
						item.dates = dates;
						item.salesHistory = dates.map(() => 0);
						item.visitorHistory = dates.map(() => 0);
						item.pageViewHistory = dates.map(() => 0);
						item.cartHistory = dates.map(() => 0);
						item.orderHistory = dates.map(() => 0);
						item.pvToOrder = dates.map(() => 0);
						item.월판매수량 = 0;
						item.일판매수량 = 0;
						item['7일판매수량'] = 0;
						item.판매변화 = 0;
						item.currentMonthlyClicks = 0;
						item.prevMonthlyClicks = 0;
					});
					return;
				}

				// 날짜별 인덱싱
				const salesByDate = {};
				salesData.forEach(s => { salesByDate[s.date] = s; });

				const supplyByDate = {};
				supplyData.forEach(s => { supplyByDate[s.importdate] = s; });

				// SKUID → vendorItemId 맵 생성
				const skuToVendorMap = {};
				arr.forEach(item => {
					if (item.SKUID) {
						skuToVendorMap[item.SKUID] = item.vendorItemId;
					}
				});

				// vendorItemId별 일별 판매량 계산 (processRocketSalesLedgerV3 공식 동일)
				const vendorDailySales = {}; // { vendorItemId: { date: 판매량 } }
				const allSalesDates = Object.keys(salesByDate).sort();

				for (let i = 1; i < allSalesDates.length; i++) {
					const prevDate = allSalesDates[i - 1];
					const currDate = allSalesDates[i];

					// dates 범위 밖의 날짜는 건너뜀
					if (currDate < startDateStr || currDate > endDateStr) continue;

					const prevSales = salesByDate[prevDate];
					const currSales = salesByDate[currDate];

					if (!prevSales || !currSales || !currSales.판매세부내역) continue;

					currSales.판매세부내역.forEach(detail => {
						const skuId = detail.sk;
						const vendorItemId = skuToVendorMap[skuId];
						if (!vendorItemId) return;

						// 전날/당일 재고
						const prevDetail = prevSales.판매세부내역?.find(d => d.sk === skuId);
						const prevStock = prevDetail ? (prevDetail.s || 0) : 0;
						const currStock = detail.s || 0;

						// 당일 입고량
						let 입고량 = 0;
						const supplyDay = supplyByDate[currDate];
						if (supplyDay?.importlist) {
							const importItem = supplyDay.importlist.find(imp =>
								imp.sku번호?.toString() === skuId.toString()
							);
							if (importItem) 입고량 = parseInt(importItem.수량 || 0);
						}

						// 일별 판매량 = 전날재고 + 당일입고 - 당일재고
						const 판매량 = prevStock + 입고량 - currStock;
						if (판매량 <= 0 && 입고량 <= 0) return;

						if (!vendorDailySales[vendorItemId]) {
							vendorDailySales[vendorItemId] = {};
						}
						// 같은 vendorItemId에 여러 SKUID가 있을 수 있으므로 합산
						vendorDailySales[vendorItemId][currDate] =
							(vendorDailySales[vendorItemId][currDate] || 0) + Math.max(0, 판매량);
					});
				}

				// 각 상품별 salesHistory 생성
				arr.forEach(item => {
					const dailySales = vendorDailySales[item.vendorItemId] || {};

					let salesHistory = dates.map(date => dailySales[date] || 0);

					// 로켓배송은 트래픽 데이터 없음 - 0으로 설정
					let visitorHistory = dates.map(() => 0);
					let pageViewHistory = dates.map(() => 0);
					let cartHistory = dates.map(() => 0);
					let orderHistory = dates.map(() => 0);
					let pvToOrder = dates.map(() => 0);

					// 번들 상품 합산 처리
					if (item.upBundlingProducts?.length > 0) {
						item.upBundlingProducts.forEach(bundle => {
							const bundleDailySales = vendorDailySales[bundle.vendorItemId] || {};
							const bundleSize = bundle.upBundlingSize || 1;

							bundle.salesHistory = dates.map(date => bundleDailySales[date] || 0);
							bundle.visitorHistory = dates.map(() => 0);
							bundle.pageViewHistory = dates.map(() => 0);
							bundle.cartHistory = dates.map(() => 0);
							bundle.orderHistory = dates.map(() => 0);
							bundle.pvToOrder = dates.map(() => 0);

							// 번들 데이터를 메인 상품에 합산
							dates.forEach((date, index) => {
								salesHistory[index] += (bundleDailySales[date] || 0) * bundleSize;
							});

							bundle.unitsSoldForLast30Days = bundle.salesHistory.reduce((sum, val) => sum + val, 0) * bundleSize;
							bundle.dailySales = bundle.unitsSoldForLast30Days / 30;
						});
					}

					// 반품 상품 처리 (연결만 하고 합산하지 않음)
					if (item.returnProducts?.length > 0) {
						item.returnProducts.forEach(returnProduct => {
							const returnDailySales = vendorDailySales[returnProduct.vendorItemId] || {};

							returnProduct.salesHistory = dates.map(date => returnDailySales[date] || 0);
							returnProduct.visitorHistory = dates.map(() => 0);
							returnProduct.pageViewHistory = dates.map(() => 0);
							returnProduct.cartHistory = dates.map(() => 0);
							returnProduct.orderHistory = dates.map(() => 0);
						});
					}

					// 최종 데이터 설정
					item.dates = dates;
					item.salesHistory = salesHistory;
					item.visitorHistory = visitorHistory;
					item.pageViewHistory = pageViewHistory;
					item.cartHistory = cartHistory;
					item.orderHistory = orderHistory;
					item.pvToOrder = pvToOrder;

					// 계산된 값들 (어제까지 30일치)
					const salesForCalculation = salesHistory.length > 30 ? salesHistory.slice(0, 30) : salesHistory;

					item.월판매수량 = salesForCalculation.reduce((sum, val) => sum + val, 0);
					item.일판매수량 = item.월판매수량 / 30;

					// 7일 판매 데이터 계산 (최근 7일)
					const salesFor7Days = salesForCalculation.slice(-7);
					item['7일판매수량'] = salesFor7Days.reduce((sum, val) => sum + val, 0);
					const 일평균7일 = item['7일판매수량'] / 7;
					const 일평균30일 = item.일판매수량;

					if (일평균30일 > 0) {
						item.판매변화 = ((일평균7일 - 일평균30일) / 일평균30일) * 100;
					} else {
						item.판매변화 = 0;
					}

					item.currentMonthlyClicks = 0;
					item.prevMonthlyClicks = 0;
				});

				console.log('일별 데이터 기반 salesHistory 생성 완료 (Sales+supplylist 기반)');
			} catch (error) {
				console.error('일별 데이터 기반 salesHistory 생성 중 오류:', error);
			}
		},

		// 특정 날짜의 광고 데이터 합계 계산
		calculateAdSummaryForDate(adSummaryByDate, targetDate) {
			if (!adSummaryByDate) return { totalCost: 0, totalClicks: 0, totalImpressions: 0, totalOrders: 0, totalUnits: 0 };

			const targetDateFormatted = targetDate.replace(/-/g, '');
			const adDataForDate = adSummaryByDate.find(ad => ad.date === targetDateFormatted);

			if (!adDataForDate) return { totalCost: 0, totalClicks: 0, totalImpressions: 0, totalOrders: 0, totalUnits: 0 };

			let totalCost = 0, totalClicks = 0, totalImpressions = 0, totalOrders = 0, totalUnits = 0;

			Object.keys(adDataForDate).forEach(key => {
				if (key !== 'date') {
					const adTypeData = adDataForDate[key];
					totalCost += adTypeData.cost || 0;
					totalClicks += adTypeData.clicks || 0;
					totalImpressions += adTypeData.impressions || 0;
					totalOrders += adTypeData.orders || 0;
					totalUnits += adTypeData.units || 0;
				}
			});

			return { totalCost, totalClicks, totalImpressions, totalOrders, totalUnits };
		},

		// 특정 날짜의 입고 수량 가져오기 (30/30 형태) - 여러 센터 데이터 집계
		getInboundQuantityForDate(item, date) {
			if (!item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
				return '';
			}

			// 같은 날짜의 모든 센터 데이터를 찾아서 집계
			const inbounds = item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds
				.filter(inb => inb.expectedDeliveryDate === date);

			if (!inbounds || inbounds.length === 0) return '';

			let totalStowed = 0;
			let totalRequested = 0;

			inbounds.forEach(inbound => {
				totalStowed += inbound.stowedQuantity || 0;
				totalRequested += inbound.requestedQuantity || 0;
			});

			// 둘 다 0이면 빈 문자열 반환
			if (totalStowed === 0 && totalRequested === 0) return '';

			const result = `${totalStowed}/${totalRequested}`;
			// console.log(`날짜 ${date}, 상품 ${item.vendorItemId}: ${result} (${inbounds.length}개 센터)`);
			return result;
		},
		// 입고 상태에 따른 색상 클래스 반환
		getInboundStatusClass(item, date) {
			if (!item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
				return '';
			}

			const inbound = item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds
				.find(inb => inb.expectedDeliveryDate === date);

			if (!inbound) return '';

			const stowed = inbound.stowedQuantity || 0;
			const requested = inbound.requestedQuantity || 0;

			// 둘 다 0이면 기본
			if (stowed === 0 && requested === 0) return '';

			// 입고 완료 (10/10)
			if (stowed === requested && requested > 0) {
				return 'bg-success text-white';
			}
			// 부분 입고 (11/12)
			else if (stowed > 0 && stowed < requested) {
				return 'bg-warning text-dark';
			}
			// 입고 전 (0/12)
			else if (stowed === 0 && requested > 0) {
				return 'bg-danger text-white';
			}

			return '';
		},
		// 특정 날짜의 전체 종합 수량 계산
		getSummaryForDate(date) {
			if (!this.saleslists || this.saleslists.length === 0) {
				return '';
			}

			let totalStowed = 0;
			let totalRequested = 0;

			this.saleslists.forEach(item => {
				if (item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
					const inbound = item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds
						.find(inb => inb.expectedDeliveryDate === date);

					if (inbound) {
						totalStowed += inbound.stowedQuantity || 0;
						totalRequested += inbound.requestedQuantity || 0;
					}
				}
			});

			// 둘 다 0이면 빈 문자열 반환
			if (totalStowed === 0 && totalRequested === 0) return '';

			return `${totalStowed}/${totalRequested}`;
		},
		// 전체 종합의 특정 날짜 입고 상태 색상 클래스 반환
		getSummaryStatusClass(date) {
			if (!this.saleslists || this.saleslists.length === 0) {
				return '';
			}

			let totalStowed = 0;
			let totalRequested = 0;

			this.saleslists.forEach(item => {
				if (item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
					const inbound = item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds
						.find(inb => inb.expectedDeliveryDate === date);

					if (inbound) {
						totalStowed += inbound.stowedQuantity || 0;
						totalRequested += inbound.requestedQuantity || 0;
					}
				}
			});

			// 둘 다 0이면 기본
			if (totalStowed === 0 && totalRequested === 0) return '';

			// 입고 완료
			if (totalStowed === totalRequested && totalRequested > 0) {
				return 'bg-success text-white';
			}
			// 부분 입고
			else if (totalStowed > 0 && totalStowed < totalRequested) {
				return 'bg-warning text-dark';
			}
			// 입고 전
			else if (totalStowed === 0 && totalRequested > 0) {
				return 'bg-danger text-white';
			}

			return '';
		},
		// 행 클래스 설정 (종합 행 강조 + 하이라이트)
		getRowClass(item) {
			const classes = [];

			// 종합 행 스타일
			if (item.isSummaryRow) {
				classes.push('table-warning', 'font-weight-bold');
			}

			// 하이라이트 스타일
			if (this.highlightedVendorItemId && item.vendorItemId === this.highlightedVendorItemId) {
				console.log('하이라이트 클래스 적용:', item.vendorItemId);
				classes.push('highlighted-row');
			}

			return classes.join(' ');
		},
		// 입고 날짜 미리 수집
		collectInboundDates(arr) {
			const allDates = new Set();

			arr.forEach(item => {
				if (item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
					item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds.forEach(inbound => {
						if (inbound.expectedDeliveryDate) {
							allDates.add(inbound.expectedDeliveryDate);
						}
					});
				}
			});

			// 날짜 정렬하여 저장
			this.inboundDates = Array.from(allDates).sort((a, b) => new Date(a) - new Date(b));
			console.log('수집된 입고 날짜:', this.inboundDates);
		},
		// 입고 수량 값에 따른 스타일 클래스 반환
		getInboundStyleByValue(value, isSummaryRow) {
			if (!value) return '';

			// 기본 클래스
			let baseClass = isSummaryRow ? 'font-weight-bold' : '';

			// 값이 "숫자/숫자" 형태인지 확인
			const match = value.match(/^(\d+)\/(\d+)$/);
			if (!match) return baseClass;

			const stowed = parseInt(match[1]);
			const requested = parseInt(match[2]);

			// 입고 완료 (12/12)
			if (stowed === requested && requested > 0) {
				return `${baseClass} bg-success text-white`;
			}
			// 부분 입고 (11/12)
			else if (stowed > 0 && stowed < requested) {
				return `${baseClass} bg-warning text-dark`;
			}
			// 입고 전 (0/12)
			else if (stowed === 0 && requested > 0) {
				return `${baseClass} bg-danger text-white`;
			}

			return baseClass;
		},
		// 전체 종합 날짜 클릭 시 해당 날짜 기준으로 정렬
		sortByDateColumn(date) {
			console.log(`날짜 ${date} 클릭됨 - 2단계 정렬 시작`);

			// 해당 날짜의 입고 상태별 우선순위 정의
			const getStatusPriority = (value) => {
				if (!value) return 4; // 빈칸

				const match = value.match(/^(\d+)\/(\d+)$/);
				if (!match) return 4;

				const stowed = parseInt(match[1]);
				const requested = parseInt(match[2]);

				// 부분 입고 (11/12) - 우선순위 1 (가장 높음)
				if (stowed > 0 && stowed < requested) return 1;
				// 입고 완료 (12/12) - 우선순위 2
				if (stowed === requested && requested > 0) return 2;
				// 입고 전 (0/12) - 우선순위 3
				if (stowed === 0 && requested > 0) return 3;

				return 4; // 빈칸 - 우선순위 4 (가장 낮음)
			};

			// 해당 날짜의 총 수량 계산 (정렬용)
			const getTotalQuantity = (value) => {
				if (!value) return 0;
				const match = value.match(/^(\d+)\/(\d+)$/);
				return match ? parseInt(match[2]) : 0; // 요청 수량 기준
			};

			// 1단계: 수량 많은 순으로 정렬
			console.log('1단계: 수량별 정렬');
			this.saleslists.sort((a, b) => {
				const aValue = this.getInboundQuantityForDate(a, date);
				const bValue = this.getInboundQuantityForDate(b, date);

				const aQuantity = getTotalQuantity(aValue);
				const bQuantity = getTotalQuantity(bValue);

				return bQuantity - aQuantity; // 수량 많은 순 (내림차순)
			});

			// 2단계: 색상별로 전체 다시 정렬 (수량 무시)
			console.log('2단계: 색상별 전체 재정렬');
			this.saleslists.sort((a, b) => {
				const aValue = this.getInboundQuantityForDate(a, date);
				const bValue = this.getInboundQuantityForDate(b, date);

				const aPriority = getStatusPriority(aValue);
				const bPriority = getStatusPriority(bValue);

				console.log(`색상 우선순위 비교: A(${aValue}, 우선순위:${aPriority}) vs B(${bValue}, 우선순위:${bPriority})`);

				// 색상 우선순위만으로 정렬 (수량 무시)
				if (aPriority !== bPriority) {
					return aPriority - bPriority; // 1(부분입고) > 2(입고완료) > 3(입고전) > 4(빈칸)
				}

				// 같은 색상 내에서는 수량 많은 순
				const aQuantity = getTotalQuantity(aValue);
				const bQuantity = getTotalQuantity(bValue);

				return bQuantity - aQuantity;
			});

			console.log(`날짜 ${date} 기준 2단계 정렬 완료`);

			// 토스트 메시지로 정렬 완료 알림
			this.$bvToast.toast(`${this.formatDateShort(date)} 기준으로 정렬되었습니다.`, {
				title: '정렬 완료',
				variant: 'info',
				solid: true,
				autoHideDelay: 2000
			});
		},
		// 정렬 초기화 (모달 초기 상태로 복원)
		resetSort() {
			console.log('정렬 초기화 시작');

			// 저장된 초기 순서가 있는지 확인
			if (!this.originalSaleslistsOrder || this.originalSaleslistsOrder.length === 0) {
				console.log('저장된 초기 순서가 없습니다.');
				return;
			}

			// 초기 순서로 복원
			this.saleslists = [...this.originalSaleslistsOrder];

			console.log('정렬 초기화 완료 - 초기 상태로 정렬됨');

			// 토스트 메시지로 초기화 완료 알림
			this.$bvToast.toast('초기 상태로 정렬되었습니다.', {
				title: '정렬 초기화',
				variant: 'success',
				solid: true,
				autoHideDelay: 2000
			});
		},
		// SCM 데이터 로딩
		async loadScmData() {
			try {
				const response = await axios.post('/api/getRocketScmDB');
				if (response.data.scmdb && Array.isArray(response.data.scmdb)) {
					// vendorItemId를 키로 하여 데이터 저장
					this.scmData = response.data.scmdb.reduce((acc, item) => {
						acc[item.vendorItemId] = item;
						return acc;
					}, {});
					console.log('🔍 [DEBUG] loadScmData 완료:', {
						총개수: response.data.scmdb.length,
						샘플데이터: response.data.scmdb.slice(0, 2)
					});
				}
			} catch (error) {
				console.error('SCM 데이터 로딩 실패:', error);
			}
		},

		// 개별 필드 업데이트 (레거시 코드, 호환성을 위해 유지)
		async updateFieldValue(item, fieldName, value) {
			// 한글 필드명을 영어로 변환
			const fieldMapping = {
				'구매': 'purchase',
				'배대지': 'overseas',
				'통관중': 'customs',
				'국내재고': 'domesticStock',
				'입고기간': 'inboundPeriod',
				'최대재고기간': 'targetStockDays',
				'최소재고기간': 'safetyStockDays',
				'MOQ수량': 'moqQuantity',
				'메모': 'memo'
			};

			const apiFieldName = fieldMapping[fieldName];
			if (!apiFieldName) return;

			try {
				const response = await axios.post('/api/updateRocketScmData', {
					vendorItemId: item.vendorItemId,
					field: apiFieldName,
					value: value
				});

				if (response.data.res === 'success') {
					console.log(`${fieldName} 필드 업데이트 성공:`, response.data);
				} else {
					console.error(`${fieldName} 필드 업데이트 실패:`, response.data);
				}
			} catch (error) {
				console.error(`${fieldName} 필드 업데이트 오류:`, error);
			}
		},

		initReqLists() {
			// 선택된 상품이 있으면 장바구니에 추가
			if (this.tableSelectedItem.length > 0) {
				const newItems = this.tableSelectedItem.map(item => ({
					...item,
					구매요청수량: item.구매필요수량
				}));

				// 기존 장바구니에 없는 상품만 추가
				newItems.forEach(newItem => {
					const existingIndex = this.purchaseCart.findIndex(
						cartItem => cartItem.vendorItemId === newItem.vendorItemId
					);

					if (existingIndex === -1) {
						// 새 상품이면 추가
						this.purchaseCart.push(newItem);
					} else {
						// 이미 있는 상품이면 구매요청수량 업데이트
						this.purchaseCart[existingIndex].구매요청수량 = newItem.구매요청수량;
					}
				});

				// 선택 해제
				this.tableSelectedItem = [];
			}

			// 장바구니 내용을 reqlists에 복사
			this.reqlists = [...this.purchaseCart];
		},
		// 구매요청 장바구니 초기화
		clearPurchaseCart() {
			if (this.purchaseCart.length === 0) {
				alert('장바구니가 이미 비어있습니다.');
				return;
			}

			if (confirm(`장바구니의 ${this.purchaseCart.length}개 상품을 모두 삭제하시겠습니까?`)) {
				this.purchaseCart = [];
				this.reqlists = [];
				this.reqTableSelectedItem = [];

				// 뱃지 사라지는 애니메이션
				this.animateBadgeDisappear();
			}
		},
		// 뱃지 사라지는 애니메이션
		animateBadgeDisappear() {
			const badge = document.querySelector('#purchaseRequestBtn .badge');
			if (badge) {
				badge.style.transition = 'all 0.3s ease-out';
				badge.style.transform = 'scale(0)';
				badge.style.opacity = '0';
			}
		},
		// 구매요청 테이블용 예상재고량 계산
		getPurchasePreviewTotalStockForItem(item) {
			if (!item.구매요청수량 || item.구매요청수량 <= 0) {
				return this.getTotalAvailableStock(item);
			}

			const currentTotalStock = this.getTotalAvailableStock(item);
			const requestQuantity = parseInt(item.구매요청수량) || 0;

			return currentTotalStock + requestQuantity;
		},
		// 구매요청 테이블용 예상재고일 계산
		getPurchasePreviewStockPeriodForItem(item) {
			if (!item.구매요청수량 || item.구매요청수량 <= 0) {
				// 구매요청수량이 없으면 현재 재고기간 표시
				const currentTotalStock = this.getTotalAvailableStock(item);
				const 계산용일판매수량 = (item.목표일판매수량 && item.목표일판매수량 > 0) ? item.목표일판매수량 : item.일판매수량;

				if (계산용일판매수량 <= 0) return 0;
				return Math.floor(currentTotalStock / 계산용일판매수량);
			}

			const totalStockAfterPurchase = this.getPurchasePreviewTotalStockForItem(item);
			const 계산용일판매수량 = (item.목표일판매수량 && item.목표일판매수량 > 0) ? item.목표일판매수량 : item.일판매수량;

			if (계산용일판매수량 <= 0) return 0;

			return Math.floor(totalStockAfterPurchase / 계산용일판매수량);
		},
		// 구매요청수량 변경 시 예상재고 업데이트 (구매요청 테이블용)
		updatePurchasePreview() {
			// 실시간 계산을 위한 함수 (Vue의 반응성으로 자동 업데이트됨)
			this.$forceUpdate();
		},
		async requestpurchase($event) {
			$event.preventDefault();
			this.$bvModal.show('waitreqpurchase');
			var lists = this.reqTableSelectedItem.length > 0 ? this.reqTableSelectedItem : this.reqlists;

			if (lists.length == 0) {
				alert('구매대행요청할 상품이 없습니다.')
				this.$bvModal.hide('waitreqpurchase');
				this.$bvModal.hide('reqpurchase');
				return
			}
			var arr = [];
			console.log(lists)
			for (var i = 0; i < lists.length; i++) {
				var e = lists[i];
				var addlist = await this.addlists(e);
				arr = arr.concat(addlist);
			}
			if (arr.length == 0) {
				alert('구매대행요청할 상품이 없습니다.')
				this.$bvModal.hide('waitreqpurchase');
				this.$bvModal.hide('reqpurchase');
				return
			}
			await this.addreqlist(arr)
		},
		async addreqlist(lists) {
			console.log(lists)
			try {
				var res = await axios.post('/api/reqpurchase/addreqlist', lists)

				if (res.data.요청결과 == "저장완료") {
					if (confirm('저장이 완료되었습니다. 구매요청메뉴로 이동하시겠습니까?')) {
						this.$router.push({ name: 'nomad.reqpurchaseV0' })
					}
				} else {
					alert(res.data.요청결과);
				}
				console.log(res)
			} catch (e) {
				console.log(e)
			}
			this.$bvModal.hide('waitreqpurchase');
			this.$bvModal.hide('reqpurchase');
		},
		async addlists(e) {
			var ob = this.$store.state.productdb.find(ele => ele.vendorItemId == e.vendorItemId);
			console.log(ob)
			if (ob && ob.구매정보 && ob.구매정보.length > 0) {
				var arr = [];
				for (var obj of ob.구매정보) {
					var newObj = await this.confirmreq(obj);
					this.resetReqVolatileFields(newObj);
					newObj.reqtype = '로켓배송';
					newObj.구매요청수량 = e.구매요청수량;
					arr.push(newObj);
				}
				return arr;
			} else {
				const skuBody = ob && ob.skudetail && ob.skudetail.detail && ob.skudetail.detail.body || {};
				const 상품명 = (ob && (ob.상품명 || ob.판매상품명)) || '';
				return [{
					checked: false,
					showspinner: false,
					바코드: ob && ob.바코드,
					상품명: 상품명,
					상품명init: 상품명,
					구매링크: undefined,
					구매링크init: undefined,
					옵션1_중국어: undefined,
					옵션2_중국어: undefined,
					옵션이미지: undefined,
					매칭상태: '매칭필요',
					상품매칭: {
						옵션1_중국어: [],
						옵션2_중국어: [],
					},
					구매재고: '',
					구매요청수량: e.구매요청수량,
					판매구성수량: 1,
					묶음구성여부: false,
					묶음구성수량: '',
					묶음대상바코드: '',
					신고영문명: '',
					신고가격: '',
					HSCODE: '',
					진행현황: '구매전',
					재고동봉: true,
					등록이미지: (ob && (ob.썸네일 || ob.등록이미지)) || '',
					요청사항: '요청등록',
					reqtype: '로켓배송',
					sizeX: (ob && ob['넓이 (mm)']) || skuBody.width || 0,
					sizeY: (ob && ob['길이 (mm)']) || skuBody.length || 0,
					sizeZ: (ob && ob['높이 (mm)']) || skuBody.height || 0,
					weight: (ob && ob['중량 (g)']) || skuBody.weight || 0,
					요청내역: {
						default: true,
						poarrange: false,
						한글표시사항: true,
						barcode: true,
						sticker: false,
						stamp: false,
						tag: false,
						reqcontent: '',
						opp: false,
						LDPE: false,
						airpacking: false,
						exportType: 'box',

						masking: false,
						destination: 'coupang',
						auto: true,
					},
					한글표시사항: {
						제품명: 상품명,
						'수입원/판매원': '',
						제조원: '',
						제조국: '',
						내용량: '',
						'원료명및성분명(재질)': '',
						상품유형: '',
						사용시주의사항: '',
						사용기준: '',
						custom: '',
					},
					polists: [],
					selectpo: '',
				}]
			}
		},
		async confirmreq(obj) {
			obj.showspinner = true;
			console.log(obj)
			if (!obj.구매링크) {
				obj.showspinner = false;
				return obj
			}
			obj.구매링크init = obj.구매링크;
			obj.매칭상태 = '매칭필요'
			var item = await this.getProductInfo(obj.구매링크);
			item = item.data.result[0].result.result
			console.log(item)
			obj.item = item;

			let option1array = [];
			let option2array = [];

			if (item.productSkuInfos) {
				item.productSkuInfos.forEach((e) => {
					if (!option1array.find(option => option.name === e.skuAttributes[0].value)) {
						option1array.push({
							name: e.skuAttributes[0].value,
							imageUrl: e.skuAttributes[0].skuImageUrl ? e.skuAttributes[0].skuImageUrl : '',
						})
					}

					if (e.skuAttributes[1]) {
						if (!option2array.find(option => option.name === e.skuAttributes[1].value)) {
							option2array.push({
								name: e.skuAttributes[1].value,
								imageUrl: e.skuAttributes[1].skuImageUrl ? e.skuAttributes[1].skuImageUrl : '',
							})
						}
					} else {
						option2array = []
					}
				})
			}

			if (option1array.length === 0) {
				obj.상품매칭.옵션1_중국어 = [];
				obj.상품매칭.옵션2_중국어 = [];
				obj.옵션1_중국어 = '';
				obj.옵션2_중국어 = '';
				obj.구매재고 = item.productSaleInfo.amountOnSale;
				obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : item.productImage.images[0];
				obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : item.productImage.images[0];
				obj.매칭상태 = '매칭완료'
			} else {
				var imgUrl = '';
				if (option2array.length == 0) {
					imgUrl = option1array.find(e => e.name == obj.옵션1_중국어) ? imgUrl = option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : "";
					if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
						obj.옵션1_중국어 = undefined;
						obj.옵션이미지 = undefined;
						obj.구매재고 = 0;
					} else {
						obj.구매재고 = item.productSkuInfos.find(f => f.skuAttributes[0].value == obj.옵션1_중국어).amountOnSale;
						obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : imgUrl;
						obj.매칭상태 = '매칭완료'
					}
					obj.상품매칭.옵션1_중국어 = option1array;
					obj.상품매칭.옵션2_중국어 = [];
					obj.옵션2_중국어 = '';
					obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
				} else {
					if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
						obj.옵션1_중국어 = undefined;
						obj.옵션이미지 = undefined;
						obj.구매재고 = 0;
					} else {
						obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : option1array.find(e => e.name == obj.옵션1_중국어).imageUrl;
						if (!option2array.find(e => e.name == obj.옵션2_중국어)) {
							obj.옵션2_중국어 = undefined;
							obj.구매재고 = 0;
						} else {
							obj.구매재고 = item.productSkuInfos.find(f => f.skuAttributes[0].value == obj.옵션1_중국어 && f.skuAttributes[1].value == obj.옵션2_중국어).amountOnSale;
							imgUrl = option1array.find(e => e.name == obj.옵션1_중국어).imageUrl ? option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : (option2array.find(e => e.name == obj.옵션2_중국어).imageUrl ? option2array.find(e => e.name == obj.옵션2_중국어).imageUrl : "");
							obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : (option1array.find(e => e.name == obj.옵션1_중국어).imageUrl ? option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : (option2array.find(e => e.name == obj.옵션2_중국어).imageUrl ? option2array.find(e => e.name == obj.옵션2_중국어).imageUrl : ""));
							obj.매칭상태 = '매칭완료'
						}
					}
					obj.상품매칭.옵션1_중국어 = option1array;
					obj.상품매칭.옵션2_중국어 = option2array;
					console.log(option1array)
					console.log(option1array.find(e => e.name == obj.옵션1_중국어))
					console.log(option2array)

					obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
				}

				if (!obj.등록이미지 && !option1array.find(e => e.imageUrl) && !option1array.find(e => e.imageUrl)) {
					obj.등록이미지 = item.productImage.images[0];
				}
			}
			obj.showspinner = false;
			return obj
		},
		async getProductInfo(구매링크) {
			var productNo = 구매링크.slice(구매링크.search('offer/') + 6, 구매링크.search('.html'));
			try {
				var res = await axios.post('/api/aiPage/getProductInfo', [{ productId: parseInt(productNo) }])
				return res
			} catch (e) {
				console.log('err821' + e);
				return false
			}
		},
		formatDownload(matchType = 'vendorItemId') {
			var arr = [];
			var fileName, sheetName;

			// 매칭 타입에 따라 헤더 구성
			var myHeader;
			if (matchType === 'barcode') {
				myHeader = ["이미지링크", "상품명", "옵션명", "바코드"];
				fileName = 'SCM일괄업로드양식_바코드매칭.xlsx';
				sheetName = 'SCM일괄업로드양식_바코드';
			} else {
				myHeader = ["이미지링크", "상품명", "옵션명", "옵션ID"];
				fileName = 'SCM일괄업로드양식_옵션ID매칭.xlsx';
				sheetName = 'SCM일괄업로드양식_옵션ID';
			}

			myHeader.push('구매완료재고', '배대지재고', '통관중재고');

			myHeader.push(
				'국내재고',
				'구매입고기간', '배대지입고기간', '통관중입고기간', '국내입고기간',
				'목표재고기간', '안전재고기간',
				'MOQ수량', '목표일판매수량', '메모'
			);

			// 수정 불가능한 필드 (회색 배경으로 표시할 필드)
			// 참고: 현재 XLSX 라이브러리에서는 스타일 적용이 제한적이므로 실제로 적용되지 않음

			for (var e of this.saleslistsinit) {
				var rowData = {
					"이미지링크": e.썸네일 || "",
					"상품명": e.판매상품명 || "",
					"옵션명": e.옵션명 || "",
				};

				// 매칭 타입에 따라 다른 키 컬럼 추가
				if (matchType === 'barcode') {
					// productdb에서 바코드 정보 찾기
					const productdbItem = this.$store.state.productdb?.find(item => item.vendorItemId === e.vendorItemId);
					rowData["바코드"] = productdbItem?.barcode || "";
				} else {
					rowData["옵션ID"] = e.vendorItemId || "";
				}

				rowData["구매완료재고"] = e.구매 || 0;
				rowData["배대지재고"] = e.배대지 || 0;
				rowData["통관중재고"] = e.통관중 || 0;

				// 나머지 데이터 추가
				Object.assign(rowData, {
					"국내재고": e.국내재고 || 0,
					"구매입고기간": e.입고기간 || 0,
					"배대지입고기간": e.배대지입고기간 || 0,
					"통관중입고기간": e.통관중입고기간 || 0,
					"국내입고기간": e.국내입고기간 || 0,
					"목표재고기간": e.최대재고기간 || 0,
					"안전재고기간": e.최소재고기간 || 0,
					"MOQ수량": e.MOQ수량 || 0,
					"목표일판매수량": e.목표일판매수량 || 0,
					"메모": e.메모 || ""
				});

				arr.push(rowData);
			}

			var dataWS = XLSX.utils.json_to_sheet(arr, { header: myHeader });

			// 셀 스타일 적용
			if (!dataWS['!cols']) dataWS['!cols'] = [];

			// 열 너비 설정
			myHeader.forEach((_, i) => {
				dataWS['!cols'][i] = { width: 15 }; // 기본 너비 설정
			});

			// 특정 열 너비 조정
			dataWS['!cols'][0] = { width: 40 }; // 이미지링크
			dataWS['!cols'][1] = { width: 30 }; // 상품명
			dataWS['!cols'][2] = { width: 30 }; // 옵션명
			dataWS['!cols'][12] = { width: 30 }; // 메모

			// 스타일 적용을 위한 셀 범위 계산
			const range = XLSX.utils.decode_range(dataWS['!ref']);
			range.e['c'] = myHeader.length - 1;
			dataWS['!ref'] = XLSX.utils.encode_range(range);

			var wb = XLSX.utils.book_new();

			XLSX.utils.book_append_sheet(wb, dataWS, sheetName);
			// 엑셀 파일을 내보낸다.
			XLSX.writeFile(wb, fileName);
		},
		onInputChange(item) {
			item.isModified = true;
		},
		async onInputComplete(item) {
			if (item.isModified) {
				// 모든 관련 필드를 한 번에 업데이트
				const updateData = {
					vendorItemId: item.vendorItemId,
					purchase: parseInt(item.구매) || 0,
					overseas: parseInt(item.배대지) || 0,
					customs: parseInt(item.통관중) || 0,
					domesticStock: parseInt(item.국내재고) || 0,
					inboundPeriod: parseInt(item.입고기간) || 0,
					overseasInputDays: parseInt(item.배대지입고기간) || this.baseSettings.overseasInputDays,
					customsInputDays: parseInt(item.통관중입고기간) || this.baseSettings.customsInputDays,
					domesticInputDays: parseInt(item.국내입고기간) || this.baseSettings.domesticInputDays,
					targetStockDays: parseInt(item.최대재고기간) || 0,
					safetyStockDays: parseInt(item.최소재고기간) || 0,
					moqQuantity: parseInt(item.MOQ수량) || 0,
					boxQuantity: parseInt(item.박스인입수량) || 1,
					memo: item.메모 || '',
					targetDailySales: parseFloat(item.목표일판매수량) || 0
				};

				try {
					// 서버에 한 번의 API 호출로 모든 필드 업데이트
					const response = await axios.post('/api/batchUpdateRocketScmData', [updateData]);

					if (response.data.res === 'success') {
						console.log('🔍 [DEBUG] onInputComplete 저장 성공:', {
							vendorItemId: updateData.vendorItemId,
							저장된값: updateData
						});

						// 🔥 중요: scmData 캐시도 함께 업데이트
						if (!this.scmData[updateData.vendorItemId]) {
							this.scmData[updateData.vendorItemId] = {};
						}
						this.scmData[updateData.vendorItemId] = {
							...this.scmData[updateData.vendorItemId],
							...updateData
						};

						console.log('🔍 [DEBUG] scmData 캐시 업데이트 완료:', this.scmData[updateData.vendorItemId]);

						// 로컬 상태 업데이트 (Vue 반응성 보장)
						this.$set(item, '구매', updateData.purchase);
						this.$set(item, '배대지', updateData.overseas);
						this.$set(item, '통관중', updateData.customs);
						this.$set(item, '국내재고', updateData.domesticStock);
						this.$set(item, '입고기간', updateData.inboundPeriod);
						this.$set(item, '배대지입고기간', updateData.overseasInputDays);
						this.$set(item, '통관중입고기간', updateData.customsInputDays);
						this.$set(item, '국내입고기간', updateData.domesticInputDays);
						this.$set(item, '최대재고기간', updateData.targetStockDays);
						this.$set(item, '최소재고기간', updateData.safetyStockDays);
						this.$set(item, 'MOQ수량', updateData.moqQuantity);
						this.$set(item, '박스인입수량', updateData.boxQuantity);
						this.$set(item, '메모', updateData.memo);

						// 메트릭 재계산 및 저장
						const metrics = this.calculateInventoryMetrics(item);
						item.남은재고기간 = metrics.남은재고기간;
						item.구매필요수량 = metrics.구매필요수량;
						item.dday = metrics.dday;
						item.배대지출고Dday = metrics.배대지출고Dday;
						item.배대지출고필요수량 = metrics.배대지출고필요수량;
						item.통관중출고Dday = metrics.통관중출고Dday;
						item.통관중출고필요수량 = metrics.통관중출고필요수량;
						item.국내출고Dday = metrics.국내출고Dday;
						item.국내출고필요수량 = metrics.국내출고필요수량;

						// Series 계산값도 갱신
						item.seriesDday = this.calculateSeriesDday(item);
						item.seriesNeededQty = this.calculateSeriesNeededQty(item);
						item.seriesNeededDays = this.calculateSeriesNeededDays(item);

						// 🔥 메인 테이블(saleslists)에도 동일하게 반영
						const mainTableItem = this.saleslists.find(i => i.vendorItemId === updateData.vendorItemId);
						if (mainTableItem && mainTableItem !== item) {
							// 재고관리 모달의 item과 메인 테이블의 item이 다른 객체인 경우
							console.log('🔍 [DEBUG] 메인 테이블 업데이트 시작:', updateData.vendorItemId);
							this.$set(mainTableItem, '구매', updateData.purchase);
							this.$set(mainTableItem, '배대지', updateData.overseas);
							this.$set(mainTableItem, '통관중', updateData.customs);
							this.$set(mainTableItem, '국내재고', updateData.domesticStock);
							this.$set(mainTableItem, '입고기간', updateData.inboundPeriod);
							this.$set(mainTableItem, '배대지입고기간', updateData.overseasInputDays);
							this.$set(mainTableItem, '통관중입고기간', updateData.customsInputDays);
							this.$set(mainTableItem, '국내입고기간', updateData.domesticInputDays);
							this.$set(mainTableItem, '최대재고기간', updateData.targetStockDays);
							this.$set(mainTableItem, '최소재고기간', updateData.safetyStockDays);
							this.$set(mainTableItem, 'MOQ수량', updateData.moqQuantity);
							this.$set(mainTableItem, '박스인입수량', updateData.boxQuantity);
							this.$set(mainTableItem, '메모', updateData.memo);

							// 메인 테이블 아이템도 메트릭 재계산
							const mainMetrics = this.calculateInventoryMetrics(mainTableItem);
							mainTableItem.남은재고기간 = mainMetrics.남은재고기간;
							mainTableItem.구매필요수량 = mainMetrics.구매필요수량;
							mainTableItem.dday = mainMetrics.dday;
							mainTableItem.배대지출고Dday = mainMetrics.배대지출고Dday;
							mainTableItem.배대지출고필요수량 = mainMetrics.배대지출고필요수량;
							mainTableItem.통관중출고Dday = mainMetrics.통관중출고Dday;
							mainTableItem.통관중출고필요수량 = mainMetrics.통관중출고필요수량;
							mainTableItem.국내출고Dday = mainMetrics.국내출고Dday;
							mainTableItem.국내출고필요수량 = mainMetrics.국내출고필요수량;

							mainTableItem.seriesDday = this.calculateSeriesDday(mainTableItem);
							mainTableItem.seriesNeededQty = this.calculateSeriesNeededQty(mainTableItem);
							mainTableItem.seriesNeededDays = this.calculateSeriesNeededDays(mainTableItem);

							console.log('🔍 [DEBUG] 메인 테이블 업데이트 완료:', mainTableItem.vendorItemId);
						}

						// 🔥 saleslistsinit에도 동일하게 반영
						const initItem = this.saleslistsinit.find(i => i.vendorItemId === updateData.vendorItemId);
						if (initItem && initItem !== item) {
							// 재고관리 모달의 item과 saleslistsinit의 item이 다른 객체인 경우
							console.log('🔍 [DEBUG] saleslistsinit 업데이트 시작:', updateData.vendorItemId);
							this.$set(initItem, '구매', updateData.purchase);
							this.$set(initItem, '배대지', updateData.overseas);
							this.$set(initItem, '통관중', updateData.customs);
							this.$set(initItem, '국내재고', updateData.domesticStock);
							this.$set(initItem, '입고기간', updateData.inboundPeriod);
							this.$set(initItem, '배대지입고기간', updateData.overseasInputDays);
							this.$set(initItem, '통관중입고기간', updateData.customsInputDays);
							this.$set(initItem, '국내입고기간', updateData.domesticInputDays);
							this.$set(initItem, '최대재고기간', updateData.targetStockDays);
							this.$set(initItem, '최소재고기간', updateData.safetyStockDays);
							this.$set(initItem, 'MOQ수량', updateData.moqQuantity);
							this.$set(initItem, '박스인입수량', updateData.boxQuantity);
							this.$set(initItem, '메모', updateData.memo);

							// saleslistsinit 아이템도 메트릭 재계산
							const initMetrics = this.calculateInventoryMetrics(initItem);
							initItem.남은재고기간 = initMetrics.남은재고기간;
							initItem.구매필요수량 = initMetrics.구매필요수량;
							initItem.dday = initMetrics.dday;
							initItem.배대지출고Dday = initMetrics.배대지출고Dday;
							initItem.배대지출고필요수량 = initMetrics.배대지출고필요수량;
							initItem.통관중출고Dday = initMetrics.통관중출고Dday;
							initItem.통관중출고필요수량 = initMetrics.통관중출고필요수량;
							initItem.국내출고Dday = initMetrics.국내출고Dday;
							initItem.국내출고필요수량 = initMetrics.국내출고필요수량;

							initItem.seriesDday = this.calculateSeriesDday(initItem);
							initItem.seriesNeededQty = this.calculateSeriesNeededQty(initItem);
							initItem.seriesNeededDays = this.calculateSeriesNeededDays(initItem);

							console.log('🔍 [DEBUG] saleslistsinit 업데이트 완료:', initItem.vendorItemId);
						}
					} else {
						console.error('항목 업데이트 실패:', response.data);
					}
				} catch (error) {
					console.error('항목 업데이트 오류:', error);
				} finally {
					// 처리 완료 플래그
					item.isModified = false;
				}
			}
		},
		markAsModified(item) {
			item.isModified = true;
		},
		calculateInventoryMetrics(item) {
			// 기본 input 값 변환
			item.구매 = parseInt(item.구매) || 0;
			item.배대지 = parseInt(item.배대지) || 0;
			item.통관중 = parseInt(item.통관중) || 0;
			item.국내재고 = parseInt(item.국내재고) || 0;

			// 계산에 사용할 일판매수량 결정 (목표 일판매수량이 있으면 우선 사용)
			const 계산용일판매수량 = (item.목표일판매수량 && item.목표일판매수량 > 0) ? item.목표일판매수량 : item.일판매수량;

			// 일판매수량이 0인 경우 예외 처리
			if (계산용일판매수량 <= 0) {
				return {
					남은재고기간: 0,
					구매필요수량: 0,
					dday: -999,
					배대지출고Dday: -999,
					배대지출고필요수량: 0,
					통관중출고Dday: -999,
					통관중출고필요수량: 0,
					국내출고Dday: -999,
					국내출고필요수량: 0,
					장기입고중: 0,
					단기입고중: 0,
					쿠팡재고기간: 0
				};
			}

			// 입고중 재고 분류
			const { 장기입고중, 단기입고중 } = this.classifyInboundInventory(item);

			// 입력값들 가져오기
			const 목표재고일 = parseInt(item.최대재고기간) || this.baseSettings.targetDays;
			const 안전재고일 = parseInt(item.최소재고기간) || this.baseSettings.safetyDays;
			const 구매입고기간 = parseInt(item.입고기간) || this.baseSettings.inputDays;
			const 배대지입고기간 = parseInt(item.배대지입고기간) || this.baseSettings.overseasInputDays;
			const 국내입고기간 = parseInt(item.국내입고기간) || this.baseSettings.domesticInputDays;

			// 전체 가용재고 계산 (구매필요수량 계산용)
			const 전체가용재고 = item.구매 + item.배대지 + item.통관중 + item.국내재고 + 장기입고중 + 단기입고중 + item.재고;

			// 남은재고기간 계산 (전체 가용재고 기준)
			let 남은재고기간 = 0;
			let 잔여가용재고 = 전체가용재고;

			// 예측 데이터 선택 (AI 기반 우선)
			const forecastData = (item.forecastAI && item.forecastAI.length > 0) ?
				item.forecastAI : item.forecastSeries;

			// 예측 데이터로 계산
			for (const 예상판매량 of forecastData) {
				if (잔여가용재고 >= 예상판매량) {
					잔여가용재고 -= 예상판매량;
					남은재고기간++;
				} else {
					break;
				}
			}

			// 예측 데이터가 부족한 경우 단순 계산으로 보완
			if (잔여가용재고 > 0 && 계산용일판매수량 > 0) {
				남은재고기간 += Math.floor(잔여가용재고 / 계산용일판매수량);
			}

			// 새로운 공식으로 계산
			// 1. 구매필요수량 = 목표재고일 - 현재가용재고 + 구매입고기간 판매예상량
			const 구매입고기간판매예상 = Math.ceil(계산용일판매수량 * 구매입고기간);
			let 구매필요수량 = 목표재고일 * 계산용일판매수량 - 전체가용재고 + 구매입고기간판매예상;
			구매필요수량 = Math.max(0, Math.round(구매필요수량));

			// 2. 구매 D-Day = (구매입고기간 + 안전재고일) - 전체가용재고일수
			const 전체가용재고일수 = 전체가용재고 / 계산용일판매수량;
			let 구매Dday = Math.ceil((구매입고기간 + 안전재고일) - 전체가용재고일수);

			// 구매필요수량이 0이면 D-Day를 -999로 설정
			if (구매필요수량 === 0) {
				구매Dday = -999;
			}

			// 3. 배대지출고수량 = 목표재고일 - 하위가용재고 + 배대지입고기간 판매예상량
			const 배대지하위가용재고 = item.통관중 + item.국내재고 + 장기입고중 + 단기입고중 + item.재고;
			const 배대지입고기간판매예상 = Math.ceil(계산용일판매수량 * 배대지입고기간);
			let 배대지출고필요수량 = 목표재고일 * 계산용일판매수량 - 배대지하위가용재고 + 배대지입고기간판매예상;
			배대지출고필요수량 = Math.max(0, Math.min(Math.round(배대지출고필요수량), item.배대지));

			// 4. 배대지출고 D-Day = (배대지입고기간 + 안전재고일) - 배대지하위가용재고일수
			const 배대지하위가용재고일수 = 배대지하위가용재고 / 계산용일판매수량;
			let 배대지출고Dday = Math.ceil((배대지입고기간 + 안전재고일) - 배대지하위가용재고일수);

			// 배대지 재고가 없거나 배대지출고필요수량이 0이면 D-Day를 -999로 설정
			if (item.배대지 <= 0 || 배대지출고필요수량 === 0) {
				배대지출고Dday = -999;
			}

			// 5. 통관중출고수량 = 목표재고일 - 통관중하위가용재고 + 통관중입고기간 판매예상량
			const 통관중하위가용재고 = item.국내재고 + 장기입고중 + 단기입고중 + item.재고;
			const 통관중입고기간 = parseInt(item.통관중입고기간) || this.baseSettings.customsInputDays || 3; // 기본 3일
			const 통관중입고기간판매예상 = Math.ceil(계산용일판매수량 * 통관중입고기간);
			let 통관중출고필요수량 = 목표재고일 * 계산용일판매수량 - 통관중하위가용재고 + 통관중입고기간판매예상;
			통관중출고필요수량 = Math.max(0, Math.min(Math.round(통관중출고필요수량), item.통관중));

			// 6. 통관중출고 D-Day = (통관중입고기간 + 안전재고일) - 통관중하위가용재고일수
			const 통관중하위가용재고일수 = 통관중하위가용재고 / 계산용일판매수량;
			let 통관중출고Dday = Math.ceil((통관중입고기간 + 안전재고일) - 통관중하위가용재고일수);

			// 통관중 재고가 없거나 통관중출고필요수량이 0이면 D-Day를 -999로 설정
			if (item.통관중 <= 0 || 통관중출고필요수량 === 0) {
				통관중출고Dday = -999;
			}

			// 8. 국내출고수량 = 목표재고일 - 단기하위가용재고 + 국내입고기간 판매예상량
			const 국내하위가용재고 = 단기입고중 + item.재고;
			const 국내입고기간판매예상 = Math.ceil(계산용일판매수량 * 국내입고기간);
			let 국내출고필요수량 = 목표재고일 * 계산용일판매수량 - 국내하위가용재고 + 국내입고기간판매예상;
			국내출고필요수량 = Math.max(0, Math.min(Math.round(국내출고필요수량), item.국내재고));

			// 9. 국내출고 D-Day = (국내입고기간 + 안전재고일) - 국내하위가용재고일수
			const 국내하위가용재고일수 = 국내하위가용재고 / 계산용일판매수량;
			let 국내출고Dday = Math.ceil((국내입고기간 + 안전재고일) - 국내하위가용재고일수);

			// 국내재고가 없거나 국내출고필요수량이 0이면 D-Day를 -999로 설정
			if (item.국내재고 <= 0 || 국내출고필요수량 === 0) {
				국내출고Dday = -999;
			}

			// 10. 쿠팡재고기간 계산
			const 쿠팡재고일수 = item.재고 / 계산용일판매수량;
			const 쿠팡재고기간 = Math.floor(쿠팡재고일수);

			return {
				남은재고기간,
				구매필요수량,
				dday: 구매Dday,
				배대지출고Dday,
				배대지출고필요수량,
				통관중출고Dday,
				통관중출고필요수량,
				국내출고Dday,
				국내출고필요수량,
				장기입고중,
				단기입고중,
				쿠팡재고기간
			};
		},
		// 입고중 재고를 단기/장기로 분류
		classifyInboundInventory(item) {
			if (!item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
				return {
					단기입고중: 0,
					장기입고중: 0
				};
			}

			const 현재날짜 = new Date();
			const 국내입고기간 = parseInt(item.국내입고기간) || this.baseSettings.domesticInputDays;
			let 단기입고중 = 0;
			let 장기입고중 = 0;

			item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds.forEach(inbound => {
				if (inbound.expectedDeliveryDate) {
					let 실제입고중수량 = 0;

					// 1. 물건이 도착했지만 아직 입고 처리 중인 경우
					const 입고처리중수량 = (inbound.receivedQuantity || 0) - (inbound.stowedQuantity || 0);

					// 2. 입고 요청했지만 아직 물건이 도착하지 않은 경우
					const 도착대기중수량 = inbound.inProgressQuantity || 0;

					// 둘 중 더 큰 값을 사용 (일반적으로 하나만 0이 아님)
					실제입고중수량 = Math.max(입고처리중수량, 도착대기중수량);

					if (실제입고중수량 > 0) {
						const 입고예정일 = new Date(inbound.expectedDeliveryDate);
						const 남은일수 = Math.ceil((입고예정일 - 현재날짜) / (1000 * 60 * 60 * 24));

						if (남은일수 <= 국내입고기간) {
							단기입고중 += 실제입고중수량;
						} else {
							장기입고중 += 실제입고중수량;
						}
					}
				}
			});

			return {
				단기입고중,
				장기입고중
			};
		},
		calculateMetricsForProduct({
			가용재고,
			일판매수량,
			forecastSeries,
			forecastAI,
			입고기간,
			최대재고기간,
			최소재고기간
		}) {
			const result = {
				남은재고기간: 0,
				구매필요수량: 0,
				dday: -999
			};

			if (!일판매수량 || 일판매수량 <= 0) {
				return result;
			}

			// 예측 데이터를 사용할지 여부 결정 (AI 기반 우선)
			const forecastData = (forecastAI && forecastAI.length > 0) ? forecastAI : forecastSeries;

			// 남은재고기간 계산
			let 남은재고기간 = 0;
			let 잔여가용재고 = 가용재고;

			for (const 예상판매량 of forecastData) {
				if (잔여가용재고 >= 예상판매량) {
					잔여가용재고 -= 예상판매량;
					남은재고기간++;
				} else {
					break;
				}
			}

			result.남은재고기간 = 남은재고기간;

			// D-Day 계산
			result.dday = Math.ceil(입고기간 - (남은재고기간 - 최소재고기간));

			// 구매 필요 수량 계산
			if (남은재고기간 <= 최소재고기간) {
				// 남은재고기간 ≤ safetyDays: 목표재고일을 충족하기 위해 구매
				result.구매필요수량 = Math.ceil(this.baseSettings.targetDays * 일판매수량 - 가용재고);
			} else if (남은재고기간 < 최대재고기간) {
				// safetyDays < 남은재고기간 < targetDays: 목표재고일을 충족하기 위해 부족분 구매
				result.구매필요수량 = Math.ceil(this.baseSettings.targetDays * 일판매수량 - 가용재고);
			} else {
				// 남은재고기간 ≥ targetDays: 구매 필요 없음
				result.구매필요수량 = 0;
			}

			// 구매 필요 수량 최소값 설정 (선택적)
			result.구매필요수량 = Math.max(0, result.구매필요수량);

			return result;
		},
		updateMaxCpcChart() {
			if (!this.saleslistsinit || this.saleslistsinit.length === 0) return;

			const maxCpcData = this.saleslistsinit
				.map(item => {
					const dbItem = this.$store.state.productdb.find(x => x.vendorItemId === item.vendorItemId);
					const margin = dbItem?.마진 || 0;
					const validPvToOrder = item.pvToOrder.filter(rate => rate > 0);
					const avgConversion = validPvToOrder.length > 0
						? validPvToOrder.reduce((a, b) => a + b, 0) / validPvToOrder.length
						: 0;

					return {
						name: item.판매상품명,
						maxCpc: Math.floor((margin * (avgConversion / 100)) / 10) * 10,
						margin,
						conversion: avgConversion
					};
				})
				.filter(item => item.maxCpc > 0)
				.sort((a, b) => b.maxCpc - a.maxCpc)
				.slice(0, 10);

			this.maxCpcChartOption = {
				chart: {
					type: 'bar',
					height: 280,
					toolbar: {
						show: false
					}
				},
				series: [{
					name: '최대 CPC',
					data: maxCpcData.map(item => parseFloat(item.maxCpc.toFixed(0)))
				}],
				plotOptions: {
					bar: {
						horizontal: true,
						barHeight: '70%',
						borderRadius: 4,
						dataLabels: {
							position: 'center'
						}
					}
				},
				colors: ['#775DD0'],
				dataLabels: {
					enabled: true,
					formatter: function (value) {
						return '￦' + value.toLocaleString();
					},
					style: {
						fontSize: '12px',
						colors: ['#fff'],
						fontWeight: 'bold'
					}
				},
				xaxis: {
					categories: maxCpcData.map(item =>
						item.name.length > 20 ? item.name.substring(0, 20) + '...' : item.name
					),
					labels: {
						rotate: -45,
						maxHeight: 150,
						style: {
							fontSize: '11px'
						}
					}
				},
				legend: {
					show: false
				},
				tooltip: {
					custom: function ({ dataPointIndex }) {
						const data = maxCpcData[dataPointIndex];
						return `
							<div class="custom-tooltip" style="padding: 8px; max-width: 300px;">
								<div style="margin-bottom: 8px; word-break: break-word; line-height: 1.4;">${data.name}</div>
								<div>CPC한도: ￦${data.maxCpc.toLocaleString()}</div>
							</div>
						`;
					}
				}
			};
		},
		updateConversionChart() {
			if (!this.saleslistsinit || this.saleslistsinit.length === 0) return;

			const totalVisits = this.saleslistsinit.reduce((sum, item) => sum + item.currentMonthlyClicks, 0);

			const productData = this.saleslistsinit
				.map(item => {
					const validPvToOrder = item.pvToOrder.filter(rate => rate > 0);
					const avgPvToOrder = validPvToOrder.length > 0
						? validPvToOrder.reduce((a, b) => a + b, 0) / validPvToOrder.length
						: 0;

					const trafficShare = (item.currentMonthlyClicks / totalVisits) * 100;

					return {
						name: item.판매상품명,
						conversion: avgPvToOrder,
						traffic: trafficShare
					};
				})
				.sort((a, b) => b.conversion - a.conversion)
				.slice(0, 10);

			this.conversionChartOption = {
				chart: {
					type: 'bar',
					height: 280,
					stacked: false,
					toolbar: {
						show: false
					}
				},
				series: [{
					name: '전환율(%)',
					type: 'column',
					data: productData.map(item => parseFloat(item.conversion.toFixed(2)))
				}, {
					name: '트래픽 점유율(%)',
					type: 'line',
					data: productData.map(item => parseFloat(item.traffic.toFixed(2)))
				}],
				plotOptions: {
					bar: {
						columnWidth: '60%'
					}
				},
				dataLabels: {
					enabled: false
				},
				stroke: {
					width: [0, 3],
					curve: 'smooth'
				},
				colors: ['#00E396', '#008FFB'],
				xaxis: {
					categories: productData.map(item =>
						item.name.length > 20 ? item.name.substring(0, 20) + '...' : item.name
					),
					labels: {
						rotate: -45,
						style: {
							fontSize: '11px'
						}
					}
				},
				yaxis: [{
					title: {
						text: '전환율(%)'
					},
					min: 0
				}, {
					opposite: true,
					title: {
						text: '트래픽 점유율(%)'
					},
					min: 0
				}],
				tooltip: {
					custom: function ({ dataPointIndex }) {
						const data = productData[dataPointIndex];
						return `
							<div class="custom-tooltip" style="padding: 8px; max-width: 300px;">
								<div style="margin-bottom: 8px; word-break: break-word; line-height: 1.4;">${data.name}</div>
								<div>전환율: ${data.conversion.toFixed(2)}%</div>
								<div>트래픽 점유율: ${data.traffic.toFixed(2)}%</div>
							</div>
						`;
					}
				},
				legend: {
					position: 'top'
				}
			};
		},
		updateProfitTop10Chart() {
			if (!this.saleslistsinit || this.saleslistsinit.length === 0) return;

			const profitByProduct = this.saleslistsinit.reduce((acc, item) => {
				const dbItem = this.$store.state.productdb.find(x => x.vendorItemId === item.vendorItemId);
				const monthlyProfit = item.월판매수량 * (dbItem?.마진 || 0);

				if (!acc[item.productId]) {
					acc[item.productId] = {
						name: item.판매상품명.split('[')[0].trim(), // 옵션정보 제거
						profit: 0
					};
				}
				acc[item.productId].profit += monthlyProfit;
				return acc;
			}, {});

			// 객체를 배열로 변환하고 정렬
			const profitData = Object.values(profitByProduct)
				.filter(item => item.profit > 0)
				.sort((a, b) => b.profit - a.profit)
				.slice(0, 10);

			this.profitTop10ChartOption = {
				chart: {
					type: 'bar',
					height: 280,
					toolbar: {
						show: false
					}
				},
				series: [{
					name: '수익',
					data: profitData.map(item => item.profit)
				}],
				plotOptions: {
					bar: {
						horizontal: true,
						barHeight: '70%',
						borderRadius: 4,
						dataLabels: {
							position: 'center'
						}
					}
				},
				colors: ['#008FFB'],
				dataLabels: {
					enabled: true,
					formatter: function (value) {
						return '￦' + value.toLocaleString();
					},
					style: {
						fontSize: '12px',
						colors: ['#fff'],
						fontWeight: 'bold'
					}
				},
				xaxis: {
					categories: profitData.map(item =>
						item.name.length > 20 ? item.name.substring(0, 20) + '...' : item.name
					),
					labels: {
						rotate: -45,
						maxHeight: 150,
						style: {
							fontSize: '11px'
						}
					}
				},
				legend: {
					show: false
				},
				tooltip: {
					custom: function ({ dataPointIndex }) {
						const data = profitData[dataPointIndex];
						return `
							<div class="custom-tooltip" style="padding: 8px; max-width: 300px;">
								<div style="margin-bottom: 8px; word-break: break-word; line-height: 1.4;">${data.name}</div>
								<div>수익: ￦${data.profit.toLocaleString()}</div>
							</div>
						`;
					}
				}
			};
		},
		showAll() {
			this.showlist = false;
			this.isShowingHidden = false; // 숨김 상태 초기화
			this.tableSelectedItem = []; // 체크 초기화
			this.saleslists = [...this.saleslistsinit];
			this.applyDefaultSort();
			setTimeout(() => { this.showlist = true; }, 10);
		},
		// Series 기준 D-Day 계산
		calculateSeriesDday(item) {
			if (!item || item.일판매수량 <= 0) return -999;

			const 가용재고 = item.재고 + item.구매 + item.배대지 + item.통관중 + item.입고중 + item.국내재고;
			let series남은재고기간 = 0;
			let series잔여가용재고 = 가용재고;

			for (const 예상판매량 of item.forecastSeries) {
				if (series잔여가용재고 >= 예상판매량) {
					series잔여가용재고 -= 예상판매량;
					series남은재고기간++;
				} else {
					break;
				}
			}

			const series안전재고도달시점 = series남은재고기간 - item.최소재고기간;
			return parseInt(item.입고기간) - series안전재고도달시점;
		},
		// Series 기준 구매필요수량 계산
		calculateSeriesNeededQty(item) {
			if (!item || item.일판매수량 <= 0) return 0;

			const 가용재고 = item.재고 + item.구매 + item.배대지 + item.통관중 + item.입고중 + item.국내재고;
			let series남은재고기간 = 0;
			let series잔여가용재고 = 가용재고;

			for (const 예상판매량 of item.forecastSeries) {
				if (series잔여가용재고 >= 예상판매량) {
					series잔여가용재고 -= 예상판매량;
					series남은재고기간++;
				} else {
					break;
				}
			}

			if (series남은재고기간 <= this.baseSettings.safetyDays) {
				// 안전재고 이하면 최대주문일수만큼 구매
				const 최대주문일수 = this.baseSettings.targetDays - this.baseSettings.safetyDays;
				return Math.ceil(
					item.forecastSeries.slice(0, 최대주문일수).reduce((sum, val) => sum + val, 0)
				);
			} else if (series남은재고기간 < this.baseSettings.targetDays) {
				// 목표재고일까지 부족한 만큼 구매
				const 필요일수 = this.baseSettings.targetDays - series남은재고기간;
				const startIndex = series남은재고기간;
				const endIndex = Math.min(startIndex + 필요일수, item.forecastSeries.length);
				return Math.ceil(
					item.forecastSeries.slice(startIndex, endIndex).reduce((sum, val) => sum + val, 0)
				);
			}
			return 0;
		},
		calculateSeriesNeededDays(item) {
			if (!item || item.일판매수량 <= 0) return '0일치';

			const 가용재고 = item.재고 + item.구매 + item.배대지 + item.통관중 + item.입고중 + item.국내재고;
			let series남은재고기간 = 0;
			let series잔여가용재고 = 가용재고;

			for (const 예상판매량 of item.forecastSeries) {
				if (series잔여가용재고 >= 예상판매량) {
					series잔여가용재고 -= 예상판매량;
					series남은재고기간++;
				} else {
					break;
				}
			}

			if (series남은재고기간 <= this.baseSettings.safetyDays) {
				return `${this.baseSettings.targetDays - this.baseSettings.safetyDays}일치`;
			} else if (series남은재고기간 < this.baseSettings.targetDays) {
				return `${this.baseSettings.targetDays - series남은재고기간}일치`;
			}
			return '0일치';
		},
		calculateNeededStockDays(item) {
			if (!item || !item.forecastAI || item.forecastAI.length === 0 || item.일판매수량 <= 0) {
				return '0일치';
			}

			const 가용재고 = item.재고 + item.구매 + item.배대지 + item.통관중 + item.입고중 + item.국내재고;
			let ai남은재고기간 = 0;
			let ai잔여가용재고 = 가용재고;

			for (const 예상판매량 of item.forecastAI) {
				if (ai잔여가용재고 >= 예상판매량) {
					ai잔여가용재고 -= 예상판매량;
					ai남은재고기간++;
				} else {
					break;
				}
			}

			if (ai남은재고기간 <= this.baseSettings.safetyDays) {
				return `${this.baseSettings.targetDays - this.baseSettings.safetyDays}일치`;
			} else if (ai남은재고기간 < this.baseSettings.targetDays) {
				return `${this.baseSettings.targetDays - ai남은재고기간}일치`;
			}
			return '0일치';
		},
		calculateForecastQuantities(item) {
			if (item.forecastSeries) {
				item.forecastSeriesQty = item.forecastSeries.slice(0, 30).reduce((pv, cv) => pv + cv, 0);
			}
			if (item.forecastAI) {
				item.forecastAIQty = item.forecastAI.slice(0, 30).reduce((pv, cv) => pv + cv, 0);
			}
			return item;
		},
		extractOfferIdFromUrl(url) {
			const match = url.match(/offer\/(\d+)\.html/);
			return match ? match[1] : null;
		},
		editlists() {
			if (this.tableSelectedItem.length == 0) {
				if (!confirm('전체상품에 변경된 내용을 적용하시겠습니까?'))
					return;
			}

			const itemsToUpdate = this.tableSelectedItem.length > 0 ?
				this.tableSelectedItem : this.saleslists;

			for (const item of itemsToUpdate) {
				if (this.입고기간) {
					item.입고기간 = parseInt(this.입고기간);
				}
				if (this.최소재고기간) {
					item.최소재고기간 = parseInt(this.최소재고기간);
				}
				if (this.최대재고기간) {
					item.최대재고기간 = parseInt(this.최대재고기간);
				}
				if (this.MOQ수량) {
					item.MOQ수량 = parseInt(this.MOQ수량);
				}
				if (this.배대지입고기간) {
					item.배대지입고기간 = parseInt(this.배대지입고기간);
				}
				if (this.통관중입고기간) {
					item.통관중입고기간 = parseInt(this.통관중입고기간);
				}
				if (this.국내입고기간) {
					item.국내입고기간 = parseInt(this.국내입고기간);
				}

				item.isModified = true;

				// 새로운 메트릭 계산
				this.calculateInventoryMetrics(item);
			}

			this.입고기간 = '';
			this.최소재고기간 = '';
			this.최대재고기간 = '';
			this.MOQ수량 = '';
			this.배대지입고기간 = '';
			this.통관중입고기간 = '';
			this.국내입고기간 = '';
		},
		async saveSales() {
			const modifiedItems = this.saleslists.filter(item => item.isModified);
			if (modifiedItems.length === 0) {
				alert('변경된 항목이 없습니다.');
				return;
			}

			try {
				// 각 필드별로 필요한 데이터 추출
				const scmUpdates = modifiedItems.map(item => ({
					vendorItemId: item.vendorItemId,
					purchase: parseInt(item.구매) || 0,
					overseas: parseInt(item.배대지) || 0,
					domesticStock: parseInt(item.국내재고) || 0,
					inboundPeriod: parseInt(item.입고기간) || 0,
					overseasInputDays: parseInt(item.배대지입고기간) || this.baseSettings.overseasInputDays,
					customsInputDays: parseInt(item.통관중입고기간) || this.baseSettings.customsInputDays,
					domesticInputDays: parseInt(item.국내입고기간) || this.baseSettings.domesticInputDays,
					targetStockDays: parseInt(item.최대재고기간) || 0,
					safetyStockDays: parseInt(item.최소재고기간) || 0,
					moqQuantity: parseInt(item.MOQ수량) || 0,
					memo: item.메모 || '',
					targetDailySales: parseFloat(item.목표일판매수량) || 0
				}));

				// 일괄 업데이트 요청
				const response = await axios.post('/api/batchUpdateRocketScmData', scmUpdates);

				if (response.data.res === 'success') {
					// 성공 후 modified 플래그 초기화
					modifiedItems.forEach(item => {
						item.isModified = false;
					});
					alert('저장 완료');
				} else {
					alert(response.data.alert || '저장 실패');
				}
			} catch (error) {
				console.error('저장 오류:', error);
				alert('저장 중 오류가 발생했습니다.');
			}
		},
		async changeMemo(event, saleslist) {
			if (event.keyCode == 13) {
				// 메모 필드 업데이트 ScmDB 형식으로 변경
				await this.updateFieldValue(saleslist, '메모', saleslist.메모);
				alert('저장 완료');
			}
		},
		async updateSaleslist(arr, bool) {
			console.log(arr)
			try {
				// isModified 플래그 제외하고 새로운 배열 생성
				const dataToSend = arr.map((item) => {
					const newItem = { ...item };
					delete newItem.isModified;
					return newItem;
				});

				var result = await axios.post('/api/updateOnlyRocketSalesV2', dataToSend);
				if (result.data.res == 'success') {
					arr.forEach(item => {
						item.isModified = false;
					});
					if (bool) {
						alert('저장 완료');
					}
					// 저장이 성공한 항목들의 isModified 플래그를 false로 초기화
					return true

				} else {
					if (bool) {
						alert(result.data.alert);
					}
					console.log(result.data)
					return false
				}
			} catch (err) {
				alert('저장 중 오류가 발생했습니다.');
				console.error(err);
				return false
			}
		},
		// D-Day 값을 D-7 또는 D+7 형식으로 변환하는 함수
		formatDday(dday) {
			// -999는 특수 값(일판매수량이 0인 경우)
			if (dday === -999) return "-";

			// D-Day를 양수와 음수에 따라 D+ 또는 D- 접두사로 표시
			if (dday > 0) {
				// 양수: 구매시기가 지났음 (구매 필요)
				return `D+${dday}`;
			} else if (dday < 0) {
				// 음수: 구매시기가 아직 안 됨 (구매 불필요)
				return `D-${Math.abs(dday)}`;
			} else {
				// 0: 오늘이 구매시기
				return "D-0";
			}
		},

		// D-Day 스타일 함수
		getDdayStyle(dday, 안전재고일) {
			if (dday > 0) {
				// 구매일이 지났음
				if (dday > 안전재고일) {
					// 안전재고일보다 더 지연됨 (품절 위험)
					return "color: #ff0000; font-weight: bold;"; // 빨간색 + 굵게
				} else {
					// 안전재고일 이내의 지연
					return "color: #ff6600;"; // 주황색
				}
			} else if (dday === 0) {
				// 오늘이 구매일
				return "color: #ff6600;"; // 주황색
			}

			// 구매일이 아직 안 됨 (D-N)
			return ""; // 기본 스타일 (검은색)
		},

		// 기존 스타일 함수 (더 이상 사용하지 않을 수 있으나 호환성을 위해 유지)
		styleDday(dday) {
			if (dday > 0) {
				return "width:80px;overflow:hidden;text-overflow: ellipsis;color:red;font-weight:bold"
			} else {
				return "width:80px;overflow:hidden;text-overflow: ellipsis;"
			}
		},
		changePoEnter(event, saleslist) {
			const index = this.saleslists.findIndex(i => i.vendorItemId === saleslist.vendorItemId);
			if (event.keyCode === 13) {
				this.changePo(saleslist, index);
			}
		},
		async changePo(saleslist) {
			try {
				// 1. 기본 input 값 변환
				saleslist.구매 = parseInt(saleslist.구매) || 0;
				saleslist.배대지 = parseInt(saleslist.배대지) || 0;
				saleslist.입고중 = parseInt(saleslist.입고중) || 0;
				saleslist.국내재고 = parseInt(saleslist.국내재고) || 0;

				// 계산 값 저장
				const metrics = this.calculateInventoryMetrics(saleslist);
				saleslist.남은재고기간 = metrics.남은재고기간;
				saleslist.구매필요수량 = metrics.구매필요수량;
				saleslist.dday = metrics.dday;

				// Series 계산 값도 저장
				saleslist.seriesDday = this.calculateSeriesDday(saleslist);
				saleslist.seriesNeededQty = this.calculateSeriesNeededQty(saleslist);
				saleslist.seriesNeededDays = this.calculateSeriesNeededDays(saleslist);

				// 2. 동일 구매링크 상품 처리
				const dbItem = this.$store.state.productdb.find(x => x.vendorItemId === saleslist.vendorItemId);
				if (dbItem?.구매정보?.[0]?.구매링크) {
					const offerId = this.extractOfferIdFromUrl(dbItem.구매정보[0].구매링크);
					if (offerId) {
						const sameGroupItems = this.saleslists.filter(item => {
							const otherDbItem = this.$store.state.productdb.find(x => x.vendorItemId === item.vendorItemId);
							if (!otherDbItem?.구매정보?.[0]?.구매링크) return false;
							return this.extractOfferIdFromUrl(otherDbItem.구매정보[0].구매링크) === offerId;
						});

						for (const groupItem of sameGroupItems) {
							// 메트릭 재계산 및 값 저장
							const groupMetrics = this.calculateInventoryMetrics(groupItem);
							groupItem.남은재고기간 = groupMetrics.남은재고기간;
							groupItem.구매필요수량 = groupMetrics.구매필요수량;
							groupItem.dday = groupMetrics.dday;

							// Series 계산 값도 저장
							groupItem.seriesDday = this.calculateSeriesDday(groupItem);
							groupItem.seriesNeededQty = this.calculateSeriesNeededQty(groupItem);
							groupItem.seriesNeededDays = this.calculateSeriesNeededDays(groupItem);
						}
					}
				}

				// 4. 차트 업데이트
				this.$nextTick(() => {
					if (this.$refs.mainChart && this.$refs.mainChart.chart) {
						this.$refs.mainChart.chart.updateOptions(saleslist.chart);
					}
				});

			} catch (error) {
				console.error('Error in changePo:', error);
				alert('처리 중 오류가 발생했습니다.');
			}
		},
		generateChartData(item, forecastSeries, forecastAI, dates) {
			// 기본 시리즈 배열
			const series = [
				{
					name: '예상 판매수량(series)',
					data: item.salesHistory.concat(forecastSeries).map(val => val || 0),
					type: 'line',
					yAxisIndex: 0
				},
				{
					name: '예상 판매수량(AI+키워드추세)',
					data: item.salesHistory.concat(forecastAI).map(val => val || 0),
					type: 'line',
					yAxisIndex: 0
				},
				{
					name: '방문자수',
					data: item.visitorHistory.map(val => val || 0),
					type: 'line',
					yAxisIndex: 1
				},
				{
					name: '페이지뷰',
					data: item.pageViewHistory.map(val => val || 0),
					type: 'line',
					yAxisIndex: 1
				},
				{
					name: '장바구니',
					data: item.cartHistory.map(val => val || 0),
					type: 'line',
					yAxisIndex: 1
				},
				{
					name: '주문수',
					data: item.orderHistory.map(val => val || 0),
					type: 'line',
					yAxisIndex: 1
				},
				{
					name: '전환율(%)',
					data: item.pvToOrder.map(val => val || 0),
					type: 'line',
					yAxisIndex: 2
				}
			];

			// 번들 제품 판매수량 추가
			if (item.upBundlingProducts && item.upBundlingProducts.length > 0) {
				// console.log('번들 제품 차트 데이터 추가:', item.upBundlingProducts.length, '개');
				item.upBundlingProducts.forEach((bundle, index) => {
					if (bundle.salesHistory && bundle.salesHistory.length > 0) {
						const bundleSize = bundle.upBundlingSize || 1;
						const bundleName = bundle.옵션명 || bundle.listingDetails?.vendorInventoryItemName || `번들 ${index + 1}`;
						// 번들 제품의 실제 판매량 (번들 사이즈 적용)
						const bundleActualSales = bundle.salesHistory.map(val => (val || 0) * bundleSize);
						const bundleSeries = {
							name: `번들x${bundleSize} (${bundleName})`,
							data: bundleActualSales,
							type: 'line',
							yAxisIndex: 0,
							color: '#FF6B6B'
						};
						// console.log('번들 시리즈 추가:', bundleSeries.name, bundleSeries.data);
						series.push(bundleSeries);
					}
				});
			}

			// 반품상품 판매수량 추가
			if (item.returnProducts && item.returnProducts.length > 0) {
				// console.log('반품 제품 차트 데이터 추가:', item.returnProducts.length, '개');
				item.returnProducts.forEach((returnProduct, index) => {
					if (returnProduct.salesHistory && returnProduct.salesHistory.length > 0) {
						const returnGrade = returnProduct.skuGrade == 'PACKAGE_DAMAGED' ? '미개봉' :
							returnProduct.skuGrade == 'RETURN_BEST' ? '최상' :
								returnProduct.skuGrade == 'RETURN_GOOD' ? '상' : '중';
						const returnName = returnProduct.옵션명 || returnProduct.listingDetails?.vendorInventoryItemName || `반품 ${index + 1}`;
						const returnSeries = {
							name: `반품-${returnGrade} (${returnName})`,
							data: returnProduct.salesHistory.map(val => val || 0),
							type: 'line',
							yAxisIndex: 0,
							color: '#4ECDC4'
						};
						// console.log('반품 시리즈 추가:', returnSeries.name, returnSeries.data);
						series.push(returnSeries);
					}
				});
			}

			// console.log('최종 차트 시리즈:', series.map(s => s.name));

			return {
				series: series,
				chart: {
					type: 'line',
					height: 500,
					width: 1200,
					animations: {
						enabled: false
					}
				},
				colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD', '#98D8C8'],
				stroke: {
					width: Array(series.length).fill(2),
					curve: 'smooth'
				},
				dataLabels: {
					enabled: false
				},
				markers: {
					size: 3
				},
				xaxis: {
					categories: dates.map(date => date || ''),
					title: {
						text: '날짜'
					}
				},
				yaxis: [
					{
						min: 0,
						max: (() => {
							// 모든 판매 데이터 수집
							let allSalesData = [
								...item.salesHistory,
								...item.salesHistory.concat(forecastSeries),
								...item.salesHistory.concat(forecastAI)
							];

							// 번들 제품 판매량 추가
							if (item.upBundlingProducts && item.upBundlingProducts.length > 0) {
								item.upBundlingProducts.forEach(bundle => {
									if (bundle.salesHistory) {
										const bundleSize = bundle.upBundlingSize || 1;
										allSalesData.push(...bundle.salesHistory.map(val => (val || 0) * bundleSize));
									}
								});
							}

							// 반품 제품 판매량 추가
							if (item.returnProducts && item.returnProducts.length > 0) {
								item.returnProducts.forEach(returnProduct => {
									if (returnProduct.salesHistory) {
										allSalesData.push(...returnProduct.salesHistory);
									}
								});
							}

							return Math.max(...allSalesData.map(val => val || 0)) * 1.1 || 100;
						})(),
						title: {
							text: '판매수량'
						},
						labels: {
							formatter: function (val) {
								return val ? Math.round(val).toString() : '0'
							}
						}
					},
					{
						min: 0,
						max: Math.max(...[
							...item.visitorHistory,
							...item.pageViewHistory,
							...item.cartHistory,
							...item.orderHistory
						].map(val => val || 0)) * 1.1 || 100,
						title: {
							text: '트래픽/주문'
						},
						opposite: true,
						labels: {
							formatter: function (val) {
								return val ? Math.round(val).toString() : '0'
							}
						}
					},
					{
						opposite: true,
						min: 0,
						max: Math.max(...item.pvToOrder.map(val => val || 0)) * 1.1 || 1,
						title: {
							text: '전환율(%)',
							offsetX: -20
						},
						labels: {
							formatter: function (val) {
								return typeof val === 'number' ? val.toFixed(2) + '%' : '0%'
							},
							offsetX: -30
						},
						tickAmount: 5,
						forceNiceScale: true,
						decimalsInFloat: 2
					}
				],
				tooltip: {
					shared: true,
					intersect: false,
					y: [{
						formatter: function (y) {
							return typeof y === 'number' ? Math.round(y).toString() : '0'
						}
					}, {
						formatter: function (y) {
							return typeof y === 'number' ? Math.round(y).toString() : '0'
						}
					}, {
						formatter: function (y) {
							return typeof y === 'number' ? Math.round(y).toString() : '0'
						}
					}, {
						formatter: function (y) {
							return typeof y === 'number' ? Math.round(y).toString() : '0'
						}
					}, {
						formatter: function (y) {
							return typeof y === 'number' ? Math.round(y).toString() : '0'
						}
					}, {
						formatter: function (y) {
							return typeof y === 'number' ? Math.round(y).toString() : '0'
						}
					}, {
						formatter: function (y) {
							return typeof y === 'number' ? y.toFixed(2) + '%' : '0%'
						}
					}]
				},
				legend: {
					show: true,
					position: 'top',
					horizontalAlign: 'left',
					floating: false,
					fontSize: '12px',
					fontFamily: 'Helvetica, Arial',
					fontWeight: 400,
					formatter: undefined,
					inverseOrder: false,
					width: undefined,
					height: undefined,
					tooltipHoverFormatter: undefined,
					customLegendItems: [],
					offsetX: 0,
					offsetY: 0,
					labels: {
						colors: undefined,
						useSeriesColors: false
					},
					markers: {
						width: 12,
						height: 12,
						strokeWidth: 0,
						strokeColor: '#fff',
						fillColors: undefined,
						radius: 12,
						customHTML: undefined,
						onClick: undefined,
						offsetX: 0,
						offsetY: 0
					},
					itemMargin: {
						horizontal: 5,
						vertical: 0
					},
					onItemClick: {
						toggleDataSeries: true
					},
					onItemHover: {
						highlightDataSeries: true
					}
				}
			};
		},
		// 판매량 전용 차트 생성 (번들/반품 포함)
		getSalesChartOption(item) {
			try {
				// 올바른 데이터 필드 사용
				// salesHistory 사용 (음수 값 처리 중요!)
				const salesHistory = Array.isArray(item.salesHistory) ?
					item.salesHistory.map(val => {
						const num = Number(val);
						// 음수 값 유지 (반품으로 인한 음수 판매량)
						return isNaN(num) ? 0 : num;
					}) :
					Array(30).fill(0);

				// dates 필드 사용
				const dates = Array.isArray(item.dates) ?
					item.dates.slice(0, 30) :
					Array(30).fill('').map((_, i) => `Day ${i + 1}`);

				console.log('getSalesChartOption - 원본 salesHistory:', item.salesHistory);
				console.log('getSalesChartOption - 처리된 salesHistory:', salesHistory);

				// 데이터 길이 맞추기
				const dataLength = Math.min(salesHistory.length, dates.length, 30);
				const alignedSales = salesHistory.slice(0, dataLength);
				const alignedDates = dates.slice(0, dataLength);

				// 간단한 시리즈 생성
				const series = [{
					name: '메인 판매량',
					data: alignedSales,
					type: 'column'
				}];

				// 번들 제품 추가 (간단하게)
				if (item.upBundlingProducts && Array.isArray(item.upBundlingProducts)) {
					item.upBundlingProducts.forEach((bundle, index) => {
						if (bundle && bundle.salesHistory && Array.isArray(bundle.salesHistory)) {
							const bundleSize = Math.max(1, Number(bundle.upBundlingSize) || 1);
							const bundleName = bundle.옵션명 || `번들 ${index + 1}`;
							const bundleData = bundle.salesHistory
								.slice(0, dataLength)
								.map(val => {
									const num = Number(val) || 0;
									return num * bundleSize; // 음수 값 유지
								});

							series.push({
								name: `번들x${bundleSize} (${bundleName})`,
								data: bundleData,
								type: 'column'
							});
						}
					});
				}

				// 반품 제품 추가 (간단하게)
				if (item.returnProducts && Array.isArray(item.returnProducts)) {
					item.returnProducts.forEach((returnProduct, index) => {
						if (returnProduct && returnProduct.salesHistory && Array.isArray(returnProduct.salesHistory)) {
							const returnGrade = returnProduct.skuGrade === 'PACKAGE_DAMAGED' ? '미개봉' :
								returnProduct.skuGrade === 'RETURN_BEST' ? '최상' :
								returnProduct.skuGrade === 'RETURN_GOOD' ? '상' : '중';
							const returnName = returnProduct.옵션명 || `반품 ${index + 1}`;
							const returnData = returnProduct.salesHistory
								.slice(0, dataLength)
								.map(val => {
									const num = Number(val) || 0;
									return num; // 음수 값 유지
								});

							series.push({
								name: `반품-${returnGrade} (${returnName})`,
								data: returnData,
								type: 'column'
							});
						}
					});
				}

				// Y축 범위 계산 (음수 값 포함)
				const allValues = series.reduce((acc, s) => acc.concat(s.data), []);
				const maxValue = Math.max(...allValues, 1);
				const minValue = Math.min(...allValues, 0);

				// 음수가 있으면 최소값을 조정, 없으면 0부터 시작
				const yMin = minValue < 0 ? minValue * 1.2 : 0;
				const yMax = maxValue > 0 ? maxValue * 1.2 : 10;

				console.log('Y축 범위 계산:', { allValues, minValue, maxValue, yMin, yMax });

				return {
					series: series,
					chart: {
						type: 'column',
						height: 300,
						animations: { enabled: false },
						toolbar: { show: false }
					},
					plotOptions: {
						bar: {
							columnWidth: '60%'
						}
					},
					colors: ['#008FFB', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4'],
					xaxis: {
						categories: alignedDates
					},
					yaxis: {
						title: { text: '판매수량' },
						min: yMin,
						max: yMax
					},
					legend: {
						show: true,
						position: 'top'
					},
					tooltip: {
						shared: true,
						y: {
							formatter: (val) => Math.round(val) + '개'
						}
					}
				};
			} catch (error) {
				console.error('판매량 차트 생성 오류:', error);
				return this.getEmptySalesChart();
			}
		},
		// 빈 판매량 차트 반환
		getEmptySalesChart() {
			return {
				series: [{
					name: '데이터 없음',
					data: Array(30).fill(0),
					type: 'column'
				}],
				chart: {
					type: 'column',
					height: 300,
					animations: { enabled: false },
					toolbar: { show: false }
				},
				colors: ['#E0E0E0'],
				xaxis: {
					categories: Array(30).fill('').map((_, i) => `Day ${i + 1}`)
				},
				yaxis: {
					title: { text: '판매수량' },
					min: 0,
					max: 10
				},
				legend: { show: false },
				tooltip: { enabled: false }
			};
		},
		// 공통 오늘 날짜 계산 함수
		getTodayString() {
			const today = new Date();
			const year = today.getFullYear();
			const month = ("0" + (1 + today.getMonth())).slice(-2);
			const day = ("0" + today.getDate()).slice(-2);
			return `${year}-${month}-${day}`;
		},

		getMonthDates() {
			// 공통 함수를 사용해서 오늘 날짜 계산
			const todayStr = this.getTodayString();
			// generateDatesFromUpdateDate와 동일한 로직 사용
			return this.generateDatesFromUpdateDate(todayStr);
		},
		async collectRocketSales() {
			var updateDate = this.getTodayString();

			// 서버에서 오늘 데이터 존재 여부 확인 (판매장부에서 이미 수집했을 수 있음)
			try {
				const checkResult = await axios.post('/api/growth/checkDailySalesExists', { date: updateDate, channel: 'rocket' });
				if (checkResult.data.res === 'success' && checkResult.data.exists) {
					if (!confirm('오늘자 데이터가 이미 수집되어 있습니다.\n(판매장부 또는 이전 수집)\n다시 수집하시겠습니까?')) {
						return;
					}
				}
			} catch (error) {
				console.error('수집 여부 확인 실패:', error);
			}

			// 수집 날짜 범위 계산
			const dateRange = await this.calculateCollectionDateRange();

			window.postMessage({
				greeting: "manualCollect",
				itemKey: "rocketDeliverySales",
				companyid: this.$store.state.user.companyid,
				suppliercode: this.$store.state.user.suppliercode,
				options: { dateRange: { startDate: dateRange.startDate, endDate: dateRange.endDate } }
			}, "*");
			this.showspinner1 = true;
			this.showlist = false;
		},

		// ✅ 특정 날짜 범위 수집 메서드
		async collectCustomDateRange() {
			// 날짜 입력 모달 표시
			this.$bvModal.show('customDateRangeModal');
		},

		// ✅ 사용자 지정 날짜 범위로 수집 실행
		async executeCustomDateCollection() {
			if (!this.customStartDate || !this.customEndDate) {
				alert('시작일과 종료일을 모두 입력해주세요.');
				return;
			}

			if (new Date(this.customStartDate) > new Date(this.customEndDate)) {
				alert('시작일이 종료일보다 늦을 수 없습니다.');
				return;
			}

			const daysDiff = Math.ceil((new Date(this.customEndDate) - new Date(this.customStartDate)) / (1000 * 60 * 60 * 24)) + 1;

			if (!confirm(`${this.customStartDate} ~ ${this.customEndDate} (${daysDiff}일) 데이터를 수집하시겠습니까?`)) {
				return;
			}

			console.log('사용자 지정 날짜 범위 수집:', this.customStartDate, '~', this.customEndDate);

			// [수집로직 일원화] manualCollect로 통합
			window.postMessage({
				greeting: "manualCollect",
				itemKey: "rocketDeliverySales",
				companyid: this.$store.state.user.companyid,
				suppliercode: this.$store.state.user.suppliercode,
				options: { dateRange: { startDate: this.customStartDate, endDate: this.customEndDate } }
			}, "*");

			this.showspinner1 = true;
			this.showlist = false;
			this.$bvModal.hide('customDateRangeModal');
		},

		// 수집 날짜 범위 계산
		async calculateCollectionDateRange() {
			try {
				// 기존 일별 판매 데이터 확인
				const result = await axios.post('/api/getLatestSalesData', {
					companyid: this.$store.state.user.companyid
				});

				if (result.data.res === 'success' && result.data.latestDate) {
					// 마지막 수집 날짜부터 어제까지 (공통 함수 사용)
					const latestDate = new Date(result.data.latestDate + 'T00:00:00'); // 로컬 시간으로 파싱
					const todayStr = this.getTodayString();
					const yesterdayStr = this.generateDatesFromUpdateDate(todayStr)[29]; // 마지막 날짜가 어제
					const yesterday = new Date(yesterdayStr + 'T00:00:00');

					// 그저께 날짜 계산 (최소 2일 수집 보장)
					const dayBeforeYesterday = new Date(yesterday);
					dayBeforeYesterday.setDate(yesterday.getDate() - 1);

					// 마지막 수집 날짜 다음날부터 시작
					let startDate = new Date(latestDate);
					startDate.setDate(startDate.getDate() + 1);

					// ✅ 최소 2일(어제, 그저께) 수집 보장: startDate가 그저께보다 늦으면 그저께로 조정
					if (startDate > dayBeforeYesterday) {
						startDate = dayBeforeYesterday;
					}

					console.log('=== 날짜 범위 계산 디버깅 ===');
					console.log('latestDate (마지막 수집):', this.formatDateForCollection(latestDate));
					console.log('dayBeforeYesterday (그저께):', this.formatDateForCollection(dayBeforeYesterday));
					console.log('startDate (시작일):', this.formatDateForCollection(startDate));
					console.log('yesterday (어제):', this.formatDateForCollection(yesterday));

					// 수집 범위 반환 (최소 2일 보장됨)
					const dateRange = {
						startDate: this.formatDateForCollection(startDate),
						endDate: this.formatDateForCollection(yesterday)
					};
					console.log('수집 범위 (최소 2일 보장):', dateRange);
					console.log('==============================');
					return dateRange;
				} else {
					// 기존 데이터가 없으면 전체 30일
					return this.getFullDateRange();
				}
			} catch (error) {
				console.error('날짜 범위 계산 오류:', error);
				// 오류 시 전체 30일
				return this.getFullDateRange();
			}
		},
		// 전체 30일 날짜 범위 반환
		getFullDateRange() {
			// 공통 함수를 사용해서 어제 기준 30일 범위 계산
			const todayStr = this.getTodayString();
			const dates = this.generateDatesFromUpdateDate(todayStr);

			console.log('=== 전체 30일 범위 계산 ===');
			console.log('어제 기준 30일 범위:', `${dates[0]} ~ ${dates[dates.length - 1]}`);
			console.log('==========================');

			return {
				startDate: dates[0],
				endDate: dates[dates.length - 1]
			};
		},
		// 날짜 포맷팅 (YYYY-MM-DD)
		formatDateForCollection(date) {
			const year = date.getFullYear();
			const month = ("0" + (1 + date.getMonth())).slice(-2);
			const day = ("0" + date.getDate()).slice(-2);
			return `${year}-${month}-${day}`;
		},
		changeleadtime(saleslist) {
			var obj = {
				vendorItemId: saleslist.vendorItemId,
				입고리드타임: saleslist.입고리드타임
			}
			if (this.$store.state.user.companyid) {
				axios.post('/api/ai/updateleadtime', { companyid: this.$store.state.user.companyid, vendorItemId: obj.vendorItemId, 입고리드타임: obj.입고리드타임 })
					.then(result => {
						console.log(result);
						if (result.data.요청결과 == 'ok') {
							this.$store.commit('updateleadtime', obj)
						} else {
							alert('저장실패(276)'); console.log(result)
						}
					})
					.catch(e => { alert('저장실패(279)'); console.log(e) })
			}
		},
		clickleadtime(saleslist) {
			if (saleslist.showleadtime) {
				saleslist.showleadtime = false;
			}
		},
		showtotal() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.saleslists = this.saleslistsinit.filter(item => !item.hidden);
			setTimeout(() => { this.showlist = true; }, 10)
		},
		showReturn() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = []; // 체크 초기화
			this.saleslists = this.saleslistsinit.filter(e => e.returnProducts && e.returnProducts.length > 0 && !e.hidden)
			setTimeout(() => { this.showlist = true; }, 10)
		},
		// 숨김 상품만 표시
		showHidden() {
			this.showlist = false;
			this.isShowingHidden = true;
			// 숨김상품 필터는 체크를 초기화하지 않음 (복원 기능을 위해)
			this.saleslists = this.saleslistsinit.filter(e => e.hidden);
			setTimeout(() => { this.showlist = true; }, 10);
		},
		// 선택한 상품들 숨김 처리
		async hideSelectedItems() {
			if (this.tableSelectedItem.length === 0) {
				alert('숨길 상품을 선택해주세요.');
				return;
			}

			try {
				// 숨김의 진실은 Productdb.hidden — 목록을 만드는 컬렉션과 같은 곳에 쓴다.
				// (예전엔 RocketSales 에 썼는데 그 컬렉션은 1개사만 갖고 있어 대부분 아무 데도 안 써졌다)
				const updatedItems = this.tableSelectedItem.map(item => ({
					SKUID: item.SKUID || '',
					vendorItemId: item.vendorItemId || ''
				}));

				const response = await axios.post('/api/product/updateRocketHidden', { items: updatedItems, hidden: true });

				if (response.data.res === 'success') {
					// 로컬 상태 업데이트
					this.tableSelectedItem.forEach(item => {
						item.hidden = true;
					});

					// 숨김 상품을 목록에서 제거
					this.saleslists = this.saleslists.filter(item => !item.hidden);
					this.saleslistsinit = this.saleslistsinit.map(item => {
						if (this.tableSelectedItem.some(selected => selected.vendorItemId === item.vendorItemId)) {
							item.hidden = true;
						}
						return item;
					});
					this.syncRocketSalesHidden(this.tableSelectedItem.map(i => i.vendorItemId), true);

					this.updateCounts();
					this.tableSelectedItem = [];
					alert(`${updatedItems.length}개 상품이 숨김 처리되었습니다.`);
				} else {
					alert('숨김 처리에 실패했습니다: ' + response.data.alert);
				}
			} catch (error) {
				console.error('숨김 처리 중 오류:', error);
				alert('숨김 처리 중 오류가 발생했습니다.');
			}
		},
		// 선택한 상품들 복원 처리
		async restoreSelectedItems() {
			if (this.tableSelectedItem.length === 0) {
				alert('복원할 상품을 선택해주세요.');
				return;
			}

			try {
				// 복원도 같은 곳(Productdb.hidden)을 되돌린다
				const updatedItems = this.tableSelectedItem.map(item => ({
					SKUID: item.SKUID || '',
					vendorItemId: item.vendorItemId || ''
				}));

				const response = await axios.post('/api/product/updateRocketHidden', { items: updatedItems, hidden: false });

				if (response.data.res === 'success') {
					// 로컬 상태 업데이트
					this.tableSelectedItem.forEach(item => {
						item.hidden = false;
					});

					// 복원된 상품을 숨김 목록에서 제거
					this.saleslists = this.saleslists.filter(item => item.hidden);
					this.saleslistsinit = this.saleslistsinit.map(item => {
						if (this.tableSelectedItem.some(selected => selected.vendorItemId === item.vendorItemId)) {
							item.hidden = false;
						}
						return item;
					});
					this.syncRocketSalesHidden(this.tableSelectedItem.map(i => i.vendorItemId), false);

					this.updateCounts();
					this.tableSelectedItem = [];
					alert(`${updatedItems.length}개 상품이 복원되었습니다.`);
				} else {
					alert('복원 처리에 실패했습니다: ' + response.data.alert);
				}
			} catch (error) {
				console.error('복원 처리 중 오류:', error);
				alert('복원 처리 중 오류가 발생했습니다.');
			}
		},
		// Vuex 캐시(rocketSales)가 화면을 다시 그릴 때 목록의 뿌리가 된다.
		// 여기에 같이 반영하지 않으면 같은 세션에서 화면을 다시 열 때 숨김이 풀려 보인다.
		syncRocketSalesHidden(vendorItemIds, hidden) {
			const cached = this.$store.state.rocketSales;
			if (!cached || cached.length === 0) return;
			const target = new Set(vendorItemIds.map(v => String(v)));
			this.$store.commit('rocketSalesUpdate', cached.map(item =>
				target.has(String(item.vendorItemId)) ? { ...item, hidden: hidden } : item));
		},
		// 카운트 업데이트
		updateCounts() {
			const visibleItems = this.saleslistsinit.filter(item => !item.hidden);

			this.totalCnt = visibleItems.length;
			this.needPo = visibleItems.filter(item => item.dday >= 0 || item.구매필요수량 > 0).length;
			this.needOverseasOutbound = visibleItems.filter(item => item.배대지출고Dday >= 0 || item.배대지출고필요수량 > 0).length;
			this.needDomesticOutbound = visibleItems.filter(item => item.국내출고Dday >= 0 || item.국내출고필요수량 > 0).length;
			this.monthlyCntOver0 = visibleItems.filter(item => item.월판매수량 > 0).length;
			this.stockDangerCnt = visibleItems.filter(item => this.isCoupangStockDanger(item)).length;
			this.overStockCnt = visibleItems.filter(item => this.isOverStock(item)).length;
			this.returnProducts = visibleItems.filter(item => item.returnProducts?.length > 0).length;
			this.hiddenProducts = this.saleslistsinit.filter(item => item.hidden).length;
		},
		showNeedReturn() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.saleslists = this.saleslistsinit.filter(e => e.판매 > 0 && !e.hidden)
			setTimeout(() => { this.showlist = true; }, 10)
		},
		showMonthlyCntOver0() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = []; // 체크 초기화
			this.saleslists = this.saleslistsinit.filter(e => e.월판매수량 > 0 && !e.hidden)
			setTimeout(() => { this.showlist = true; }, 10)
		},
		// 품절예고 상품 표시 (쿠팡재고기간이 안전재고기간보다 짧은 경우)
		showStockDanger() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = []; // 체크 초기화
			this.saleslists = this.saleslistsinit.filter(e => this.isCoupangStockDanger(e) && !e.hidden)
			setTimeout(() => { this.showlist = true; }, 10)
		},
		// 과재고위험 상품 표시
		showOverStock() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = []; // 체크 초기화
			this.saleslists = this.saleslistsinit.filter(e => this.isOverStock(e) && !e.hidden)
			setTimeout(() => { this.showlist = true; }, 10)
		},
		// 재고 위험 판단 (남은재고기간, 쿠팡재고기간, 전체가용재고기간 중 하나라도 위험하면 true)
		isStockDanger(item) {
			if (!item.최소재고기간) return false;

			const safetyDays = parseFloat(item.최소재고기간);

			// 남은재고기간 체크 (기존 로직)
			if (item.남은재고기간) {
				const remainingDays = parseFloat(item.남은재고기간);
				if (remainingDays < safetyDays && remainingDays >= 0) {
					return true;
				}
			}

			// 쿠팡재고기간 체크
			if (this.isCoupangStockDanger(item)) {
				return true;
			}

			// 전체가용재고기간 체크 (새로운 로직)
			if (this.isTotalStockDanger(item)) {
				return true;
			}

			return false;
		},
		// 재고 위험 CSS 클래스
		getStockDangerClass(item) {
			return this.isStockDanger(item) ? 'text-danger font-weight-bold' : '';
		},
		// 재고 위험 툴팁
		getStockDangerTooltip(item) {
			if (this.isStockDanger(item)) {
				return `경고: 남은재고기간(${item.남은재고기간}일)이 안전재고기간(${item.최소재고기간}일)보다 짧습니다!`;
			}
			return '';
		},
		// 반품 상품 재고 위험 판단
		isReturnStockDanger(returnItem, parentItem) {
			if (!returnItem.남은재고기간 || !parentItem.최소재고기간) return false;
			const remainingDays = parseFloat(returnItem.남은재고기간);
			const safetyDays = parseFloat(parentItem.최소재고기간);
			return remainingDays < safetyDays && remainingDays >= 0;
		},
		// 반품 상품 재고 위험 CSS 클래스
		getReturnStockDangerClass(returnItem, parentItem) {
			return this.isReturnStockDanger(returnItem, parentItem) ? 'text-danger font-weight-bold' : '';
		},
		// 반품 상품 재고 위험 툴팁
		getReturnStockDangerTooltip(returnItem, parentItem) {
			if (this.isReturnStockDanger(returnItem, parentItem)) {
				return `경고: 남은재고기간(${returnItem.남은재고기간}일)이 안전재고기간(${parentItem.최소재고기간}일)보다 짧습니다!`;
			}
			return '';
		},
		// 쿠팡재고 위험 판단
		isCoupangStockDanger(item) {
			if (!item.쿠팡재고기간 || !item.최소재고기간) return false;
			const stockDays = parseInt(item.쿠팡재고기간) || 0;
			const safetyDays = parseInt(item.최소재고기간) || 0;
			return stockDays <= safetyDays && stockDays >= 0;
		},
		// 전체가용재고기간 위험 판단
		isTotalStockDanger(item) {
			if (!item.남은재고기간 || !item.입고기간 || !item.최대재고기간) return false;
			const totalStockDays = parseFloat(item.남은재고기간) || 0;
			const inboundDays = parseFloat(item.입고기간) || 0;
			const targetDays = parseFloat(item.최대재고기간) || 0;
			const requiredDays = inboundDays + targetDays;
			return totalStockDays < requiredDays && totalStockDays >= 0;
		},
		// 전체가용재고기간 위험 CSS 클래스
		getTotalStockDangerClass(item) {
			if (this.isTotalStockDanger(item)) {
				return 'total-stock-danger text-white font-weight-bold';
			}
			// 기존 남은재고기간 위험도 체크
			return this.getStockDangerClass(item);
		},
		// 전체가용재고기간 위험 툴팁
		getTotalStockDangerTooltip(item) {
			if (this.isTotalStockDanger(item)) {
				const inboundDays = parseFloat(item.입고기간) || 0;
				const targetDays = parseFloat(item.최대재고기간) || 0;
				const requiredDays = inboundDays + targetDays;
				return `경고: 전체가용재고기간(${item.남은재고기간}일)이 \n구매입고기간+목표재고기간(${requiredDays}일)보다 짧아\n구매진행이 필요합니다!`;
			}
			// 기존 남은재고기간 툴팁 반환
			return this.getStockDangerTooltip(item);
		},
		// 재고 기간 계산 (재고량 / 일판매수량)
		getStockPeriod(stockQuantity, dailySales, item = null) {
			if (!stockQuantity || !dailySales || dailySales <= 0) {
				return '';
			}

			// item이 있고 목표 일판매수량이 설정되어 있으면 목표수량 사용
			let 계산용일판매수량 = dailySales;
			if (item && item.목표일판매수량 && item.목표일판매수량 > 0) {
				계산용일판매수량 = item.목표일판매수량;
			}

			const days = Math.floor(stockQuantity / 계산용일판매수량);

			// 재고가 있지만 1일 이내라면 0일로 표시
			if (stockQuantity > 0 && days < 1) {
				return '0일';
			}

			return days > 0 ? `${days}일` : '';
		},
		// 전체가용재고 계산
		getTotalAvailableStock(item) {
			const { 장기입고중, 단기입고중 } = this.classifyInboundInventory(item);
			return (item.구매 || 0) + (item.배대지 || 0) + (item.통관중 || 0) + (item.국내재고 || 0) + 장기입고중 + 단기입고중 + (item.재고 || 0);
		},
		// 개별 재고금액 계산
		getStockAmount(quantity, vendorItemId) {
			if (!quantity || quantity <= 0) return 0;

			const productItem = this.$store.state.productdb.find(item => item.vendorItemId === vendorItemId);
			if (!productItem || !productItem.매입가) return 0;

			return Math.round(quantity * productItem.매입가);
		},
		// 전체 재고금액 계산
		getTotalStockAmount() {
			if (!this.saleslists || this.saleslists.length === 0) return 0;

			let total = 0;
			this.saleslists.forEach(item => {
				if (item.isSummaryRow) return; // 종합 행 제외

				const totalStock = this.getTotalAvailableStock(item);
				const stockAmount = this.getStockAmount(totalStock, item.vendorItemId);
				total += stockAmount;
			});

			return total;
		},
		// 과재고 위험 판단 (쿠팡재고기간이 60일 초과)
		isOverStock(item) {
			if (!item.쿠팡재고기간) return false;
			const stockDays = parseInt(item.쿠팡재고기간) || 0;
			return stockDays > 60;
		},
		// 쿠팡재고 박스 클래스 결정 (경고 스타일 포함)
		getCoupangStockBoxClass(item) {
			const baseClass = 'inventory-box-vertical text-white';

			if (!item.쿠팡재고기간) {
				return `${baseClass} bg-dark`;
			}

			const stockDays = parseInt(item.쿠팡재고기간) || 0;
			const safetyDays = parseInt(item.최소재고기간) || 0;

			// 60일 초과 시 주황색 경고
			if (stockDays > 60) {
				return `${baseClass} stock-warning`;
			}

			// 안전재고기간 이하 시 빨간색 경고
			if (item.최소재고기간 && stockDays <= safetyDays) {
				return `${baseClass} stock-danger`;
			}

			// 정상 상태
			return `${baseClass} bg-dark`;
		},
		showNeedPo() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = []; // 체크 초기화

			// 1. D-Day가 0 이상이거나 구매필요수량이 0보다 큰 항목 필터링 (숨김 상품 제외)
			let filteredList = this.saleslistsinit.filter(e =>
				(e.dday >= 0 || e.구매필요수량 > 0) && !e.hidden
			);

			// 2. productId로 그룹화
			const groupedByProduct = {};
			filteredList.forEach(item => {
				if (!groupedByProduct[item.productId]) {
					groupedByProduct[item.productId] = [];
				}
				groupedByProduct[item.productId].push(item);
			});

			// 3. 각 그룹의 최대 D-Day를 기준으로 그룹 정렬
			// D-Day가 음수인 경우는 구매필요수량을 고려
			const sortedList = Object.entries(groupedByProduct)
				.sort(([, groupA], [, groupB]) => {
					// 각 그룹의 최대 D-Day 계산
					const maxDdayA = Math.max(...groupA.map(item => item.dday));
					const maxDdayB = Math.max(...groupB.map(item => item.dday));

					// D-Day가 모두 음수인 경우 구매필요수량으로 비교
					if (maxDdayA < 0 && maxDdayB < 0) {
						const maxNeededQtyA = Math.max(...groupA.map(item => item.구매필요수량));
						const maxNeededQtyB = Math.max(...groupB.map(item => item.구매필요수량));
						return maxNeededQtyB - maxNeededQtyA;
					}
					return maxDdayB - maxDdayA;
				})
				.flatMap(([, group]) => {
					// 각 그룹 내에서 D-Day 순으로 정렬하되,
					// D-Day가 음수인 경우는 구매필요수량으로 정렬
					return group.sort((a, b) => {
						if (a.dday < 0 && b.dday < 0) {
							return b.구매필요수량 - a.구매필요수량;
						}
						return b.dday - a.dday;
					});
				});

			this.saleslists = sortedList;
			setTimeout(() => { this.showlist = true; }, 10);
		},
		showNeedOverseasOutbound() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = []; // 체크 초기화

			// 배대지출고 D-Day가 0 이상이거나 배대지출고필요수량이 0보다 큰 항목 필터링 (숨김 상품 제외)
			let filteredList = this.saleslistsinit.filter(e =>
				(e.배대지출고Dday >= 0 || e.배대지출고필요수량 > 0) && !e.hidden
			);

			// productId로 그룹화 및 정렬
			const groupedByProduct = {};
			filteredList.forEach(item => {
				if (!groupedByProduct[item.productId]) {
					groupedByProduct[item.productId] = [];
				}
				groupedByProduct[item.productId].push(item);
			});

			const sortedList = Object.entries(groupedByProduct)
				.sort(([, groupA], [, groupB]) => {
					const maxDdayA = Math.max(...groupA.map(item => item.배대지출고Dday));
					const maxDdayB = Math.max(...groupB.map(item => item.배대지출고Dday));

					if (maxDdayA < 0 && maxDdayB < 0) {
						const maxNeededQtyA = Math.max(...groupA.map(item => item.배대지출고필요수량));
						const maxNeededQtyB = Math.max(...groupB.map(item => item.배대지출고필요수량));
						return maxNeededQtyB - maxNeededQtyA;
					}
					return maxDdayB - maxDdayA;
				})
				.flatMap(([, group]) => {
					return group.sort((a, b) => {
						if (a.배대지출고Dday < 0 && b.배대지출고Dday < 0) {
							return b.배대지출고필요수량 - a.배대지출고필요수량;
						}
						return b.배대지출고Dday - a.배대지출고Dday;
					});
				});

			this.saleslists = sortedList;
			setTimeout(() => { this.showlist = true; }, 10);
		},
		showNeedDomesticOutbound() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.tableSelectedItem = []; // 체크 초기화

			// 국내출고 D-Day가 0 이상이거나 국내출고필요수량이 0보다 큰 항목 필터링 (숨김 상품 제외)
			let filteredList = this.saleslistsinit.filter(e =>
				(e.국내출고Dday >= 0 || e.국내출고필요수량 > 0) && !e.hidden
			);

			// productId로 그룹화 및 정렬
			const groupedByProduct = {};
			filteredList.forEach(item => {
				if (!groupedByProduct[item.productId]) {
					groupedByProduct[item.productId] = [];
				}
				groupedByProduct[item.productId].push(item);
			});

			const sortedList = Object.entries(groupedByProduct)
				.sort(([, groupA], [, groupB]) => {
					const maxDdayA = Math.max(...groupA.map(item => item.국내출고Dday));
					const maxDdayB = Math.max(...groupB.map(item => item.국내출고Dday));

					if (maxDdayA < 0 && maxDdayB < 0) {
						const maxNeededQtyA = Math.max(...groupA.map(item => item.국내출고필요수량));
						const maxNeededQtyB = Math.max(...groupB.map(item => item.국내출고필요수량));
						return maxNeededQtyB - maxNeededQtyA;
					}
					return maxDdayB - maxDdayA;
				})
				.flatMap(([, group]) => {
					return group.sort((a, b) => {
						if (a.국내출고Dday < 0 && b.국내출고Dday < 0) {
							return b.국내출고필요수량 - a.국내출고필요수량;
						}
						return b.국내출고Dday - a.국내출고Dday;
					});
				});

			this.saleslists = sortedList;
			setTimeout(() => { this.showlist = true; }, 10);
		},
		showNeedPriceAdjust() {
			this.showlist = false;
			this.isShowingHidden = false;
			this.saleslists = this.saleslistsinit.filter(e => e.가격조정필요 === true && !e.hidden)
			setTimeout(() => { this.showlist = true; }, 10)
		},
		modalID(index) {
			// console.log(index);
			return 'modal' + index
		},
		async search() {
			this.showspinner1 = true;
			this.loadingtext = '로켓배송 판매현황을 불러오는 중입니다.'
			// 공통 함수를 사용해서 오늘 날짜 계산
			var updateDate = this.getTodayString();

			console.log('=== search 날짜 디버깅 ===');
			console.log('계산된 updateDate:', updateDate);
			console.log('========================');

			// SCM 데이터 로딩
			await this.loadScmData();

			// 쿠패스연동 데이터 로딩
			this.coupassData = [];
			this.inventoryMap = {};
			if (this.coupassSyncEnabled) {
				try {
					const coupassResult = await axios.post('/api/reqpurchase/getOngoingList', {
						companyid: this.$store.state.user.companyid,
						status: ['구매완료', '배송중', '배송완료', '입고작업', '출고확인대기', '재고대기', '출고요청', '출고대기', '중국재고', '국내창고입고중']
					});
					if (coupassResult.data.요청결과 === 'success') {
						this.coupassData = coupassResult.data.reqpurchase || [];
						console.log('쿠패스연동 데이터 로드 완료:', this.coupassData.length, '건');
					}
				} catch (error) {
					console.error('쿠패스연동 데이터 가져오기 오류:', error);
				}

				try {
					const invResult = await axios.post('/api/inventory/getList', {
						companyid: this.$store.state.user.companyid
					});
					if (invResult.data.요청결과 === 'ok' && invResult.data.items) {
						invResult.data.items.forEach(inv => {
							if (inv.barcode) {
								this.inventoryMap[inv.barcode] = (this.inventoryMap[inv.barcode] || 0) + (inv.수량 || 0);
							}
						});
						console.log('Inventory 데이터 로드 완료:', Object.keys(this.inventoryMap).length, '건');
					}
				} catch (error) {
					console.error('Inventory 데이터 가져오기 오류:', error);
				}
			}

			try {
				var rocketSalesData;

				// Vuex 캐시 확인 - 이미 로드된 상품 데이터가 있으면 재사용
				if (this.$store.state.rocketSales?.length > 0) {
					console.log('Vuex 캐시에서 로켓배송 상품 데이터 사용:', this.$store.state.rocketSales.length, '건');
					rocketSalesData = this.$store.state.rocketSales.map(item => ({
						썸네일: item.썸네일 || '',
						판매상품명: item.판매상품명 || '',
						옵션명: item.옵션명 || '',
						productId: item.productId || '',
						vendorItemId: item.vendorItemId || '',
						SKUID: item.SKUID || '',
						재고: item.재고 || 0,
						hidden: item.hidden || false,
						입고중: 0,
						updateDate: updateDate,
						inventoryDetails: null,
						inboundInfo: null,
						returnProducts: [],
						upBundlingProducts: [],
						skuGrade: 'NEW',
						입고기간: this.baseSettings.inputDays,
						최대재고기간: this.baseSettings.targetDays,
						최소재고기간: this.baseSettings.safetyDays,
						MOQ수량: this.baseSettings.moqQuantity
					}));
				} else {
					// Productdb가 없으면 먼저 로드
					if (this.$store.state.productdb.length == 0) {
						try {
							var result = await axios.post('/api/getAllProductdb');
							if (result.data?.productdb?.length == 0) {
								alert('로켓배송 판매현황/SCM을 이용하기전에 로켓배송 상품DB를 먼저 수집해주세요')
								this.$router.push({ name: 'product.rocketProductManagement' })
								return
							}
							this.$store.commit('productdbupdate', result.data.productdb);
						} catch (e) {
							console.error('로켓배송 상품DB 불러오기 실패:', e)
						}
					}

					// API에서 로드
					const productResult = await axios.post('/api/product/getRocketProductData');
					if (!productResult.data.success || !productResult.data.data?.length) {
						alert('로켓배송 상품 데이터가 없습니다. 상품DB를 먼저 수집해주세요.');
						this.showspinner = false;
						this.showspinner1 = false;
						return;
					}

					rocketSalesData = productResult.data.data.map(p => ({
						썸네일: p.썸네일 || '',
						판매상품명: p.상품명 || '',
						옵션명: p.옵션명 || '',
						productId: p.노출ID || '',
						vendorItemId: p.옵션ID || '',
						SKUID: p['SKU ID'] || '',
						재고: p.재고 || 0,
						// 숨김상품의 진실은 Productdb.hidden — 이 목록에서 떨구면 새로고침 때마다 풀린다
						hidden: p.hidden || false,
						입고중: 0,
						updateDate: updateDate,
						inventoryDetails: null,
						inboundInfo: null,
						returnProducts: [],
						upBundlingProducts: [],
						skuGrade: 'NEW',
						입고기간: this.baseSettings.inputDays,
						최대재고기간: this.baseSettings.targetDays,
						최소재고기간: this.baseSettings.safetyDays,
						MOQ수량: this.baseSettings.moqQuantity
					}));

					console.log('API에서 로켓배송 상품 데이터 로드 완료:', rocketSalesData.length, '건');
					this.$store.commit('rocketSalesUpdate', rocketSalesData);
				}

				// 일별 데이터에서 salesHistory 생성
				this.loadingtext = '판매 데이터 분석 중...';
				await new Promise(resolve => setTimeout(resolve, 0));
				await this.buildSalesDataFromDailySales(rocketSalesData);

				this.loadingtext = '상품 데이터 처리 중... 0%';
				await new Promise(resolve => setTimeout(resolve, 0));
				await this.searchresult(rocketSalesData);

				// 오늘자 수집 여부 확인 (GrowthDailySales 기준)
				this.$nextTick(async () => {
					try {
						// 로켓배송 수집은 Sales 에 쓴다 — channel:'rocket' 이 없으면 그로스 표(GrowthDailySales)를 봐서
						// 로켓만 쓰는 계정은 수집해도 늘 「수집필요」였다(#64)
						const checkResult = await axios.post('/api/growth/checkDailySalesExists', { date: updateDate, channel: 'rocket' });
						this.collectionCheckDate = updateDate;
						if (checkResult.data.res === 'success' && !checkResult.data.exists) {
							this.todayCollectionNeeded = true;
							this.$bvToast.toast('오늘자 판매현황을 수집해주세요!', {
								title: '데이터 수집 필요',
								variant: 'warning',
								solid: true,
								autoHideDelay: 3000
							});
						} else {
							this.todayCollectionNeeded = false;
						}
					} catch (error) {
						console.error('수집 여부 확인 실패:', error);
					}
				});
			} catch (e) {
				alert('로켓배송 판매현황 가져오기 실패')
				console.error(e)
				this.showlist = false;
				this.showspinner = false;
				this.showspinner1 = false;
			}
		},
		generateDatesFromUpdateDate(updateDate) {
			if (!updateDate) return [];
			const baseDate = new Date(updateDate);
			// 어제를 기준으로 설정 (오늘 데이터 제외)
			baseDate.setDate(baseDate.getDate() - 1); // 하루 빼서 어제로 설정
			const dates = [];
			// 어제부터 30일 전까지 생성 (오름차순 정렬)
			for (let i = 29; i >= 0; i--) {
				const d = new Date(baseDate);
				d.setDate(baseDate.getDate() - i);
				dates.push(d.toISOString().split('T')[0]);
			}

			// console.log(`generateDatesFromUpdateDate: updateDate=${updateDate}, 어제=${baseDate.toISOString().split('T')[0]}, 생성된 날짜 범위=${dates[0]} ~ ${dates[dates.length-1]}`);
			return dates;
		},
		datetotimestamp(a) {
			var date = new Date(a);
			return date.getTime();
		},
		async searchresult(arr) {
			if (!arr || arr.length === 0) {
				alert('로켓배송 판매현황이 없습니다.');
				this.showlist = false;
				this.showspinner = false;
				this.showspinner1 = false;
				return;
			}

			this.needPo = 0;
			this.saleslists = [];
			this.saleslistsinit = [];

			// 입고 날짜 미리 수집
			this.collectInboundDates(arr);


			// SCM 데이터와 판매 데이터 병합
			const applyScmData = (item) => {
				const scmItem = this.scmData[item.vendorItemId];
				if (scmItem) {
					// console.log('🔍 [DEBUG] applyScmData 적용:', {
					// 	vendorItemId: item.vendorItemId,
					// 	기존값: {
					// 		입고기간: item.입고기간,
					// 		최대재고기간: item.최대재고기간,
					// 		최소재고기간: item.최소재고기간,
					// 		MOQ수량: item.MOQ수량
					// 	},
					// 	ScmDB값: {
					// 		inboundPeriod: scmItem.inboundPeriod,
					// 		targetStockDays: scmItem.targetStockDays,
					// 		safetyStockDays: scmItem.safetyStockDays,
					// 		moqQuantity: scmItem.moqQuantity
					// 	}
					// });
					// SCM 데이터가 있으면 해당 값으로 덮어쓰기
					item.구매 = scmItem.purchase || 0;
					item.배대지 = scmItem.overseas || 0;
					item.통관중 = scmItem.customs || 0;
					item.국내재고 = scmItem.domesticStock || 0;
					item.입고기간 = scmItem.inboundPeriod || item.입고기간 || 0;
						// ➕ ScmDB의 단계별 입고기간 필드도 적용
						item.배대지입고기간 = scmItem.overseasInputDays || item.배대지입고기간 || this.baseSettings.overseasInputDays;
						item.통관중입고기간 = scmItem.customsInputDays || item.통관중입고기간 || this.baseSettings.customsInputDays;
						item.국내입고기간 = scmItem.domesticInputDays || item.국내입고기간 || this.baseSettings.domesticInputDays;

					item.최대재고기간 = scmItem.targetStockDays || item.최대재고기간 || 0;
					item.최소재고기간 = scmItem.safetyStockDays || item.최소재고기간 || 0;
					item.MOQ수량 = scmItem.moqQuantity !== undefined ? scmItem.moqQuantity : 2;
					item.메모 = scmItem.memo || '';
					item.목표일판매수량 = scmItem.targetDailySales || 0;
				} else {
					console.log('🔍 [DEBUG] applyScmData ScmDB에 데이터 없음:', item.vendorItemId);
					// SCM 데이터가 없는 경우에도 기본값 설정
					item.MOQ수량 = item.MOQ수량 || 2;
					item.목표일판매수량 = 0;
				}
				return item;
			};

			arr.sort((a, b) => b.월판매수량 - a.월판매수량);

			arr = arr.map(e => applyScmData(e));

			// 쿠패스연동 데이터 적용 (쿠패스 ON이면 실시간 데이터가 SCM 수동입력보다 우선)
			const coupassScmUpdates = [];
			const applyCoupassData = (item) => {
				if (!this.coupassSyncEnabled) return item;

				const productItem = this.$store.state.productdb.find(g => g.vendorItemId === item.vendorItemId);
				if (!productItem || !productItem.barcode) return item;

				let 구매완료재고 = 0;
				let 배대지재고 = 0;
				let 통관중재고 = 0;

				if (this.coupassData.length) {
					const matchedItems = this.coupassData.filter(c => c.바코드 === productItem.barcode);
					matchedItems.forEach(matched => {
						const 수량 = parseInt(matched.구매요청수량) || 0;
						switch(matched.processStatus) {
							case '구매완료':
							case '배송중':
								구매완료재고 += 수량;
								break;
							case '배송완료':
							case '입고작업':
							case '출고확인대기':
							case '재고대기':
							case '출고요청':
							case '출고대기':
							case '중국재고':
								배대지재고 += 수량;
								break;
							case '국내창고입고중':
								통관중재고 += 수량;
								break;
						}
					});

					item.구매 = 구매완료재고;
					item.배대지 = 배대지재고;
					item.통관중 = 통관중재고;
				}

				const 국내재고 = this.inventoryMap[productItem.barcode] || 0;
				item.국내재고 = 국내재고;

				coupassScmUpdates.push({
					vendorItemId: item.vendorItemId,
					coupassPurchase: 구매완료재고,
					coupassOverseas: 배대지재고,
					coupassCustoms: 통관중재고,
					coupassDomesticStock: 국내재고
				});

				return item;
			};

			arr = arr.map(e => applyCoupassData(e));

			// 쿠패스 계산 결과를 RocketScmDB에 일괄 저장
			if (coupassScmUpdates.length > 0) {
				try {
					await axios.post('/api/batchUpdateRocketScmData', coupassScmUpdates);
				} catch (error) {
					console.error('쿠패스 재고 RocketScmDB 저장 오류:', error);
				}
			}

			// ✅ 일별 데이터는 이미 buildSalesDataFromDailySales에서 처리됨

			// 🔥 성능 최적화: rocketSales를 Map으로 미리 인덱싱 (O(n) find → O(1) lookup)
			const rocketSalesMap = new Map();
			if (this.$store.state.rocketSales?.length > 0) {
				this.$store.state.rocketSales.forEach(f => {
					rocketSalesMap.set(f.vendorItemId, f);
				});
			}

			// 🔥 배치 처리 + 진행률 표시 + lazy chart
			const totalCount = arr.length;
			const BATCH_SIZE = 200;
			const todayDate = new Date();
			const tempSaleslists = [];
			const tempSaleslistsinit = [];

			const processItem = (e) => {
				// 최대입고기간과 보관료 계산
				if (e.inboundInfo?.cfsStowedDetailList?.length > 0) {
					const oldestDate = new Date(e.inboundInfo.cfsStowedDetailList[0].inboundDate);
					e.최대입고기간 = Math.floor((todayDate - oldestDate) / (1000 * 60 * 60 * 24));
				} else {
					e.최대입고기간 = 0;
				}
				e.보관료 = parseFloat(e.inventoryDetails?.storageFee?.monthlyStorageFeeAmount?.amount || 0);

				// 반품상품
				if (e.returnProducts?.length > 0) {
					for (const a of e.returnProducts) {
						if (a.inboundInfo?.cfsStowedDetailList?.length > 0) {
							const oldestDate = new Date(a.inboundInfo.cfsStowedDetailList[0].inboundDate);
							a.최대입고기간 = Math.floor((todayDate - oldestDate) / (1000 * 60 * 60 * 24));
						} else {
							a.최대입고기간 = 0;
						}
						a.보관료 = parseFloat(a.inventoryDetails?.storageFee?.monthlyStorageFeeAmount?.amount || 0);
					}
				}

				// 번들 상품 처리
				if (e.upBundlingProducts?.length > 0) {
					for (const bundle of e.upBundlingProducts) {
						if (bundle.inboundInfo?.cfsStowedDetailList?.length > 0) {
							const oldestDate = new Date(bundle.inboundInfo.cfsStowedDetailList[0].inboundDate);
							bundle.최대입고기간 = Math.floor((todayDate - oldestDate) / (1000 * 60 * 60 * 24));
						} else {
							bundle.최대입고기간 = 0;
						}
						bundle.보관료 = parseFloat(bundle.inventoryDetails?.storageFee?.monthlyStorageFeeAmount?.amount || 0);
					}
				}

				// mean과 forecastSeries 계산
				let startIndex = e.salesHistory ? e.salesHistory.findIndex(element => element !== 0) : -1;
				let mean = 0;
				if (startIndex !== -1) {
					let sum = 0;
					for (let i = startIndex; i < e.salesHistory.length; i++) {
						sum += e.salesHistory[i];
					}
					mean = sum / (e.salesHistory.length - startIndex);
				}

				const maxDays = Math.max(parseInt(e.입고기간 ? e.입고기간 : this.baseSettings.inputDays) + (e.최대재고기간 ? e.최대재고기간 : this.baseSettings.targetDays), 30);
				const forecastSeries = Array(maxDays).fill(mean);

				// 기존 데이터 확인 및 설정값 적용
				const f = rocketSalesMap.get(e.vendorItemId);
				let 최대재고기간, 최소재고기간, 입고기간, MOQ수량, 배대지입고기간, 국내입고기간;
				let 구매, 배대지, 국내재고, 메모;
				const forecastAI = [];
				const keywordForecast = [];

				if (f) {
					최대재고기간 = f.최대재고기간 ? parseInt(f.최대재고기간) : this.baseSettings.targetDays;
					최소재고기간 = f.최소재고기간 ? parseInt(f.최소재고기간) : this.baseSettings.safetyDays;
					입고기간 = f.입고기간 ? parseInt(f.입고기간) : this.baseSettings.inputDays;
					MOQ수량 = f.MOQ수량 !== undefined ? parseInt(f.MOQ수량) : this.baseSettings.moqQuantity;
					배대지입고기간 = f.배대지입고기간 ? parseInt(f.배대지입고기간) : this.baseSettings.overseasInputDays;
					국내입고기간 = f.국내입고기간 ? parseInt(f.국내입고기간) : this.baseSettings.domesticInputDays;
					구매 = parseInt(f.구매) || 0;
					배대지 = parseInt(f.배대지) || 0;
					국내재고 = f.국내재고 ? parseInt(f.국내재고) : 0;
					메모 = f.메모 || '';
				} else {
					입고기간 = this.baseSettings.inputDays;
					최대재고기간 = this.baseSettings.targetDays;
					최소재고기간 = this.baseSettings.safetyDays;
					MOQ수량 = this.baseSettings.moqQuantity;
					배대지입고기간 = this.baseSettings.overseasInputDays;
					국내입고기간 = this.baseSettings.domesticInputDays;
					구매 = 0;
					배대지 = 0;
					국내재고 = 0;
					메모 = '';
					e.MOQ수량 = MOQ수량;
				}

				const dates = e.updateDate ? this.generateDatesFromUpdateDate(e.updateDate) : this.getMonthDates();
				const histLen = e.salesHistory ? e.salesHistory.length : 30;
				const zeroArr = Array(histLen).fill(0);

				// 번들 상품의 판매 히스토리 처리
				if (e.upBundlingProducts?.length > 0) {
					e.upBundlingProducts.forEach(bundle => {
						if (!bundle.salesHistory || bundle.salesHistory.length === 0) bundle.salesHistory = zeroArr;
						bundle.visitorHistory = bundle.visitorHistory || zeroArr;
						bundle.pageViewHistory = bundle.pageViewHistory || zeroArr;
						bundle.cartHistory = bundle.cartHistory || zeroArr;
						bundle.orderHistory = bundle.orderHistory || zeroArr;
						bundle.pvToOrder = bundle.pvToOrder || zeroArr;
					});
				}

				// 반품 상품의 판매 히스토리 처리
				if (e.returnProducts?.length > 0) {
					e.returnProducts.forEach(returnProduct => {
						if (!returnProduct.salesHistory || returnProduct.salesHistory.length === 0) returnProduct.salesHistory = zeroArr;
						returnProduct.visitorHistory = returnProduct.visitorHistory || zeroArr;
						returnProduct.pageViewHistory = returnProduct.pageViewHistory || zeroArr;
						returnProduct.cartHistory = returnProduct.cartHistory || zeroArr;
						returnProduct.orderHistory = returnProduct.orderHistory || zeroArr;
						returnProduct.pvToOrder = returnProduct.pvToOrder || zeroArr;
					});
				}

				// 임시 데이터 객체 생성 (chart는 lazy — 모달 열 때 생성)
				const itemData = {
					...e,
					dates, 구매, 배대지, 국내재고, 입고기간,
					최대재고기간, 최소재고기간, MOQ수량, 배대지입고기간, 국내입고기간,
					chart: null, forecastSeries, forecastAI, keywordForecast,
					메모, 일판매수량: e.일판매수량,
					isModified: false, 장기입고중: 0, 단기입고중: 0
				};

				// 메트릭 계산
				const calculatedMetrics = this.calculateInventoryMetrics(itemData);

				// 발주 데이터 미리 계산
				const matchedPOs = this.getMatchedPOs(itemData);
				const poQty = matchedPOs.reduce((sum, po) => sum + (po.확정수량 || 0), 0);
				let poTooltip = '';
				if (matchedPOs.length > 0) {
					poTooltip = '발주서 현황 (' + matchedPOs.length + '건)\n' +
						matchedPOs.map(po =>
							(po.발주번호 || '') + ' | ' + (po.확정수량 || 0) + '개 | ' +
							(po.입고예정일 || '') + ' | ' + (po.발주센터 || '')
						).join('\n');
				}

				const finalItemData = {
					...itemData,
					...calculatedMetrics,
					forecastSeriesQty: forecastSeries.slice(0, 30).reduce((pv, cv) => pv + cv, 0),
					forecastAIQty: 0,
					_poQty: poQty,
					_poTooltip: poTooltip
				};

				tempSaleslistsinit.push(finalItemData);
				if (!finalItemData.hidden) {
					tempSaleslists.push(finalItemData);
				}
			};

			// 배치 처리로 UI 블로킹 방지 + 진행률 표시
			for (let batchStart = 0; batchStart < totalCount; batchStart += BATCH_SIZE) {
				const batchEnd = Math.min(batchStart + BATCH_SIZE, totalCount);

				for (let i = batchStart; i < batchEnd; i++) {
					processItem(arr[i]);
				}

				// 진행률 업데이트
				const progress = Math.round((batchEnd / totalCount) * 100);
				this.loadingtext = `상품 데이터 처리 중... ${progress}% (${batchEnd}/${totalCount})`;

				// UI 스레드에 제어권 양보
				if (batchEnd < totalCount) {
					await new Promise(resolve => setTimeout(resolve, 0));
				}
			}

			this.saleslists = tempSaleslists;
			this.saleslistsinit = tempSaleslistsinit;

			// 재고커버리지(C-store) 영속화 — 광고대시보드 R_cov 입력 (theory §16)
			try {
				const coveragePayload = this.saleslistsinit.map(item => ({
					vendorItemId: item.vendorItemId,
					deliveryType: '로켓배송',
					stockDays: item.남은재고기간,
					dailySales: item.일판매수량,
					leadTime: item.입고기간
				}));
				await axios.post('/api/saveInventoryCoverage', coveragePayload);
			} catch (err) {
				console.error('saveInventoryCoverage 오류:', err);
			}

			// 통계 업데이트 (updateCounts 메서드 사용)
			this.updateCounts();

			// 정렬: 저장된 순서가 있으면 우선 적용, 없으면 기본 정렬
			this.applyDefaultSort();

			// 쿠패스연동 시 입고 상태 자동 업데이트
			if (this.coupassSyncEnabled) {
				this.autoUpdateReqpurchaseStatus();
			}

			// UI 업데이트
			this.$nextTick(() => {
				this.showlist = true;
				this.showspinner = false;
				this.showspinner1 = false;
				this.loadingtext = '';
			});
		},
		calculateOldestAndTotalQty(data) {
			const today = new Date(); // 오늘 날짜 설정
			const thirtyDaysAgo = new Date();
			thirtyDaysAgo.setDate(today.getDate() - 30);

			let totalQty = 0;
			let oldestDate = null;
			let daysAgo = null;

			data.forEach(item => {
				const inboundDate = new Date(item.inboundDate);

				// 30일 이상 지난 항목 처리
				if (inboundDate < thirtyDaysAgo) {
					totalQty += item.remainingSkuQty; // 합산
					if (!oldestDate || inboundDate < oldestDate) {
						oldestDate = inboundDate; // 가장 오래된 날짜 업데이트
					}
				}
			});

			// 가장 오래된 날짜와 오늘의 차이를 계산
			if (oldestDate) {
				daysAgo = Math.floor((today - oldestDate) / (1000 * 60 * 60 * 24)); // 날짜 차이 계산
			}

			return {
				totalQty,
				oldestDaysAgo: daysAgo // 며칠 전인지 반환
			};
		},
		deepClone(obj) {
			if (obj === null || typeof obj !== "object") {
				return obj
			}

			const result = Array.isArray(obj) ? [] : {}

			for (let key of Object.keys(obj)) {
				result[key] = this.deepClone(obj[key])
			}

			return result
		},
		todate(date) {
			var today = new Date(date);
			today.setHours(today.getHours() + 9);
			return today.toISOString().replace('T', ' ').substring(0, 19);
		},
		timestamp(date) {
			//inputdate = "yyyy-mm-dd"
			return new Date(date).getTime()
		},
		getTodaywith() {
			var date = new Date();
			var year = date.getFullYear();
			var month = ("0" + (1 + date.getMonth())).slice(-2);
			var day = ("0" + date.getDate()).slice(-2);

			return year + "-" + month + "-" + day;
		},
		timestamptodate(timestamp) {
			var date = new Date(timestamp);
			var year = date.getFullYear();
			var month = ("0" + (1 + date.getMonth())).slice(-2);
			var day = ("0" + date.getDate()).slice(-2);

			return year + "-" + month + "-" + day;
		},
		downloadsales() {
			function getToday() {
				var date = new Date();
				var year = date.getFullYear();
				var month = ("0" + (1 + date.getMonth())).slice(-2);
				var day = ("0" + date.getDate()).slice(-2);

				return year + month + day;
			}
			var arr = [];
			var obj = {};
			console.log(this.saleslists)
			this.saleslists.forEach(e => {
				obj = {
					SKUID: e.SKUID,
					옵션ID: e.vendorItemId,
					상품명: e.판매상품명,
					옵션명: e.옵션명,
					발주가능상태: e.발주가능상태,
					구매필요수량: e.구매필요수량,
					안전재고: e.안전재고,
					쿠팡내재고: e.재고,
					출고: e.판매,
					입고리드타임: e.입고리드타임,
					// 재고기준일 : e.재고기준일,
					일판매수량: e.일판매수량
				}
				arr.push(obj)
			})
			const workBook = XLSX.utils.book_new()
			const workSheet1 = XLSX.utils.json_to_sheet(arr)
			XLSX.utils.book_append_sheet(workBook, workSheet1, '발주수요예측')
			XLSX.writeFile(workBook, '발주수요예측' + '_' + getToday() + '.xlsx')
		},
		// 메소드를 호출하는 곳에서도 async/await 사용
		async setDateRange(item, days) {
			// 데이터 범위 확인
			const maxAvailableDays = item.salesHistory.length;

			// 요청 일수가 가용 데이터보다 크면 조정
			const adjustedDays = Math.min(days, maxAvailableDays);
			if (adjustedDays !== days) {
				console.log(`요청된 ${days}일이 가용 데이터 ${maxAvailableDays}일보다 커서 ${adjustedDays}일로 조정됨`);
			}
			// 공통 함수를 사용해서 어제까지 날짜 범위 계산
			const todayStr = this.getTodayString();
			const allDates = this.generateDatesFromUpdateDate(todayStr);

			// 요청된 일수만큼 뒤에서부터 가져오기
			const requestedDates = allDates.slice(-days);

			item.startDate = requestedDates[0];
			item.endDate = requestedDates[requestedDates.length - 1];
			console.log(item.startDate, item.endDate)

			// updateDateRange 호출하여 데이터 업데이트
			await this.updateDateRange(item);
		},
		formatDateYMD(date) {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		},

		async updateDateRange(item) {
			if (item.startDate && item.endDate) {
				// 선택된 날짜 범위가 데이터에 있는지 확인
				const startIndex = item.dates.findIndex(d => d >= item.startDate);
				const endIndex = item.dates.findIndex(d => d >= item.endDate);

				// 유효한 범위인지 확인
				if (startIndex !== -1 && (endIndex !== -1 || item.endDate > item.dates[item.dates.length - 1])) {
					const endIdx = endIndex !== -1 ? endIndex : item.dates.length - 1;

					// 해당 기간의 판매 이력 추출
					const filteredSalesHistory = item.salesHistory.slice(startIndex, endIdx + 1);

					if (filteredSalesHistory.length > 0) {
						// 일평균 판매량 재계산
						const customDailySales = filteredSalesHistory.reduce((sum, val) => sum + val, 0) / filteredSalesHistory.length;

						// 원래 값 백업
						const originalDailySales = item.일판매수량;

						// 임시로 변경
						item.일판매수량 = customDailySales;

						// 선택된 기간에 대한 메트릭 계산
						const customMetrics = this.calculateInventoryMetrics(item);

						// 원래 값으로 복원
						item.일판매수량 = originalDailySales;

						// 계산된 메트릭 저장
						item.customPeriodMetrics = {
							dday: customMetrics.dday,
							구매필요수량: customMetrics.구매필요수량,
							neededStockDays: this.calculateNeededStockDays({
								...item,
								일판매수량: customDailySales
							}),
							일판매수량: customDailySales
						};

						// 차트에 선택된 기간 표시
						if (this.$refs.mainChart && this.$refs.mainChart.chart) {
							const chart = this.$refs.mainChart.chart;

							// 기존 주석 제거
							if (chart.opts.annotations && chart.opts.annotations.xaxis) {
								chart.clearAnnotations();
							}

							// 선택된 범위에 주석 추가
							const annotations = {
								xaxis: [{
									x: item.dates[startIndex],
									x2: item.dates[endIdx],
									borderColor: '#77B6EA',
									fillColor: '#77B6EA',
									opacity: 0.2,
									label: {
										borderColor: '#77B6EA',
										style: {
											color: '#fff',
											background: '#77B6EA'
										},
										text: '선택된 기간'
									}
								}]
							};

							chart.updateOptions({ annotations }, false, true);
						}

						// 판매량 차트도 업데이트
						this.$nextTick(() => {
							if (this.$refs.salesChart && this.$refs.salesChart.chart) {
								try {
									const salesChart = this.$refs.salesChart.chart;
									const salesChartOption = this.getSalesChartOption(item);
									if (salesChartOption && salesChartOption.series) {
										salesChart.updateOptions(salesChartOption, true, true);
									}
								} catch (error) {
									console.error('판매량 차트 업데이트 오류:', error);
								}
							}
						});
					}
				}
			}
		},
		updateItemValues(item) {
			return this.calculateInventoryMetrics(item);
		},
		getUpdatedChartOption(item) {
			// console.log(item)
			const validateData = (data) => {
				if (!Array.isArray(data)) return Array(30).fill(0);
				return data.map(val => {
					const num = Number(val);
					return isNaN(num) ? 0 : num;
				});
			};

			const salesHistory = validateData(item.salesHistory);
			const visitorHistory = validateData(item.visitorHistory);
			const pageViewHistory = validateData(item.pageViewHistory);
			const cartHistory = validateData(item.cartHistory);
			const orderHistory = validateData(item.orderHistory);
			const pvToOrder = validateData(item.pvToOrder);
			// const forecastSeries = validateData(item.forecastSeries);
			// const forecastAI = validateData(item.forecastAI);

			// X축 범위 수정
			const displayDays = Math.max(30, parseInt(item.입고기간) + this.baseSettings.targetDays);
			const dates = item.dates.slice(0, displayDays);

			const salesMax = Math.max(
				...salesHistory,
				// ...forecastSeries,
				// ...forecastAI,
				1
			) * 1.1;

			const trafficMax = Math.max(
				...visitorHistory,
				...pageViewHistory,
				...cartHistory,
				...orderHistory,
				1
			) * 1.1;

			const conversionMax = Math.max(
				...pvToOrder,
				0.1
			) * 1.1;

			// 입고 이벤트 annotations 생성
			const inboundAnnotations = this.createInboundAnnotations(item, dates);

			// 기본 시리즈 배열 (번들/반품 제외)
			const series = [
				{
					name: '판매량',
					data: salesHistory.map(val => val || 0),
					type: 'column'
				},
				{
					name: '방문자수',
					type: 'line',
					data: visitorHistory.map(val => val || 0)
				},
				{
					name: '페이지뷰',
					type: 'line',
					data: pageViewHistory.map(val => val || 0)
				},
				{
					name: '장바구니',
					type: 'line',
					data: cartHistory.map(val => val || 0)
				},
				{
					name: '주문건수',
					type: 'line',
					data: orderHistory.map(val => val || 0)
				},
				{
					name: '전환율(%)',
					type: 'line',
					data: pvToOrder.map(val => val || 0)
				}
			];

			return {
				series: series,
				annotations: {
					xaxis: inboundAnnotations
				},
				chart: {
					height: 500,
					animations: { enabled: false },
					toolbar: {
						show: true
					},
					parentHeightOffset: 0,   // 부모 컨테이너와의 간격 제거
					offsetY: 0
				},
				plotOptions: {
					bar: {
						columnWidth: '30%',  // bar 너비 조절
						opacity: 0.4         // bar 투명도 조절
					}
				},
				stroke: {
					width: [0, 3, 3, 3, 3, 3],  // line 그래프 두께 증가
					curve: 'smooth'
				},
				colors: [
					'rgba(0, 143, 251, 0.5)',   // bar 차트 색상 (투명도 포함)
					'#00E396',
					'#FEB019',
					'#FF4560',
					'#775DD0',
					'#26a69a'
				],
				markers: {
					size: [0, 0, 0, 0, 0, 6],   // 전환율만 마커 표시
					colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#26a69a'],
					strokeColors: '#fff',
					strokeWidth: 2,
					hover: {
						size: 8
					}
				},
				xaxis: {
					categories: dates,
					labels: {
						style: { fontSize: '12px' }
					}
				},
				yaxis: [
					{
						seriesName: '판매량',
						title: {
							text: '판매수량',
							offsetX: 0,
							offsetY: -10
						},
						min: 0,
						max: salesMax,
						labels: {
							formatter: (val) => Math.round(val).toString()
						}
					},
					{
						seriesName: ['방문자수', '페이지뷰', '장바구니', '주문건수'],
						title: { text: '트래픽/주문' },
						min: 0,
						max: trafficMax,
						opposite: true,
						labels: {
							formatter: (val) => Math.round(val).toString()
						},
						show: true
					},
					{
						seriesName: '전환율(%)',
						title: {
							text: '전환율(%)',
							offsetX: -20
						},
						min: 0,
						max: conversionMax,
						opposite: true,
						labels: {
							formatter: (val) => val.toFixed(2) + '%',
							offsetX: -30
						},
						tickAmount: 5
					}
				],
				tooltip: {
					enabled: true,
					shared: true,
					intersect: false,
					followCursor: true,
					x: {
						show: true
					},
					custom: ({ series, dataPointIndex, w }) => {
						const date = w.globals.categoryLabels[dataPointIndex];

						// 기본 tooltip 내용
						let tooltipContent = `<div class="custom-tooltip" style="padding: 10px; background: #fff; border: 1px solid #ccc; border-radius: 4px;">`;
						tooltipContent += `<div style="font-weight: bold; margin-bottom: 5px;">${date}</div>`;

						// 각 시리즈 데이터 표시
						const seriesNames = ['판매량', '방문자수', '페이지뷰', '장바구니', '주문건수', '전환율(%)'];
						series.forEach((seriesData, index) => {
							const value = seriesData[dataPointIndex];
							if (value !== undefined && value !== null) {
								const formattedValue = index === 5 ? `${value.toFixed(2)}%` : Math.round(value).toString();
								tooltipContent += `<div>${seriesNames[index]}: ${formattedValue}</div>`;
							}
						});

						// 입고 정보 추가
						const inboundInfo = this.getInboundInfoForDate(item, date);
						if (inboundInfo) {
							tooltipContent += `<div style="border-top: 1px solid #eee; margin-top: 5px; padding-top: 5px; color: #00E396; font-weight: bold;">`;
							tooltipContent += `입고재고: ${inboundInfo.remainingSkuQty}개</div>`;
						}

						tooltipContent += `</div>`;
						return tooltipContent;
					},
					marker: {
						show: true
					},
					fixed: {
						enabled: false,
						position: 'topRight'
					}
				},
				dataLabels: { enabled: false },
				legend: {
					position: 'top',           // legend 위치를 상단으로
					horizontalAlign: 'center', // 가운데 정렬
					offsetY: 0,               // 상단 여백
					offsetX: 0,               // 좌우 여백
					floating: true,           // legend를 차트 영역 위에 띄움
					itemMargin: {
						horizontal: 15,
						vertical: 5
					},
					height: 30,              // legend 영역 높이
					fontSize: '13px',
					markers: {
						width: 12,
						height: 12,
						strokeWidth: 0,
						radius: 12
					}
				},
				grid: {
					padding: {
						top: 30,    // 상단 여백 추가
						bottom: 10   // 하단 여백
					}
				},
			};
		},
		createInboundAnnotations(item, dates) {
			// 입고상세내역이 없으면 빈 배열 반환
			if (!item.inboundInfo || !item.inboundInfo.cfsStowedDetailList || !Array.isArray(item.inboundInfo.cfsStowedDetailList)) {
				return [];
			}

			const annotations = [];
			let labelOffsetY = 10; // 라벨 위치를 위아래로 조정하기 위한 변수

			// 날짜순으로 정렬하여 겹침 방지
			const sortedInboundList = [...item.inboundInfo.cfsStowedDetailList]
				.filter(detail => detail.remainingSkuQty > 0)
				.sort((a, b) => new Date(a.inboundDate) - new Date(b.inboundDate));

			sortedInboundList.forEach((inboundDetail, index) => {
				// 입고일자를 YYYY-MM-DD 형식으로 변환
				const inboundDate = new Date(inboundDetail.inboundDate).toISOString().split('T')[0];

				// 차트의 dates 배열에서 해당 날짜의 인덱스 찾기
				const dateIndex = dates.findIndex(date => date === inboundDate);

				// 해당 날짜가 차트 범위에 있는 경우에만 annotation 추가
				if (dateIndex >= 0) {
					// 라벨 위치를 번갈아가며 조정하여 겹침 방지
					const currentOffsetY = index % 2 === 0 ? labelOffsetY : labelOffsetY + 25;

					annotations.push({
						x: inboundDate,
						strokeDashArray: 0,
						borderColor: '#00E396',
						borderWidth: 2,
						label: {
							borderColor: '#00E396',
							style: {
								color: '#fff',
								background: '#00E396',
								fontSize: '10px',
								fontWeight: 'bold'
							},
							orientation: 'horizontal',
							offsetY: currentOffsetY,
							text: `입고재고:${inboundDetail.remainingSkuQty}개`
						}
					});
				}
			});

			return annotations;
		},
		getInboundInfoForDate(item, date) {
			// 입고상세내역이 없으면 null 반환
			if (!item.inboundInfo || !item.inboundInfo.cfsStowedDetailList || !Array.isArray(item.inboundInfo.cfsStowedDetailList)) {
				return null;
			}

			// 해당 날짜의 입고 정보 찾기
			const inboundDetail = item.inboundInfo.cfsStowedDetailList.find(detail => {
				const inboundDate = new Date(detail.inboundDate).toISOString().split('T')[0];
				return inboundDate === date && detail.remainingSkuQty > 0;
			});

			return inboundDetail || null;
		},
		resetChartData(item) {
			if (!item) return;

			// 차트가 없으면 lazy 생성
			if (!item.chart) {
				const dates = item.dates || this.getMonthDates();
				item.chart = this.generateChartData(item, item.forecastSeries || [], item.forecastAI || [], dates);
			}

			// 모달에서 사용할 계산값 미리 저장
			const metrics = this.calculateInventoryMetrics(item);
			item.남은재고기간 = metrics.남은재고기간;
			item.구매필요수량 = metrics.구매필요수량;
			item.dday = metrics.dday;

			// 커스텀 기간 메트릭 초기화
			item.customPeriodMetrics = null;

			const chartOption = this.getUpdatedChartOption(item);

			this.$nextTick(() => {
				if (this.$refs.mainChart && this.$refs.mainChart.chart) {
					this.$refs.mainChart.chart.updateOptions(chartOption, true, true);
				}
			});
		},
		calculateForecast(salesHistory, days) {
			const avgSales = salesHistory.reduce((sum, val) => sum + val, 0) / salesHistory.length;
			return Array(days).fill(avgSales);
		},
		closeModal(event, item) {
			event.preventDefault();
			if (this.$refs.mainChart && this.$refs.mainChart.chart) {
				this.$refs.mainChart.chart.destroy();
			}
			this.$nextTick(() => {
				this.$bvModal.hide('poQty' + item.vendorItemId)
			});
		},
		async calculateDailyStats() {
			try {
				const endDate = new Date();
				const startDate = new Date();
				startDate.setDate(startDate.getDate() - this.selectedPeriod);

				const dailyStats = [];
				for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
					const formattedDate = this.formatDate(d.toISOString().split('T')[0]);
					let revenue = 0;
					let profit = 0;

					if (this.saleslistsinit && Array.isArray(this.saleslistsinit)) {
						this.saleslistsinit.forEach(sale => {
							if (!sale || !sale.salesHistory || !Array.isArray(sale.salesHistory)) {
								return;
							}

							const dayIndex = sale.dates.indexOf(d.toISOString().split('T')[0]);
							if (dayIndex >= 0) {
								const quantity = sale.salesHistory[dayIndex] || 0;
								const dbItem = this.$store.state.productdb.find(x => x.vendorItemId === sale.vendorItemId);

								if (dbItem && typeof dbItem.salePrice === 'number' && typeof dbItem.마진 === 'number') {
									revenue += quantity * (dbItem.salePrice - dbItem.coupon);
									profit += quantity * dbItem.마진;
								}
							}
						});
					}

					dailyStats.push({
						date: formattedDate,
						revenue: Math.round(revenue),
						profit: Math.round(profit)
					});
				}

				this.dailyStats = dailyStats;
				await this.$nextTick();
				await this.updateRevenueChart();
				this.updateProfitTop10Chart();
				this.updateConversionChart(); // 전환율 차트 업데이트 추가
				this.updateMaxCpcChart();
			} catch (error) {
				console.error('Error calculating daily stats:', error);
				this.dailyStats = [];
			}
		},

		async updateRevenueChart() {
			try {
				if (!this.dailyStats || this.dailyStats.length === 0) {
					console.warn("일일 통계 데이터가 없습니다.");
					return;
				}

				// 데이터 준비
				const revenueData = this.dailyStats.map(day => ({
					x: day.date,
					y: day.revenue || 0
				}));

				const profitData = this.dailyStats.map(day => ({
					x: day.date,
					y: day.profit || 0
				}));

				const categories = this.dailyStats.map(day => day.date);

				// 새로운 옵션 설정
				const newOptions = {
					series: [{
						name: '매출',
						type: 'line',
						data: revenueData
					}, {
						name: '수익',
						type: 'line',
						data: profitData
					}],
					xaxis: {
						...this.revenueChartOption.xaxis,
						categories: categories
					}
				};

				// 차트 업데이트
				this.revenueChartOption = {
					...this.revenueChartOption,
					...newOptions
				};

				await this.$nextTick();
				const chartElement = document.querySelector('#revenue-chart');
				if (chartElement && chartElement.__vue__ && chartElement.__vue__.chart) {
					chartElement.__vue__.chart.updateOptions(this.revenueChartOption, false, true);
				}
			} catch (error) {
				console.error('차트 업데이트 중 오류 발생:', error);
			}
		},

		changePeriod(days) {
			this.selectedPeriod = days;
			this.calculateDailyStats();
		},

		// formatNumber(value) {
		// return new Intl.NumberFormat('ko-KR').format(Math.round(value));
		// },
		async uploadfile(event, matchType = 'vendorItemId') {
			try {
				this.showlist = false;
				this.showuploadspinner = true;
				this.currentUploadType = matchType;

				// 업로드 상태 업데이트
				if (matchType === 'barcode') {
					this.uploadstatus2 = '업로드 중...';
				} else {
					this.uploadstatus = '업로드 중...';
				}

				const file = event.target.files[0];
				const data = await this.readFileAsync(file);
				const workbook = XLSX.read(data, { type: 'binary' });

				// 매칭 타입에 따라 특정 시트만 처리
				let targetSheetName;
				if (matchType === 'barcode') {
					// "SCM일괄업로드양식_바코드" 시트 찾기
					targetSheetName = workbook.SheetNames.find(name => name.includes('바코드') || name === 'SCM일괄업로드양식_바코드');
					if (!targetSheetName) {
						alert('바코드 매칭용 시트를 찾을 수 없습니다. "SCM일괄업로드양식_바코드" 시트가 있는지 확인해주세요.');
						this.showuploadspinner = false;
						this.uploadstatus2 = 'excel file upload';
						return;
					}
				} else {
					// "SCM일괄업로드양식_옵션ID" 시트 찾기
					targetSheetName = workbook.SheetNames.find(name => name.includes('옵션ID') || name === 'SCM일괄업로드양식_옵션ID');
					if (!targetSheetName) {
						alert('옵션ID 매칭용 시트를 찾을 수 없습니다. "SCM일괄업로드양식_옵션ID" 시트가 있는지 확인해주세요.');
						this.showuploadspinner = false;
						this.uploadstatus = 'excel file upload';
						return;
					}
				}

				// 처리할 시트 목록 결정 (항상 특정 시트만 처리)
				const sheetsToProcess = [targetSheetName];

				for (const sheetName of sheetsToProcess) {
					const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

					// 매칭 타입에 따른 유효성 검사
					let invalidOption;
					if (matchType === 'barcode') {
						// 바코드로 매칭 - productdb에서 바코드 확인 후 vendorItemId로 rocketSales 확인
						invalidOption = roa.find(e => {
							const productdbItem = this.$store.state.productdb?.find(item => item.barcode === e.바코드);
							if (!productdbItem) return true;
							return !this.$store.state.rocketSales.find(ele => ele.vendorItemId === productdbItem.vendorItemId);
						});
						if (invalidOption) {
							alert(`상품DB에 ${invalidOption.바코드} 바코드가 존재하지 않거나 해당하는 판매 데이터가 없습니다. 상품DB를 다시 수집해주세요.`);
							continue;
						}
					} else {
						// 옵션ID로 매칭
						invalidOption = roa.find(e => !this.$store.state.rocketSales.find(ele => ele.vendorItemId === e.옵션ID));
						if (invalidOption) {
							alert(`상품DB에 ${invalidOption.옵션ID} 옵션ID가 존재하지 않습니다. 로켓배송 상품DB를 다시 수집해주세요.`);
							continue;
						}
					}

					const scmUpdates = []; // ScmDB 업데이트를 위한 배열
					const updatedItems = []; // 로컬에서 업데이트된 항목들

					// 수정된 항목만 업데이트하고 메트릭 재계산
					for (const e of roa) {
						let vendorItemId, ob, item;

						if (matchType === 'barcode') {
							// 바코드로 매칭
							if (!e.바코드) continue;

							// productdb에서 바코드로 vendorItemId 찾기
							const productdbItem = this.$store.state.productdb?.find(item => item.barcode === e.바코드);
							if (!productdbItem) continue;

							vendorItemId = productdbItem.vendorItemId;
						} else {
							// 옵션ID로 매칭
							if (!e.옵션ID) continue;
							vendorItemId = e.옵션ID;
						}

						// 기존 항목 찾기
						ob = this.deepClone(
							this.$store.state.rocketSales.find(ele => ele.vendorItemId === vendorItemId)
						);

						if (!ob) continue; // 항목이 없으면 건너뛰기

						// 로컬 항목 찾기
						item = this.saleslistsinit.find(i => i.vendorItemId === vendorItemId);
						if (!item) continue; // 로컬 항목이 없으면 건너뛰기

						// 변경 여부 확인을 위한 원본 값 저장
						const original = {
							구매: item.구매,
							배대지: item.배대지,
							통관중: item.통관중,
							국내재고: item.국내재고,
							입고기간: item.입고기간,
							배대지입고기간: item.배대지입고기간,
							통관중입고기간: item.통관중입고기간,
							국내입고기간: item.국내입고기간,
							최대재고기간: item.최대재고기간,
							최소재고기간: item.최소재고기간,
							MOQ수량: item.MOQ수량,
							메모: item.메모
						};

						// 새 값 준비
						const newValues = {
							구매: (parseInt(e.구매완료재고) || parseInt(e.구매) || 0),
							배대지: (parseInt(e.배대지재고) || parseInt(e.배대지) || 0),
							통관중: (parseInt(e.통관중재고) || parseInt(e.통관중) || 0),
							국내재고: parseInt(e.국내재고) || 0,
							입고기간: parseInt(e.구매입고기간) || parseInt(e.입고기간) || ob.입고기간 || 0,
							배대지입고기간: parseInt(e.배대지입고기간) || ob.배대지입고기간 || 0,
							통관중입고기간: parseInt(e.통관중입고기간) || ob.통관중입고기간 || 0,
							국내입고기간: parseInt(e.국내입고기간) || ob.국내입고기간 || 0,
							최대재고기간: parseInt(e.목표재고기간) || parseInt(e.최대재고기간) || ob.최대재고기간 || 0,
							최소재고기간: parseInt(e.안전재고기간) || parseInt(e.최소재고기간) || ob.최소재고기간 || 0,
							MOQ수량: parseInt(e.MOQ수량) || ob.MOQ수량 || 0,
							메모: e.메모 || ob.메모 || ''
						};

						// 변경 여부 확인
						let isChanged = false;
						for (const key in newValues) {
							if (newValues[key] !== original[key]) {
								isChanged = true;
								break;
							}
						}

						// 변경된 항목만 처리
						if (isChanged) {
							// 필드 값 업데이트
							item.구매 = newValues.구매;
							item.배대지 = newValues.배대지;
							item.통관중 = newValues.통관중;
							item.국내재고 = newValues.국내재고;
							item.입고기간 = newValues.입고기간;
							item.배대지입고기간 = newValues.배대지입고기간;
							item.통관중입고기간 = newValues.통관중입고기간;
							item.국내입고기간 = newValues.국내입고기간;
							item.최대재고기간 = newValues.최대재고기간;
							item.최소재고기간 = newValues.최소재고기간;
							item.MOQ수량 = newValues.MOQ수량;
							item.메모 = newValues.메모;

							// 메트릭 재계산
							const metrics = this.calculateInventoryMetrics(item);
							item.남은재고기간 = metrics.남은재고기간;
							item.구매필요수량 = metrics.구매필요수량;
							item.dday = metrics.dday;
							item.배대지출고Dday = metrics.배대지출고Dday;
							item.배대지출고필요수량 = metrics.배대지출고필요수량;
							item.통관중출고Dday = metrics.통관중출고Dday;
							item.통관중출고필요수량 = metrics.통관중출고필요수량;
							item.국내출고Dday = metrics.국내출고Dday;
							item.국내출고필요수량 = metrics.국내출고필요수량;

							// Series 계산값도 갱신
							item.seriesDday = this.calculateSeriesDday(item);
							item.seriesNeededQty = this.calculateSeriesNeededQty(item);
							item.seriesNeededDays = this.calculateSeriesNeededDays(item);

							// ScmDB 형식으로 데이터 변환 (모든 필드 포함)
							const scmItem = {
								vendorItemId: vendorItemId,
								purchase: item.구매,
								overseas: item.배대지,
								customs: item.통관중,
								domesticStock: item.국내재고,
								inboundPeriod: item.입고기간,
								overseasInputDays: item.배대지입고기간,
								customsInputDays: item.통관중입고기간,
								domesticInputDays: item.국내입고기간,
								targetStockDays: item.최대재고기간,
								safetyStockDays: item.최소재고기간,
								moqQuantity: item.MOQ수량,
								memo: item.메모,
								targetDailySales: parseFloat(item.목표일판매수량) || 0,
								// 계산된 필드도 포함
								remainingStockDays: item.남은재고기간,
								neededPurchaseQty: item.구매필요수량,
								dday: item.dday
							};

							scmUpdates.push(scmItem);
							updatedItems.push(item);
						}
					}

					try {
						// 변경된 항목이 없는 경우
						if (scmUpdates.length === 0) {
							alert('변경된 항목이 없습니다.');
							this.showuploadspinner = false;
							this.$bvModal.hide('excelupload');
							return;
						}

						// ScmDB에 일괄 업데이트
						const response = await axios.post('/api/batchUpdateRocketScmData', scmUpdates);

						if (response.data.res === 'success') {
							// 결과 메시지 생성
							const matchTypeText = matchType === 'barcode' ? '바코드' : '옵션ID';
							alert(`${matchTypeText} 매칭 업로드 완료: 총 ${roa.length}개 항목 중 ${scmUpdates.length}개 데이터가 성공적으로 업데이트되었습니다.`);
						} else {
							alert(response.data.alert || '일부 데이터 업데이트에 실패했습니다.');
						}
					} catch (error) {
						console.error('데이터 업데이트 오류:', error);
						alert('데이터 업데이트 중 오류가 발생했습니다.');
					}

					this.showuploadspinner = false;
					this.currentUploadType = '';

					// 업로드 상태 초기화
					if (matchType === 'barcode') {
						this.uploadstatus2 = 'excel file upload';
					} else {
						this.uploadstatus = 'excel file upload';
					}

					// ScmDB 데이터를 다시 로드하고 페이지 새로고침
					await this.loadScmData();
					this.search()
				}
			} catch (error) {
				alert(error.message);
				this.showuploadspinner = false;
				this.currentUploadType = '';

				// 업로드 상태 초기화
				if (matchType === 'barcode') {
					this.uploadstatus2 = 'excel file upload';
				} else {
					this.uploadstatus = 'excel file upload';
				}

				this.$store.commit('rocketSalesUpdate', []);
				this.search()
			}
		},
		async readFileAsync(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = (e) => resolve(e.target.result);
				reader.onerror = (error) => reject(error);
				reader.readAsBinaryString(file);
			});
		},
		// 날짜 포맷팅
		formatDate(dateString) {
			if (!dateString) return '-';
			const date = new Date(dateString);
			return date.toLocaleDateString('ko-KR', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit'
			});
		},
		// 짧은 날짜 포맷팅 (MM/DD)
		formatDateShort(dateString) {
			if (!dateString) return '-';
			const date = new Date(dateString);
			return date.toLocaleDateString('ko-KR', {
				month: '2-digit',
				day: '2-digit'
			});
		},
		// 재고 관리 모달 열기 (공통)
		showInventoryModal(item = null) {
			// 모달을 열 때 현재 saleslists 순서를 초기 상태로 저장
			this.originalSaleslistsOrder = [...this.saleslists];
			console.log('재고 관리 모달 열림 - 초기 순서 저장됨');

			// 선택 상태 초기화
			this.inventorySelectedItems = [];

			// 필터링 해제 (전체 상품 표시)
			this.inventoryFilteredVendorItemId = null;

			// 하이라이트 설정 (shown 이벤트에서 사용)
			if (item && !item.isSummaryRow) {
				this.highlightedVendorItemId = item.vendorItemId;
				console.log('재고관리 모달 - 상품 하이라이트 예약:', item.vendorItemId);
			} else {
				this.highlightedVendorItemId = null;
				console.log('재고관리 모달 - 전체 상품 표시');
			}

			this.$bvModal.show('inventoryModal');

			// 모달 스타일 강제 적용
			this.$nextTick(() => {
				this.forceModalStyle('inventoryModal');
			});
		},
		// 재고 관리 모달이 완전히 열린 후 실행
		onInventoryModalShown() {
			console.log('재고 관리 모달 shown 이벤트 발생');
			if (this.highlightedVendorItemId) {
				this.scrollToItemInModal('inventoryTable', this.highlightedVendorItemId);
			}
		},
		// 모달 스타일 강제 적용 함수
		forceModalStyle(modalId) {
			setTimeout(() => {
				const modal = document.getElementById(modalId);
				if (modal) {
					const modalDialog = modal.querySelector('.modal-dialog');
					const modalContent = modal.querySelector('.modal-content');
					const modalBody = modal.querySelector('.modal-body');

					if (modalDialog) {
						modalDialog.style.maxWidth = '98vw';
						modalDialog.style.width = '98vw';
						modalDialog.style.height = '96vh';
						modalDialog.style.maxHeight = '96vh';
						modalDialog.style.margin = '1vh auto';
					}

					if (modalContent) {
						modalContent.style.height = '100%';
						modalContent.style.display = 'flex';
						modalContent.style.flexDirection = 'column';
						modalContent.style.border = 'none';
						modalContent.style.borderRadius = '0';
					}

					if (modalBody) {
						modalBody.style.flex = '1';
						modalBody.style.overflowY = 'auto';
						modalBody.style.padding = '0.5rem';
						modalBody.style.maxHeight = 'none';
					}

					console.log(`모달 ${modalId} 스타일 강제 적용 완료`);
				}
			}, 100);
		},
		// 구매필요수량 모달 열릴 때
		onPoQtyModalShow(item) {
			// 기존 resetChartData 호출
			this.resetChartData(item);

			// 판매량 차트 준비
			this.salesChartReady = false;

			// 데이터 검증 후 차트 준비
			this.$nextTick(() => {
				if (item && item.salesHistory && item.dates) {
					// 약간의 지연 후 차트 렌더링
					setTimeout(() => {
						this.salesChartReady = true;
					}, 100);
				}

				// 모달 스타일 강제 적용
				this.forceModalStyle('poQty' + item.vendorItemId);
			});
		},
		// 입고 수량 tooltip 생성 - 모든 센터 정보 표시
		getInboundTooltip(item, date) {
			if (!item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
				return '';
			}

			// 같은 날짜의 모든 센터 데이터를 찾기
			const inbounds = item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds
				.filter(inb => inb.expectedDeliveryDate === date);

			if (!inbounds || inbounds.length === 0) return '';

			const productName = item.판매상품명 || item.productName || '상품명 없음';
			const optionName = item.옵션명 || item.optionName || '';

			let tooltip = `상품: ${productName}`;
			if (optionName) {
				tooltip += `\n옵션: ${optionName}`;
			}
			tooltip += `\n입고예정일: ${date}`;

			// 여러 센터가 있는 경우 각각 표시
			if (inbounds.length > 1) {
				tooltip += `\n\n📦 센터별 입고 현황 (${inbounds.length}개 센터):`;
				let totalStowed = 0;
				let totalRequested = 0;

				inbounds.forEach((inbound, index) => {
					const stowed = inbound.stowedQuantity || 0;
					const requested = inbound.requestedQuantity || 0;
					const fcName = inbound.fcName || `센터${index + 1}`;

					totalStowed += stowed;
					totalRequested += requested;

					let status = '';
					if (stowed === requested && requested > 0) {
						status = ' ✅완료';
					} else if (stowed > 0 && stowed < requested) {
						status = ' 🟡부분입고';
					} else if (stowed === 0 && requested > 0) {
						status = ' 🔴대기중';
					}

					tooltip += `\n  • ${fcName}: ${stowed}/${requested}${status}`;
				});

				tooltip += `\n\n📊 전체 합계: ${totalStowed}/${totalRequested}`;
			} else {
				// 단일 센터인 경우
				const inbound = inbounds[0];
				const stowed = inbound.stowedQuantity || 0;
				const requested = inbound.requestedQuantity || 0;
				const fcName = inbound.fcName || '센터 정보 없음';

				tooltip += `\n센터: ${fcName}`;
				tooltip += `\n입고 상태: ${stowed}/${requested}`;

				if (stowed === requested && requested > 0) {
					tooltip += ' (입고완료)';
				} else if (stowed > 0 && stowed < requested) {
					tooltip += ' (부분입고)';
				} else if (stowed === 0 && requested > 0) {
					tooltip += ' (입고대기)';
				}
			}

			return tooltip;
		},
		// 전체 종합 tooltip 생성
		getSummaryTooltip(date) {
			if (!this.saleslists || this.saleslists.length === 0) {
				return '';
			}

			let totalStowed = 0;
			let totalRequested = 0;
			let partialInbounds = []; // 부분입고 상품들
			let completeInbounds = []; // 완료입고 상품들
			let pendingInbounds = []; // 입고전 상품들

			this.saleslists.forEach(item => {
				if (item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
					const inbound = item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds
						.find(inb => inb.expectedDeliveryDate === date);

					if (inbound) {
						const stowed = inbound.stowedQuantity || 0;
						const requested = inbound.requestedQuantity || 0;

						totalStowed += stowed;
						totalRequested += requested;

						const productName = item.판매상품명 || item.productName || '상품명 없음';
						const optionName = item.옵션명 || item.optionName || '';
						const fcName = inbound.fcName || '센터 정보 없음';

						const productInfo = {
							name: productName,
							option: optionName,
							center: fcName,
							stowed: stowed,
							requested: requested,
							ratio: `${stowed}/${requested}`
						};

						// 상태별로 분류
						if (stowed > 0 && stowed < requested) {
							partialInbounds.push(productInfo); // 부분입고
						} else if (stowed === requested && requested > 0) {
							completeInbounds.push(productInfo); // 입고완료
						} else if (stowed === 0 && requested > 0) {
							pendingInbounds.push(productInfo); // 입고전
						}
					}
				}
			});

			if (totalStowed === 0 && totalRequested === 0) return '';

			// tooltip 구성
			let tooltip = `전체 입고 현황 (${date})\n`;
			tooltip += `총 입고 상태: ${totalStowed}/${totalRequested}\n\n`;

			// 부분입고 상품들 (우선 표시)
			if (partialInbounds.length > 0) {
				tooltip += `🟡 부분입고 (${partialInbounds.length}개):\n`;
				partialInbounds.slice(0, 5).forEach(item => { // 최대 5개만 표시
					tooltip += `  • ${item.name}`;
					if (item.option) tooltip += ` (${item.option})`;
					tooltip += ` - ${item.center}: ${item.ratio}\n`;
				});
				if (partialInbounds.length > 5) {
					tooltip += `  ... 외 ${partialInbounds.length - 5}개\n`;
				}
				tooltip += '\n';
			}

			// 입고완료 상품들
			if (completeInbounds.length > 0) {
				tooltip += `🟢 입고완료 (${completeInbounds.length}개)\n`;
				if (completeInbounds.length <= 3) {
					completeInbounds.forEach(item => {
						tooltip += `  • ${item.name}`;
						if (item.option) tooltip += ` (${item.option})`;
						tooltip += ` - ${item.center}: ${item.ratio}\n`;
					});
				} else {
					tooltip += `  • 총 ${completeInbounds.length}개 상품 입고완료\n`;
				}
				tooltip += '\n';
			}

			// 입고전 상품들
			if (pendingInbounds.length > 0) {
				tooltip += `🔴 입고전 (${pendingInbounds.length}개)\n`;
				if (pendingInbounds.length <= 3) {
					pendingInbounds.forEach(item => {
						tooltip += `  • ${item.name}`;
						if (item.option) tooltip += ` (${item.option})`;
						tooltip += ` - ${item.center}: ${item.ratio}\n`;
					});
				} else {
					tooltip += `  • 총 ${pendingInbounds.length}개 상품 입고대기\n`;
				}
			}

			return tooltip.trim();
		},
		// 메모 추가
		addMemo(item) {
			this.currentItem = item;
			this.currentMemo = '';
			this.$bvModal.show('memoModal');
		},
		// 메모 편집
		editMemo(item) {
			this.currentItem = item;
			this.currentMemo = item.메모 || '';
			this.$bvModal.show('memoModal');
		},
		// 메모 삭제
		async deleteMemo(item) {
			if (confirm('메모를 삭제하시겠습니까?')) {
				this.$set(item, '메모', '');
				this.$set(item, 'isModified', true);

				try {
					await this.onInputComplete(item);
					console.log('메모가 삭제되었습니다.');
				} catch (error) {
					console.error('메모 삭제 오류:', error);
					this.$bvToast.toast('메모 삭제에 실패했습니다.', {
						title: '삭제 오류',
						variant: 'danger',
						solid: true
					});
				}
			}
		},
		// 메모 저장
		async saveMemo() {
			if (this.currentItem) {
				// 메모 내용을 trim하고, 빈 문자열이면 null 또는 빈 문자열로 설정
				const trimmedMemo = this.currentMemo.trim();
				this.$set(this.currentItem, '메모', trimmedMemo || '');

				// 수정 플래그 설정
				this.$set(this.currentItem, 'isModified', true);

				// 자동 저장 (빈 문자열도 저장되도록)
				try {
					await this.onInputComplete(this.currentItem);
					console.log('메모가 저장되었습니다:', trimmedMemo || '(빈 메모)');
					console.log('저장된 아이템 메모:', this.currentItem.메모);

					// saleslists 배열에서 해당 아이템을 찾아서 직접 업데이트
					const itemIndex = this.saleslists.findIndex(item =>
						item.vendorItemId === this.currentItem.vendorItemId
					);

					if (itemIndex !== -1) {
						this.$set(this.saleslists, itemIndex, { ...this.currentItem });
						console.log('saleslists 업데이트 완료');
					}

					// Vue의 반응성을 위해 강제 업데이트
					this.$forceUpdate();
				} catch (error) {
					console.error('메모 저장 오류:', error);
					this.$bvToast.toast('메모 저장에 실패했습니다.', {
						title: '저장 오류',
						variant: 'danger',
						solid: true
					});
				}
			}
			this.currentItem = null;
			this.currentMemo = '';
		},
		// 메모 취소
		cancelMemo() {
			this.currentItem = null;
			this.currentMemo = '';
		},
		// 설정 모달 열기
		showSettingsModal(item = null) {
			// 선택 상태 초기화
			this.settingsSelectedItems = [];

			// 필터링 해제 (전체 상품 표시)
			this.settingsFilteredVendorItemId = null;

			// 하이라이트 설정 (shown 이벤트에서 사용)
			if (item && !item.isSummaryRow) {
				this.highlightedVendorItemId = item.vendorItemId;
				console.log('설정관리 모달 - 상품 하이라이트 예약:', item.vendorItemId);
			} else {
				this.highlightedVendorItemId = null;
				console.log('설정관리 모달 - 전체 상품 표시');
			}

			this.$bvModal.show('settingsModal');
		},
		// 설정 관리 모달이 완전히 열린 후 실행
		onSettingsModalShown() {
			console.log('설정 관리 모달 shown 이벤트 발생');
			if (this.highlightedVendorItemId) {
				this.scrollToItemInModal('settingsTable', this.highlightedVendorItemId);
			}
		},
		// 모달 내에서 특정 상품으로 스크롤 및 하이라이트
		scrollToItemInModal(tableRef, vendorItemId) {
			console.log('scrollToItemInModal 시작:', tableRef, vendorItemId);

			// 모달이 완전히 렌더링될 때까지 대기
			this.$nextTick(() => {
				setTimeout(() => {
					const table = this.$refs[tableRef];
					if (!table) {
						console.log('테이블 ref를 찾을 수 없습니다:', tableRef);
						return;
					}

					// 전체 아이템 목록 가져오기
					const items = tableRef === 'inventoryTable'
						? this.filteredInventoryList
						: this.filteredSettingsList;

					// 아이템 인덱스 찾기
					const itemIndex = items.findIndex(item => item.vendorItemId === vendorItemId);
					if (itemIndex === -1) {
						console.log('아이템을 찾을 수 없습니다:', vendorItemId);
						return;
					}

					console.log(`아이템 인덱스: ${itemIndex}, 전체 아이템 수: ${items.length}`);

					// 페이지당 아이템 수 (CDataTable의 items-per-page와 동일)
					const itemsPerPage = 100;

					// 해당 아이템이 있는 페이지 계산
					const targetPage = Math.floor(itemIndex / itemsPerPage) + 1;
					console.log(`목표 페이지: ${targetPage}, 현재 페이지: ${table.currentPage}`);

					// CDataTable의 currentPage 업데이트
					if (table.currentPage !== targetPage) {
						table.currentPage = targetPage;
						console.log('페이지 변경됨:', targetPage);
					}

					// 페이지 변경 및 렌더링 완료 후 스크롤
					this.$nextTick(() => {
						setTimeout(() => {
							// 테이블 wrapper 찾기
							const mainTable = table.$refs.mainTable;
							if (!mainTable || !mainTable.$el) {
								console.log('메인 테이블을 찾을 수 없습니다');
								return;
							}

							const tableWrapper = mainTable.$el.querySelector('.v-data-table__wrapper');
							if (!tableWrapper) {
								console.log('테이블 wrapper를 찾을 수 없습니다');
								return;
							}

							// 현재 페이지 내에서의 인덱스
							const indexInPage = itemIndex % itemsPerPage;

							// 각 행의 높이 (대략적인 값, 실제 높이에 맞게 조정 필요)
							const rowHeight = 60;

							// 스크롤 위치 계산 (중간에 오도록)
							const scrollTop = (indexInPage * rowHeight) - (tableWrapper.clientHeight / 2) + (rowHeight / 2);

							// 스크롤 실행 (부드러운 스크롤)
							tableWrapper.scrollTo({
								top: Math.max(0, scrollTop),
								behavior: 'smooth'
							});
							console.log(`스크롤 위치: ${scrollTop}, indexInPage: ${indexInPage}`);

							// 스크롤 완료 후 하이라이트 애니메이션 시작
							setTimeout(() => {
								console.log('하이라이트 애니메이션 시작');
								this.startHighlightAnimation();
							}, 800); // 스크롤 애니메이션 완료 대기 (smooth scroll 시간)
						}, 500); // 페이지 변경 후 충분한 딜레이
					});
				}, 300); // 모달 렌더링 후 약간의 딜레이
			});
		},
		// 하이라이트 애니메이션 시작
		startHighlightAnimation() {
			console.log('startHighlightAnimation 호출됨, highlightedVendorItemId:', this.highlightedVendorItemId);

			// Vue 리렌더링 강제 트리거
			this.$forceUpdate();

			// 하이라이트는 모달을 닫을 때까지 계속 유지됨
		},
		// 모달이 닫힐 때 하이라이트 제거
		onModalHidden() {
			console.log('모달 닫힘 - 하이라이트 제거');
			this.highlightedVendorItemId = null;
		},
		// 설정 툴팁 생성
		getSettingsTooltip(item) {
			let tooltip = '현재 설정값:\n';
			tooltip += `구매입고기간: ${item.입고기간 || '-'}일\n`;
			tooltip += `배대지입고기간: ${item.배대지입고기간 || '-'}일\n`;
			tooltip += `통관중입고기간: ${item.통관중입고기간 || '-'}일\n`;
			tooltip += `국내입고기간: ${item.국내입고기간 || '-'}일\n`;
			tooltip += `목표재고기간: ${item.최대재고기간 || '-'}일\n`;
			tooltip += `안전재고기간: ${item.최소재고기간 || '-'}일\n`;
			tooltip += `MOQ수량: ${item.MOQ수량 || '-'}개\n`;
			tooltip += `1박스 인입수량: ${item.박스인입수량 || '-'}개`;
			return tooltip;
		},
		// 목표 일판매수량 모달 열기
		openTargetSalesModal(item) {
			this.targetSalesModal.item = item;
			this.targetSalesModal.targetSales = item.목표일판매수량 || 0;
			this.targetSalesModal.show = true;
		},
		// 목표 일판매수량 저장
		async saveTargetSales() {
			if (!this.targetSalesModal.item) return;

			const item = this.targetSalesModal.item;
			const targetSales = parseFloat(this.targetSalesModal.targetSales) || 0;

			try {
				// 로컬 상태 업데이트
				this.$set(item, '목표일판매수량', targetSales);

				// 재계산 트리거
				const metrics = this.calculateInventoryMetrics(item);
				item.남은재고기간 = metrics.남은재고기간;
				item.구매필요수량 = metrics.구매필요수량;
				item.dday = metrics.dday;
				item.배대지출고Dday = metrics.배대지출고Dday;
				item.배대지출고필요수량 = metrics.배대지출고필요수량;
				item.통관중출고Dday = metrics.통관중출고Dday;
				item.통관중출고필요수량 = metrics.통관중출고필요수량;
				item.국내출고Dday = metrics.국내출고Dday;
				item.국내출고필요수량 = metrics.국내출고필요수량;

				// 서버에 저장
				const updateData = {
					vendorItemId: item.vendorItemId,
					targetDailySales: targetSales
				};
				const response = await axios.post('/api/batchUpdateRocketScmData', [updateData]);

				if (response.data.res === 'success') {
					this.$bvToast.toast('목표 일판매수량이 저장되었습니다.', {
						title: '저장 완료',
						variant: 'success',
						solid: true
					});
				} else {
					throw new Error(response.data.alert || '서버 저장 실패');
				}

			} catch (error) {
				console.error('목표 일판매수량 저장 실패:', error);
				this.$bvToast.toast('저장에 실패했습니다: ' + error.message, {
					title: '오류',
					variant: 'danger',
					solid: true
				});
			}

			this.targetSalesModal.show = false;
		},
		// 목표 일판매수량 모달 취소
		cancelTargetSales() {
			this.targetSalesModal.show = false;
			this.targetSalesModal.item = null;
			this.targetSalesModal.targetSales = 0;
		},
		// 구매요청수량 모달 열기
		openPurchaseRequestModal(item) {
			// 기본값 설정
			if (!item.박스인입수량) item.박스인입수량 = 1;
			if (!item.MOQ수량) item.MOQ수량 = 2;

			this.purchaseRequestModal.item = item;
			this.purchaseRequestModal.requestQuantity = item.구매필요수량 || 0;
			this.purchaseRequestModal.show = true;
		},
		// 구매요청수량 저장
		async savePurchaseRequest() {
			if (!this.purchaseRequestModal.item) return;

			const item = this.purchaseRequestModal.item;
			const requestQuantity = parseInt(this.purchaseRequestModal.requestQuantity) || 0;

			if (requestQuantity <= 0) {
				this.$bvToast.toast('구매요청수량을 입력해주세요.', {
					title: '입력 오류',
					variant: 'warning',
					solid: true
				});
				return false; // 모달이 닫히지 않도록 false 반환
			}

			try {
				// 처리 중 상태 시작
				this.purchaseRequestModal.isProcessing = true;

				// 애니메이션 효과 (날아가는 애니메이션)
				this.showPurchaseAnimation();

				// 애니메이션이 완료될 때까지 대기
				await new Promise(resolve => setTimeout(resolve, 1200));

				// 장바구니에 추가 (기존 로직 활용)
				const newItem = {
					...item,
					구매요청수량: requestQuantity
				};

				const existingIndex = this.purchaseCart.findIndex(
					cartItem => cartItem.vendorItemId === newItem.vendorItemId
				);

				if (existingIndex === -1) {
					// 새 상품이면 추가
					this.purchaseCart.push(newItem);
				} else {
					// 이미 있는 상품이면 구매요청수량 업데이트
					this.purchaseCart[existingIndex].구매요청수량 = requestQuantity;
				}

				// 성공 메시지 표시
				this.$bvToast.toast(`구매요청수량 ${requestQuantity}개가 장바구니에 추가되었습니다! 🛒`, {
					title: '구매요청 추가 완료',
					variant: 'success',
					solid: true,
					autoHideDelay: 3000,
					toastClass: 'success-message'
				});

			} catch (error) {
				console.error('구매요청수량 저장 실패:', error);
				this.$bvToast.toast('저장에 실패했습니다.', {
					title: '오류',
					variant: 'danger',
					solid: true
				});
			} finally {
				// 처리 완료 후 상태 초기화 및 모달 닫기
				setTimeout(() => {
					this.purchaseRequestModal.isProcessing = false;
					this.purchaseRequestModal.show = false;
				}, 500);
			}
		},
		// 구매요청수량 모달 취소
		cancelPurchaseRequest() {
			this.purchaseRequestModal.show = false;
			this.purchaseRequestModal.item = null;
			this.purchaseRequestModal.requestQuantity = 0;
			this.purchaseRequestModal.isProcessing = false;
		},
		// 구매 후 예상 전체재고수량 계산
		getPurchasePreviewTotalStock() {
			if (!this.purchaseRequestModal.item || !this.purchaseRequestModal.requestQuantity) return 0;

			const item = this.purchaseRequestModal.item;
			const requestQuantity = parseInt(this.purchaseRequestModal.requestQuantity) || 0;
			const currentTotalStock = this.getTotalAvailableStock(item);

			return currentTotalStock + requestQuantity;
		},
		// 구매 후 예상 전체재고기간 계산
		getPurchasePreviewStockPeriod() {
			if (!this.purchaseRequestModal.item || !this.purchaseRequestModal.requestQuantity) return 0;

			const item = this.purchaseRequestModal.item;
			const totalStockAfterPurchase = this.getPurchasePreviewTotalStock();

			// 목표 일판매수량이 있으면 우선 사용
			const 계산용일판매수량 = (item.목표일판매수량 && item.목표일판매수량 > 0) ? item.목표일판매수량 : item.일판매수량;

			if (계산용일판매수량 <= 0) return 0;

			return Math.floor(totalStockAfterPurchase / 계산용일판매수량);
		},
		// 구매 예상 정보 계산 (입력값 변경 시 호출)
		calculatePurchasePreview() {
			// 실시간 계산을 위한 함수 (현재는 computed로 처리되므로 빈 함수)
		},
		// 현재 전체재고기간 계산
		getCurrentStockPeriod() {
			if (!this.purchaseRequestModal.item) return 0;

			const item = this.purchaseRequestModal.item;
			const currentTotalStock = this.getTotalAvailableStock(item);

			// 목표 일판매수량이 있으면 우선 사용
			const 계산용일판매수량 = (item.목표일판매수량 && item.목표일판매수량 > 0) ? item.목표일판매수량 : item.일판매수량;

			if (계산용일판매수량 <= 0) return 0;

			return Math.floor(currentTotalStock / 계산용일판매수량);
		},
		// 구매요청 추가 애니메이션 효과
		showPurchaseAnimation() {
			// 상품 이미지 복제하여 날아가는 애니메이션 생성
			this.createFlyingProductAnimation();

			// 모달 내용에 애니메이션 클래스 추가
			const modalContent = document.querySelector('.modal-content');
			if (modalContent) {
				modalContent.classList.add('cart-animation');

				// 애니메이션 완료 후 클래스 제거
				setTimeout(() => {
					modalContent.classList.remove('cart-animation');
				}, 600);
			}
		},
		// 상품이 구매요청 버튼으로 날아가는 애니메이션
		createFlyingProductAnimation() {
			const modalImg = document.querySelector('.modal-content img');
			const purchaseBtn = document.getElementById('purchaseRequestBtn');

			if (!modalImg || !purchaseBtn) return;

			// 상품 이미지 복제
			const flyingImg = modalImg.cloneNode(true);
			flyingImg.style.position = 'fixed';
			flyingImg.style.width = '60px';
			flyingImg.style.height = '60px';
			flyingImg.style.zIndex = '9999';
			flyingImg.style.pointerEvents = 'none';
			flyingImg.style.borderRadius = '8px';
			flyingImg.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';

			// 시작 위치 설정 (모달 이미지 위치)
			const modalRect = modalImg.getBoundingClientRect();
			flyingImg.style.left = modalRect.left + 'px';
			flyingImg.style.top = modalRect.top + 'px';

			// DOM에 추가
			document.body.appendChild(flyingImg);

			// 목표 위치 계산 (구매요청 버튼 위치)
			const btnRect = purchaseBtn.getBoundingClientRect();
			const targetX = btnRect.left + btnRect.width / 2 - 30; // 중앙 정렬
			const targetY = btnRect.top + btnRect.height / 2 - 30;

			// 애니메이션 실행
			setTimeout(() => {
				flyingImg.style.transition = 'all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
				flyingImg.style.transform = `translate(${targetX - modalRect.left}px, ${targetY - modalRect.top}px) scale(0.3)`;
				flyingImg.style.opacity = '0';
			}, 100);

			// 애니메이션 완료 후 정리 및 뱃지 애니메이션
			setTimeout(() => {
				document.body.removeChild(flyingImg);
				this.animateBadge();
			}, 1100);
		},
		// 뱃지 펄스 애니메이션
		animateBadge() {
			const badge = document.querySelector('#purchaseRequestBtn .badge');
			if (badge) {
				badge.classList.add('badge-pulse');
				setTimeout(() => {
					badge.classList.remove('badge-pulse');
				}, 600);
			}
		},
		// 구매요청수량이 있는지 확인
		getPurchaseRequestQuantity(item) {
			const cartItem = this.purchaseCart.find(cartItem => cartItem.vendorItemId === item.vendorItemId);
			return cartItem ? cartItem.구매요청수량 : 0;
		},
		// 구매요청수량이 있는 항목인지 확인
		hasPurchaseRequest(item) {
			return this.getPurchaseRequestQuantity(item) > 0;
		},
		// 구매 설정 업데이트 (박스인입수량, MOQ수량)
		async updatePurchaseSettings() {
			if (!this.purchaseRequestModal.item) return;

			const item = this.purchaseRequestModal.item;

			try {
				// 메인 리스트에서 동일한 상품 찾아서 업데이트
				const mainItem = this.saleslists.find(listItem => listItem.vendorItemId === item.vendorItemId);
				if (mainItem) {
					mainItem.박스인입수량 = parseInt(item.박스인입수량) || 1;
					mainItem.MOQ수량 = parseInt(item.MOQ수량) || 2;
				}

				// 서버에 저장 (기존 설정 저장 로직과 동일)
				const updateData = {
					vendorItemId: item.vendorItemId,
					박스인입수량: parseInt(item.박스인입수량) || 1,
					MOQ수량: parseInt(item.MOQ수량) || 2
				};

				// 실제 서버 저장은 추후 구현
				// await axios.post('/api/growth/updatePurchaseSettings', updateData);

				console.log('구매 설정 업데이트:', updateData);

			} catch (error) {
				console.error('구매 설정 업데이트 실패:', error);
			}
		},
		// 아이템 설정 업데이트 (서버 저장)
		async updateItemSettings(item) {
			try {
				// 기존 onInputComplete와 동일한 로직 사용
				this.$set(item, 'isModified', true);
				await this.onInputComplete(item);

				console.log('설정이 자동 저장되었습니다:', item);

				// Vue의 반응성을 위해 강제 업데이트
				this.$forceUpdate();
			} catch (error) {
				console.error('설정 저장 오류:', error);
				// 오류 토스트 표시
				this.$bvToast.toast('설정 저장에 실패했습니다.', {
					title: '저장 오류',
					variant: 'danger',
					solid: true
				});
			}
		},

		// 재고 일괄변경 적용
		async applyBulkInventory() {
			const inventory = this.재고일괄변경;
			let updatedCount = 0;

			// 선택된 아이템이 없으면 전체 적용, 있으면 선택된 아이템만 적용
			const targetItems = this.inventorySelectedItems.length > 0 ? this.inventorySelectedItems : this.saleslists;

			// confirm창으로 확인
			const confirmMessage = this.inventorySelectedItems.length > 0
				? `선택한 ${this.inventorySelectedItems.length}개 상품에 재고 변경을 적용하시겠습니까?`
				: `전체 ${this.saleslists.length}개 상품에 재고 변경을 적용하시겠습니까?`;

			if (!confirm(confirmMessage)) {
				return;
			}

			// 변경할 항목들을 수집하고 테이블 데이터 직접 변경
			const itemsToUpdate = [];

			targetItems.forEach(item => {
				let updated = false;

				if (inventory.구매 !== null && inventory.구매 !== '') {
					item.구매 = inventory.구매;
					updated = true;
				}
				if (inventory.배대지 !== null && inventory.배대지 !== '') {
					item.배대지 = inventory.배대지;
					updated = true;
				}
				if (inventory.통관중 !== null && inventory.통관중 !== '') {
					item.통관중 = inventory.통관중;
					updated = true;
				}
				if (inventory.국내재고 !== null && inventory.국내재고 !== '') {
					item.국내재고 = inventory.국내재고;
					updated = true;
				}

				if (updated) {
					updatedCount++;
					itemsToUpdate.push(item);
				}
			});

			// 변경된 항목들을 일괄 저장 (한 번의 API 호출)
			if (updatedCount > 0) {
				const scmUpdates = itemsToUpdate.map(item => ({
					vendorItemId: item.vendorItemId,
					purchase: parseInt(item.구매) || 0,
					overseas: parseInt(item.배대지) || 0,
					customs: parseInt(item.통관중) || 0,
					domesticStock: parseInt(item.국내재고) || 0
				}));
				try {
					const response = await axios.post('/api/batchUpdateRocketScmData', scmUpdates);
					if (response.data.res === 'success') {
						const message = this.inventorySelectedItems.length > 0
							? `선택한 ${updatedCount}개 상품의 재고가 일괄 변경되었습니다.`
							: `전체 ${updatedCount}개 상품의 재고가 일괄 변경되었습니다.`;
						this.$bvToast.toast(message, { title: '일괄변경 완료', variant: 'success', solid: true });
					} else {
						this.$bvToast.toast(response.data.alert || '저장 실패', { title: '오류', variant: 'danger', solid: true });
					}
				} catch (error) {
					console.error('재고 일괄 저장 오류:', error);
					this.$bvToast.toast('재고 저장 중 오류가 발생했습니다.', { title: '오류', variant: 'danger', solid: true });
				}
			}

			// 입력값만 초기화 (선택 상태는 유지)
			this.재고일괄변경 = {
				구매: null,
				배대지: null,
				통관중: null,
				국내재고: null
			};
			// this.inventorySelectedItems = []; // 선택 상태 유지
		},
		// 설정 일괄변경 적용
		async applyBulkSettings() {
			const settings = this.설정일괄변경;
			let updatedCount = 0;

			// 선택된 아이템이 없으면 전체 적용, 있으면 선택된 아이템만 적용
			const targetItems = this.settingsSelectedItems.length > 0 ? this.settingsSelectedItems : this.saleslists;

			// confirm창으로 확인
			const confirmMessage = this.settingsSelectedItems.length > 0
				? `선택한 ${this.settingsSelectedItems.length}개 상품에 설정 변경을 적용하시겠습니까?`
				: `전체 ${this.saleslists.length}개 상품에 설정 변경을 적용하시겠습니까?`;

			if (!confirm(confirmMessage)) {
				return;
			}

			// 변경할 항목들을 수집하고 테이블 데이터 직접 변경
			const itemsToUpdate = [];

			targetItems.forEach(item => {
				let updated = false;

				if (settings.입고기간 !== null && settings.입고기간 !== '') {
					item.입고기간 = settings.입고기간;
					updated = true;
				}
				if (settings.배대지입고기간 !== null && settings.배대지입고기간 !== '') {
					item.배대지입고기간 = settings.배대지입고기간;
					updated = true;
				}
				if (settings.통관중입고기간 !== null && settings.통관중입고기간 !== '') {
					item.통관중입고기간 = settings.통관중입고기간;
					updated = true;
				}
				if (settings.국내입고기간 !== null && settings.국내입고기간 !== '') {
					item.국내입고기간 = settings.국내입고기간;
					updated = true;
				}
				if (settings.최소재고기간 !== null && settings.최소재고기간 !== '') {
					item.최소재고기간 = settings.최소재고기간;
					updated = true;
				}
				if (settings.최대재고기간 !== null && settings.최대재고기간 !== '') {
					item.최대재고기간 = settings.최대재고기간;
					updated = true;
				}
				if (settings.MOQ수량 !== null && settings.MOQ수량 !== '') {
					item.MOQ수량 = settings.MOQ수량;
					updated = true;
				}

				if (updated) {
					updatedCount++;
					itemsToUpdate.push(item);
				}
			});

			// 변경된 항목들을 일괄 저장 (한 번의 API 호출)
			if (updatedCount > 0) {
				const scmUpdates = itemsToUpdate.map(item => ({
					vendorItemId: item.vendorItemId,
					inboundPeriod: parseInt(item.입고기간) || 0,
					overseasInputDays: parseInt(item.배대지입고기간) || this.baseSettings.overseasInputDays,
					customsInputDays: parseInt(item.통관중입고기간) || this.baseSettings.customsInputDays,
					domesticInputDays: parseInt(item.국내입고기간) || this.baseSettings.domesticInputDays,
					targetStockDays: parseInt(item.최대재고기간) || 0,
					safetyStockDays: parseInt(item.최소재고기간) || 0,
					moqQuantity: parseInt(item.MOQ수량) || 0
				}));
				try {
					const response = await axios.post('/api/batchUpdateRocketScmData', scmUpdates);
					if (response.data.res === 'success') {
						const message = this.settingsSelectedItems.length > 0
							? `선택한 ${updatedCount}개 상품의 설정이 일괄 변경되었습니다.`
							: `전체 ${updatedCount}개 상품의 설정이 일괄 변경되었습니다.`;
						this.$bvToast.toast(message, { title: '일괄변경 완료', variant: 'success', solid: true });
					} else {
						this.$bvToast.toast(response.data.alert || '저장 실패', { title: '오류', variant: 'danger', solid: true });
					}
				} catch (error) {
					console.error('설정 일괄 저장 오류:', error);
					this.$bvToast.toast('설정 저장 중 오류가 발생했습니다.', { title: '오류', variant: 'danger', solid: true });
				}
			}

			// 입력값만 초기화 (선택 상태는 유지)
			this.설정일괄변경 = {
				입고기간: null,
				배대지입고기간: null,
				통관중입고기간: null,
				국내입고기간: null,
				최소재고기간: null,
				최대재고기간: null,
				MOQ수량: null
			};
			// this.settingsSelectedItems = []; // 선택 상태 유지
		},
		// 아이템들 중에 메모가 있는지 확인
		hasMemoInItems() {
			return this.saleslists && this.saleslists.some(item =>
				item.메모 && item.메모.trim()
			);
		},
		// 메모가 있는 아이템 개수 반환
		getMemoCount() {
			if (!this.saleslists) return 0;
			return this.saleslists.filter(item =>
				item.메모 && item.메모.trim()
			).length;
		},
		// 종합 메모 tooltip 생성
		getSummaryMemoTooltip() {
			if (!this.saleslists) return '';

			const itemsWithMemo = this.saleslists.filter(item =>
				item.메모 && item.메모.trim()
			);

			if (itemsWithMemo.length === 0) return '';

			let tooltip = `메모가 있는 상품 (${itemsWithMemo.length}개):\n\n`;

			itemsWithMemo.slice(0, 5).forEach(item => { // 최대 5개만 표시
				const productName = item.판매상품명 || item.productName || '상품명 없음';
				const optionName = item.옵션명 || item.optionName || '';

				tooltip += `• ${productName}`;
				if (optionName) tooltip += ` (${optionName})`;
				tooltip += `\n  메모: ${item.메모}\n\n`;
			});

			if (itemsWithMemo.length > 5) {
				tooltip += `... 외 ${itemsWithMemo.length - 5}개 상품에 메모 있음`;
			}

			return tooltip.trim();
		},

		// 쿠팡재고기간 위험 상태 툴팁 반환
		getCoupangStockDangerTooltip(item) {
			if (!item.쿠팡재고기간) return '';

			const stockDays = parseInt(item.쿠팡재고기간) || 0;
			const safetyDays = parseInt(item.최소재고기간) || 0;
			const dailySales = parseFloat(item.일평균판매량) || 0;

			let tooltip = `현재 쿠팡재고기간: ${stockDays}일\n`;
			tooltip += `최소재고기간: ${safetyDays}일\n`;

			if (dailySales > 0) {
				tooltip += `일평균 판매량: ${dailySales.toFixed(2)}개\n`;

				if (stockDays > 0) {
					const daysToStockOut = Math.ceil(stockDays);
					const stockOutDate = new Date();
					stockOutDate.setDate(stockOutDate.getDate() + daysToStockOut);

					tooltip += `예상 품절일: ${stockOutDate.getMonth() + 1}/${stockOutDate.getDate()} (${daysToStockOut}일 후)\n`;
				}
			}

			// 60일 초과 경고
			if (stockDays > 60) {
				tooltip += `\n⚠️ 주의: 재고기간이 60일을 초과합니다!`;
				tooltip += `\n💰 과재고로 인한 보관료 증가 위험`;
			}
			// 안전재고기간 이하 경고
			else if (item.최소재고기간 && stockDays <= safetyDays) {
				tooltip += `\n⚠️ 위험: 안전재고기간 이하입니다!`;
				if (stockDays <= 3) {
					tooltip += `\n🚨 긴급: 3일 이내 품절 위험!`;
				}
			}

			return tooltip.trim();
		},
		// 반품상품 위험 상태 클래스 반환
		getReturnProductDangerClass(returnProduct, item) {
			if (!returnProduct.orderableQuantity || !item.일평균판매량 || !item.안전재고기간) return '';

			const stockDays = Math.floor((returnProduct.orderableQuantity || 0) / item.일평균판매량);
			const safetyDays = parseInt(item.안전재고기간) || 0;

			if (stockDays <= safetyDays) {
				return 'bg-danger text-white font-weight-bold stock-danger';
			}

			return '';
		},
		// 반품상품 위험 상태 툴팁 반환
		getReturnProductDangerTooltip(returnProduct, item) {
			if (!returnProduct.orderableQuantity || !item.일평균판매량 || !item.안전재고기간) return '';

			const stockDays = Math.floor((returnProduct.orderableQuantity || 0) / item.일평균판매량);
			const safetyDays = parseInt(item.안전재고기간) || 0;
			const dailySales = parseFloat(item.일평균판매량) || 0;

			let tooltip = `반품상품 재고기간: ${stockDays}일\n`;
			tooltip += `안전재고기간: ${safetyDays}일\n`;

			if (dailySales > 0) {
				tooltip += `일평균 판매량: ${dailySales.toFixed(2)}개\n`;

				if (stockDays > 0) {
					const daysToStockOut = Math.ceil(stockDays);
					const stockOutDate = new Date();
					stockOutDate.setDate(stockOutDate.getDate() + daysToStockOut);

					tooltip += `예상 품절일: ${stockOutDate.getMonth() + 1}/${stockOutDate.getDate()} (${daysToStockOut}일 후)\n`;
				}
			}

			if (stockDays <= safetyDays) {
				tooltip += `\n⚠️ 위험: 안전재고기간 이하입니다!`;
				if (stockDays <= 3) {
					tooltip += `\n🚨 긴급: 3일 이내 품절 위험!`;
				}
			}

			return tooltip.trim();
		},
		// 입고중 상태 모달 열기 (기존 함수 유지)
		showInboundStatus(item) {
			if (!item.inventoryDetails?.inProgressInboundStatistics?.inProgressInbounds) {
				this.$bvToast.toast('입고중 데이터가 없습니다.', {
					title: '알림',
					variant: 'warning',
					solid: true
				});
				return;
			}

			this.selectedInboundData = {
				vendorItemId: item.vendorItemId,
				productName: item.판매상품명,
				optionName: item.옵션명,
				thumbnail: item.썸네일,
				재고: item.재고,
				구매: item.구매,
				배대지: item.배대지,
				장기입고중: item.장기입고중,
				국내재고: item.국내재고,
				단기입고중: item.단기입고중,
				inbounds: item.inventoryDetails.inProgressInboundStatistics.inProgressInbounds
			};

			this.$bvModal.show('inboundStatusModal');
		},
		// 모달 내에서 재고 업데이트
		async updateInventoryInModal(item, field, value) {
			try {
				const newValue = parseInt(value) || 0;
				let oldValue;

				// 기존 값 확인
				if (field === '구매') oldValue = item.구매 || 0;
				else if (field === '배대지') oldValue = item.배대지 || 0;
				else if (field === '국내재고') oldValue = item.국내재고 || 0;

				// 값이 실제로 변경된 경우에만 업데이트
				if (oldValue !== newValue) {
					// 값 업데이트
					if (field === '구매') item.구매 = newValue;
					else if (field === '배대지') item.배대지 = newValue;
					else if (field === '국내재고') item.국내재고 = newValue;

					// 수정 플래그 설정
					item.isModified = true;

					// 자동 저장
					await this.onInputComplete(item);

					console.log(`${field} 값이 ${oldValue}에서 ${newValue}로 변경되어 서버에 저장되었습니다.`);
				} else {
					console.log(`${field} 값이 변경되지 않아 서버 업데이트를 생략합니다.`);
				}
			} catch (error) {
				console.error('재고 업데이트 오류:', error);
			}
		},
		// 입고 상세 보기
		showInboundDetail(item) {
			// 기존 입고중 상태 모달 로직 사용
			this.showInboundStatus(item);
		},
		// 재고 메모 업데이트
		async updateInventoryMemo(item) {
			try {
				item.isModified = true;
				await this.onInputComplete(item);
			} catch (error) {
				console.error('메모 업데이트 오류:', error);
			}
		},
		// 기본 정렬 적용
		applyDefaultSort() {
			if (!this.saleslists || this.saleslists.length === 0) return;

			// productId별 월판매수량 합계 계산 (기본 정렬용)
			const productSales = {};
			this.saleslists.forEach(item => {
				const productId = item.productId;
				if (!productSales[productId]) productSales[productId] = 0;
				productSales[productId] += item.월판매수량 || 0;
			});

			// 저장된 순서가 있으면 우선 적용, 없으면 기본 정렬
			this.saleslists.sort((a, b) => {
				const aProd = parseInt(a.productOrder);
				const bProd = parseInt(b.productOrder);
				const aOpt = parseInt(a.optionOrder);
				const bOpt = parseInt(b.optionOrder);
				const aHasOrder = Number.isFinite(aProd) || Number.isFinite(aOpt);
				const bHasOrder = Number.isFinite(bProd) || Number.isFinite(bOpt);

				// 하나라도 순서가 설정된 경우, 순서가 있는 항목을 앞에 배치
				if (aHasOrder || bHasOrder) {
					if (aHasOrder && !bHasOrder) return -1;
					if (!aHasOrder && bHasOrder) return 1;
					// 둘 다 순서가 있으면 productOrder -> optionOrder 기준 오름차순
					const aProductOrder = Number.isFinite(aProd) ? aProd : 999999;
					const bProductOrder = Number.isFinite(bProd) ? bProd : 999999;
					if (aProductOrder !== bProductOrder) return aProductOrder - bProductOrder;
					const aOptionOrder = Number.isFinite(aOpt) ? aOpt : 999999;
					const bOptionOrder = Number.isFinite(bOpt) ? bOpt : 999999;
					if (aOptionOrder !== bOptionOrder) return aOptionOrder - bOptionOrder;
					// 순서가 동일하면 기본 정렬 보조 기준
					const aItemSales2 = a.월판매수량 || 0;
					const bItemSales2 = b.월판매수량 || 0;
					return bItemSales2 - aItemSales2;
				}

				// 기본 정렬: productId별 월판매수량 합계 내림차순 -> 개별 월판매수량 내림차순
				const aSales = productSales[a.productId] || 0;
				const bSales = productSales[b.productId] || 0;
				if (aSales !== bSales) return bSales - aSales;
				const aItemSales = a.월판매수량 || 0;
				const bItemSales = b.월판매수량 || 0;
				return bItemSales - aItemSales;
			});
		},
		// 노출ID 순서 업데이트 (같은 productId 모두 적용)
		async updateProductOrder(item) {
			try {
				const productId = item.productId;
				const orderValue = item.productOrder;

				// 같은 productId를 가진 모든 항목에 순서 적용
				this.saleslists.forEach(listItem => {
					if (listItem.productId === productId) {
						listItem.productOrder = orderValue;
						listItem.isModified = true;
					}
				});

				// 모든 수정된 항목 저장
				const modifiedItems = this.saleslists.filter(listItem =>
					listItem.productId === productId && listItem.isModified
				);

				for (const modifiedItem of modifiedItems) {
					await this.onInputComplete(modifiedItem);
				}
			} catch (error) {
				console.error('노출ID 순서 업데이트 오류:', error);
			}
		},
		// 옵션ID 순서 업데이트
		async updateOrder(item) {
			try {
				// 🆕 RocketSales에 순서 정보 저장
				const response = await axios.post('/api/updateOnlyRocketSalesV2', [item]);

				if (response.data.res === 'success') {
					console.log('순서가 저장되었습니다:', item.vendorItemId);
				} else {
					console.error('순서 저장 실패:', response.data.alert);
				}
			} catch (error) {
				console.error('순서 업데이트 오류:', error);
			}
		},
		// 커스텀 정렬 적용
		async applyCustomSort() {
			if (!this.saleslists || this.saleslists.length === 0) return;

			// 1. 기존 정렬 로직 유지
			this.saleslists.sort((a, b) => {
				// 1. 노출ID 순서 우선 (빈값은 뒤로)
				const aProductOrder = parseInt(a.productOrder) || 999999;
				const bProductOrder = parseInt(b.productOrder) || 999999;

				if (aProductOrder !== bProductOrder) {
					return aProductOrder - bProductOrder;
				}

				// 2. 같은 노출ID 순서 내에서 옵션ID 순서 (빈값은 뒤로)
				const aOptionOrder = parseInt(a.optionOrder) || 999999;
				const bOptionOrder = parseInt(b.optionOrder) || 999999;

				if (aOptionOrder !== bOptionOrder) {
					return aOptionOrder - bOptionOrder;
				}

				// 3. 순서가 모두 같으면 기본 정렬 (월판매수량 기준)
				const aSales = a.월판매수량 || 0;
				const bSales = b.월판매수량 || 0;

				return bSales - aSales;
			});

			// 🆕 2. 순서가 설정된 아이템들을 RocketSales에 저장
			const itemsWithOrder = this.saleslists.filter(item =>
				(item.productOrder && item.productOrder !== '') ||
				(item.optionOrder && item.optionOrder !== '')
			);

			if (itemsWithOrder.length > 0) {
				try {
					// RocketSales 컬렉션에 저장 (순서 정보 포함)
					const response = await axios.post('/api/updateOnlyRocketSalesV2', itemsWithOrder);

					if (response.data.res === 'success') {
						console.log(`${itemsWithOrder.length}개 아이템의 순서가 저장되었습니다.`);
						this.showOrderModal = false;
						this.$bvToast.toast('순서가 적용되고 저장되었습니다.', {
							title: '알림',
							variant: 'success',
							solid: true
						});
					} else {
						alert('순서 저장에 실패했습니다: ' + response.data.alert);
					}
				} catch (error) {
					console.error('순서 저장 오류:', error);
					alert('순서 저장 중 오류가 발생했습니다.');
				}
			} else {
				// 순서 설정이 없어도 정렬은 적용
				this.showOrderModal = false;
				this.$bvToast.toast('순서가 적용되었습니다.', {
					title: '알림',
					variant: 'success',
					solid: true
				});
			}
		},
		// 재고 업데이트 (기존 함수)
		async updateInventory(field, value) {
			try {
				const item = this.saleslists.find(item => item.vendorItemId === this.selectedInboundData.vendorItemId);
				if (item) {
					// 기본 테이블의 값도 업데이트
					if (field === '구매') item.구매 = parseInt(value) || 0;
					else if (field === '배대지') item.배대지 = parseInt(value) || 0;
					else if (field === '국내재고') item.국내재고 = parseInt(value) || 0;

					// 수정 플래그 설정
					item.isModified = true;

					// 자동 저장
					await this.onInputComplete(item);
				}
			} catch (error) {
				console.error('재고 업데이트 오류:', error);
			}
		},
		// 상태 텍스트 변환
		getStatusText(status) {
			const statusMap = {
				'INIT_COMPLETED': '입고 대기',
				'STOWING': '입고 중',
				'COMPLETED': '입고 완료',
				'CANCELLED': '취소됨'
			};
			return statusMap[status] || status;
		},
		// 상태별 CSS 클래스
		getStatusClass(status) {
			const classMap = {
				'INIT_COMPLETED': 'badge badge-warning',
				'STOWING': 'badge badge-info',
				'COMPLETED': 'badge badge-success',
				'CANCELLED': 'badge badge-danger'
			};
			return classMap[status] || 'badge badge-secondary';
		},

		// 숫자 포맷팅
		formatNumber(number) {
			return new Intl.NumberFormat('ko-KR').format(number);
		},

		// 통화 포맷팅
		formatCurrency(amount) {
			return new Intl.NumberFormat('ko-KR', {
				style: 'currency',
				currency: 'KRW'
			}).format(amount);
		},

		// 입고 경과일 계산
		calculateDaysAgo(inboundDate) {
			const today = new Date();
			const date = new Date(inboundDate);
			return Math.floor((today - date) / (1000 * 60 * 60 * 24));
		},

		// 보관료 계산
		calculateStorageFee(inboundDate, quantity, storageFeeRates) {
			const daysStored = this.calculateDaysAgo(inboundDate);
			const rates = storageFeeRates.feeRatesAfterPromotion;

			const applicableRate = rates.find(rate =>
				daysStored >= rate.startDay && daysStored <= rate.endDay
			);

			return applicableRate ? (applicableRate.feeRate * quantity) : 0;
		},

		// 입고 리스트 정렬
		sortedInboundList(inboundInfo) {
			if (!inboundInfo?.cfsStowedDetailList) return [];
			return [...inboundInfo.cfsStowedDetailList].sort((a, b) =>
				new Date(a.inboundDate) - new Date(b.inboundDate)
			);
		},

		// 총 수량 계산
		getTotalQuantity(inboundInfo) {
			return inboundInfo?.cfsStowedDetailList?.reduce((sum, detail) =>
				sum + detail.remainingSkuQty, 0
			) || 0;
		},

		// 총 보관료 계산
		getTotalStorageFee(inboundInfo) {
			if (!inboundInfo?.cfsStowedDetailList) return 0;
			return inboundInfo.cfsStowedDetailList.reduce((sum, detail) =>
				sum + this.calculateStorageFee(
					detail.inboundDate,
					detail.remainingSkuQty,
					inboundInfo.storageFeeRates
				), 0
			);
		},
		// 메인 제품의 월판매수량 계산 (번들 제품 제외)
		getMainProductMonthlySales(item) {
			if (!item.upBundlingProducts || item.upBundlingProducts.length === 0) {
				return item.월판매수량;
			}

			// 번들 제품들의 실제 판매수량 합계 계산 (번들 사이즈 적용)
			const bundleSales = item.upBundlingProducts.reduce((sum, bundle) => {
				const bundleActualSales = this.getBundleProductMonthlySales(bundle);
				return sum + bundleActualSales;
			}, 0);

			// 전체 월판매수량에서 번들 실제 판매수량을 뺀 메인 제품 판매수량
			return Math.max(0, item.월판매수량 - bundleSales);
		},
		// 메인 제품의 일판매수량 계산 (번들 제품 제외)
		getMainProductDailySales(item) {
			if (!item.upBundlingProducts || item.upBundlingProducts.length === 0) {
				return item.일판매수량;
			}

			// 번들 제품들의 실제 일판매수량 합계 계산 (번들 사이즈 적용)
			const bundleDailySales = item.upBundlingProducts.reduce((sum, bundle) => {
				const bundleActualSales = this.getBundleProductMonthlySales(bundle);
				return sum + (bundleActualSales / 30);
			}, 0);

			// 전체 일판매수량에서 번들 실제 판매수량을 뺀 메인 제품 판매수량
			return Math.max(0, item.일판매수량 - bundleDailySales);
		},
		// 반품상품의 월판매수량 계산 (salesHistory 배열 합계)
		getReturnProductMonthlySales(returnProduct) {
			if (!returnProduct || !returnProduct.salesHistory || !Array.isArray(returnProduct.salesHistory)) {
				return 0;
			}
			// salesHistory 배열의 모든 값을 합계하여 월판매수량 계산
			return returnProduct.salesHistory.reduce((sum, sales) => sum + (sales || 0), 0);
		},
		// 번들상품의 월판매수량 계산 (salesHistory 우선, 없으면 unitsSoldForLast30Days 사용)
		getBundleProductMonthlySales(bundleProduct) {
			if (!bundleProduct) {
				return 0;
			}

			// salesHistory 배열이 있으면 우선 사용
			if (bundleProduct.salesHistory && Array.isArray(bundleProduct.salesHistory)) {
				return bundleProduct.salesHistory.reduce((sum, sales) => sum + (sales || 0), 0);
			}

			// salesHistory가 없으면 unitsSoldForLast30Days 사용
			return bundleProduct.unitsSoldForLast30Days || 0;
		},
		// 메인 제품의 7일판매수량 계산 (번들 제품 제외)
		getMainProduct7DaySales(item) {
			if (!item.upBundlingProducts || item.upBundlingProducts.length === 0) {
				return item['7일판매수량'];
			}

			// 번들 제품들의 실제 7일판매수량 합계 계산
			const bundle7DaySales = item.upBundlingProducts.reduce((sum, bundle) => {
				const bundleActual7DaySales = this.getBundleProduct7DaySales(bundle);
				return sum + bundleActual7DaySales;
			}, 0);

			// 전체 7일판매수량에서 번들 실제 판매수량을 뺀 메인 제품 판매수량
			return Math.max(0, item['7일판매수량'] - bundle7DaySales);
		},
		// 반품상품의 7일판매수량 계산 (salesHistory 배열의 최근 7일 합계)
		getReturnProduct7DaySales(returnProduct) {
			if (!returnProduct || !returnProduct.salesHistory || !Array.isArray(returnProduct.salesHistory)) {
				return 0;
			}
			// salesHistory 배열의 최근 7일 값을 합계하여 7일판매수량 계산
			const recent7Days = returnProduct.salesHistory.slice(-7);
			return recent7Days.reduce((sum, sales) => sum + (sales || 0), 0);
		},
		// 번들상품의 7일판매수량 계산 (salesHistory 우선, 없으면 unitsSoldForLast30Days/30*7 사용)
		getBundleProduct7DaySales(bundleProduct) {
			if (!bundleProduct) {
				return 0;
			}

			// salesHistory 배열이 있으면 우선 사용 (최근 7일)
			if (bundleProduct.salesHistory && Array.isArray(bundleProduct.salesHistory)) {
				const recent7Days = bundleProduct.salesHistory.slice(-7);
				return recent7Days.reduce((sum, sales) => sum + (sales || 0), 0);
			}

			// salesHistory가 없으면 unitsSoldForLast30Days를 기준으로 7일치 추정
			const monthlySales = bundleProduct.unitsSoldForLast30Days || 0;
			return Math.round(monthlySales * 7 / 30);
		},
			getRecent7DaysHeaders() {
				const headers = [];
				const today = new Date();
				const baseDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
				for (let offset = 6; offset >= 0; offset--) {
					const d = new Date(baseDate);
					d.setDate(baseDate.getDate() - offset);
					const month = String(d.getMonth() + 1).padStart(2, '0');
					const day = String(d.getDate()).padStart(2, '0');
					const label = `${month}/${day}`;
					const value = `recentDay${offset}`;
					headers.push({
						text: label,
						value,
						align: 'center',
						width: 60,
						isSlot: true
					});
				}
				return headers;
			},
			getMainProductDailySalesAtOffset(item, daysAgo) {
				if (!item || !item.salesHistory || !Array.isArray(item.salesHistory) || item.salesHistory.length === 0) {
					return 0;
				}
				const index = item.salesHistory.length - 1 - daysAgo;
				if (index < 0) {
					return 0;
				}
				const total = item.salesHistory[index] || 0;

				if (!this.showBundleProducts || !item.upBundlingProducts || item.upBundlingProducts.length === 0) {
					return total;
				}

				const bundleDailySales = item.upBundlingProducts.reduce((sum, bundle) => {
					return sum + this.getBundleProductDailySales(bundle, daysAgo);
				}, 0);

				return Math.max(0, total - bundleDailySales);
			},
			getReturnProductDailySales(returnProduct, daysAgo) {
				if (!returnProduct || !returnProduct.salesHistory || !Array.isArray(returnProduct.salesHistory) || returnProduct.salesHistory.length === 0) {
					return 0;
				}
				const index = returnProduct.salesHistory.length - 1 - daysAgo;
				if (index < 0) {
					return 0;
				}
				return returnProduct.salesHistory[index] || 0;
			},
			getBundleProductDailySales(bundleProduct, daysAgo) {
				if (!bundleProduct) {
					return 0;
				}

				if (bundleProduct.salesHistory && Array.isArray(bundleProduct.salesHistory) && bundleProduct.salesHistory.length > 0) {
					const index = bundleProduct.salesHistory.length - 1 - daysAgo;
					if (index < 0) {
						return 0;
					}
					return bundleProduct.salesHistory[index] || 0;
				}

				const monthlySales = bundleProduct.unitsSoldForLast30Days || 0;
				return Math.round(monthlySales / 30);
			},

			// 메인 제품의 3일판매수량 계산 (번들 제품 고려)
			getMainProduct3DaySales(item) {
				if (!item || !item.salesHistory || !Array.isArray(item.salesHistory)) {
					return 0;
				}

				// salesHistory 배열의 최근 3일 합계
				const recent3Days = item.salesHistory.slice(-3);
				const total3Days = recent3Days.reduce((sum, sales) => sum + (sales || 0), 0);

				// 번들 보기 OFF이거나 번들 상품이 없으면 전체 3일 판매수량 반환
				if (!this.showBundleProducts || !item.upBundlingProducts || item.upBundlingProducts.length === 0) {
					return total3Days;
				}

				// 번들 상품들의 3일판매수량 합계
				const bundle3DaySales = item.upBundlingProducts.reduce((sum, bundle) => {
					return sum + this.getBundleProduct3DaySales(bundle);
				}, 0);

				return Math.max(0, total3Days - bundle3DaySales);
			},
			// 반품상품의 3일판매수량 계산 (salesHistory 배열의 최근 3일 합계)
			getReturnProduct3DaySales(returnProduct) {
				if (!returnProduct || !returnProduct.salesHistory || !Array.isArray(returnProduct.salesHistory)) {
					return 0;
				}
				const recent3Days = returnProduct.salesHistory.slice(-3);
				return recent3Days.reduce((sum, sales) => sum + (sales || 0), 0);
			},
			// 번들상품의 3일판매수량 계산 (salesHistory 우선, 없으면 unitsSoldForLast30Days/30*3 사용)
			getBundleProduct3DaySales(bundleProduct) {
				if (!bundleProduct) {
					return 0;
				}

				if (bundleProduct.salesHistory && Array.isArray(bundleProduct.salesHistory)) {
					const recent3Days = bundleProduct.salesHistory.slice(-3);
					return recent3Days.reduce((sum, sales) => sum + (sales || 0), 0);
				}

				const monthlySales = bundleProduct.unitsSoldForLast30Days || 0;
				return Math.round(monthlySales * 3 / 30);
			},
			// 메인 제품의 어제 판매수량 계산 (번들 제품 고려)
			getMainProductYesterdaySales(item) {
				if (!item || !item.salesHistory || !Array.isArray(item.salesHistory) || item.salesHistory.length === 0) {
					return 0;
				}

				const totalYesterday = item.salesHistory[item.salesHistory.length - 1] || 0;

				if (!this.showBundleProducts || !item.upBundlingProducts || item.upBundlingProducts.length === 0) {
					return totalYesterday;
				}

				const bundleYesterdaySales = item.upBundlingProducts.reduce((sum, bundle) => {
					return sum + this.getBundleProductYesterdaySales(bundle);
				}, 0);

				return Math.max(0, totalYesterday - bundleYesterdaySales);
			},
			// 반품상품의 어제 판매수량 계산
			getReturnProductYesterdaySales(returnProduct) {
				if (!returnProduct || !returnProduct.salesHistory || !Array.isArray(returnProduct.salesHistory) || returnProduct.salesHistory.length === 0) {
					return 0;
				}
				return returnProduct.salesHistory[returnProduct.salesHistory.length - 1] || 0;
			},
			// 번들상품의 어제 판매수량 계산
			getBundleProductYesterdaySales(bundleProduct) {
				if (!bundleProduct) {
					return 0;
				}

				if (bundleProduct.salesHistory && Array.isArray(bundleProduct.salesHistory)) {
					if (!bundleProduct.salesHistory.length) {
						return 0;
					}
					return bundleProduct.salesHistory[bundleProduct.salesHistory.length - 1] || 0;
				}

				const monthlySales = bundleProduct.unitsSoldForLast30Days || 0;
				return Math.round(monthlySales / 30);
			},

		// 판매변화율 계산 (번들 상품 고려)
		getSalesChangeRate(item) {
			if (!item.upBundlingProducts || item.upBundlingProducts.length === 0) {
				return item.판매변화;
			}

			// 메인 제품의 7일 및 30일 평균 계산
			const main7DaySales = this.getMainProduct7DaySales(item);
			const main30DaySales = this.getMainProductMonthlySales(item);
			const main7DayAvg = main7DaySales / 7;
			const main30DayAvg = main30DaySales / 30;

			if (main30DayAvg > 0) {
				return ((main7DayAvg - main30DayAvg) / main30DayAvg) * 100;
			}
			return 0;
		},
		// 판매변화 스타일 계산 (색상과 화살표)
		getSalesChangeStyle(changeRate) {
			if (changeRate > 0) {
				return {
					color: '#28a745', // 초록색
					icon: '↗'
				};
			} else if (changeRate < 0) {
				return {
					color: '#dc3545', // 빨간색
					icon: '↘'
				};
			} else {
				return {
					color: '#6c757d', // 회색
					icon: '→'
				};
			}
		},
		// 반품상품의 판매변화율 계산
		getReturnProductChangeRate(returnProduct) {
			if (!returnProduct || !returnProduct.salesHistory || !Array.isArray(returnProduct.salesHistory)) {
				return 0;
			}

			const recent7Days = returnProduct.salesHistory.slice(-7);
			const avg7Days = recent7Days.reduce((sum, sales) => sum + (sales || 0), 0) / 7;
			const avg30Days = returnProduct.salesHistory.reduce((sum, sales) => sum + (sales || 0), 0) / 30;

			if (avg30Days > 0) {
				return ((avg7Days - avg30Days) / avg30Days) * 100;
			}
			return 0;
		},
		// 번들상품의 판매변화율 계산
		getBundleProductChangeRate(bundleProduct) {
			if (!bundleProduct) {
				return 0;
			}

			// salesHistory 배열이 있으면 사용
			if (bundleProduct.salesHistory && Array.isArray(bundleProduct.salesHistory)) {
				const recent7Days = bundleProduct.salesHistory.slice(-7);
				const avg7Days = recent7Days.reduce((sum, sales) => sum + (sales || 0), 0) / 7;
				const avg30Days = bundleProduct.salesHistory.reduce((sum, sales) => sum + (sales || 0), 0) / 30;

				if (avg30Days > 0) {
					return ((avg7Days - avg30Days) / avg30Days) * 100;
				}
			}

			// salesHistory가 없으면 변화율 계산 불가
			return 0;
		}
	}
}
</script>

<style scoped>
/* 구매요청 추가 애니메이션 */
@keyframes addToCart {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	50% {
		transform: scale(1.2);
		opacity: 0.8;
	}
	100% {
		transform: scale(1);
		opacity: 1;
	}
}

@keyframes fadeInSuccess {
	0% {
		opacity: 0;
		transform: translateY(-10px);
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
}

.cart-animation {
	animation: addToCart 0.6s ease-in-out;
}

.success-message {
	animation: fadeInSuccess 0.5s ease-out;
}

/* 구매요청 버튼 호버 효과 */
.btn-primary:hover {
	transform: translateY(-1px);
	box-shadow: 0 4px 8px rgba(0,123,255,0.3);
	transition: all 0.2s ease;
}

/* 구매요청이 있는 항목 스타일 */
.purchase-requested {
	background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;
	border: 2px solid #2196f3 !important;
	box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3) !important;
	position: relative;
}

.purchase-requested::before {
	content: "🛒";
	position: absolute;
	top: -5px;
	right: -5px;
	font-size: 12px;
	background: #2196f3;
	color: white;
	border-radius: 50%;
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.purchase-requested:hover {
	transform: translateY(-1px);
	box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4) !important;
	transition: all 0.2s ease;
}

/* 장바구니 담기 애니메이션 */
@keyframes flyToCart {
	0% {
		transform: scale(1) translate(0, 0);
		opacity: 1;
	}
	50% {
		transform: scale(0.8) translate(50px, -20px);
		opacity: 0.8;
	}
	100% {
		transform: scale(0.3) translate(200px, -100px);
		opacity: 0;
	}
}

.fly-to-cart {
	animation: flyToCart 1s ease-out forwards;
	z-index: 9999;
	pointer-events: none;
}

/* 뱃지 펄스 애니메이션 */
@keyframes badgePulse {
	0% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.3);
	}
	100% {
		transform: scale(1);
	}
}

.badge-pulse {
	animation: badgePulse 0.6s ease-in-out;
}

/* 구매요청 버튼 뱃지 스타일 */
#purchaseRequestBtn .badge {
	min-width: 18px;
	height: 18px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

/* 하이라이트 행 애니메이션 (무한 반복) - success 색상 */
@keyframes pulse-success {
	0% {
		box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
	}
	70% {
		box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
	}
	100% {
		box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
	}
}

::v-deep .highlighted-row {
	animation: pulse-success 2s infinite !important;
	background-color: rgba(40, 167, 69, 0.15) !important;
}

::v-deep .highlighted-row td {
	background-color: inherit !important;
}

::v-deep .highlighted-row:hover {
	background-color: rgba(40, 167, 69, 0.25) !important;
}

/* v-data-table 행에 직접 적용 */
::v-deep tbody tr.highlighted-row {
	animation: pulse-success 2s infinite !important;
	background-color: rgba(40, 167, 69, 0.15) !important;
}


</style>